import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.models');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const wiz: any;

@Component({
    selector: 'wiz-page-models',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.models/view.scss */
:host {
  display: block;
}`],
})
export class PageModelsComponent implements OnInit, OnDestroy {
    private readonly registryCacheKey: string = 'fallai:model-registry:v2';
    private readonly registryCacheMaxAgeMs: number = 10 * 60 * 1000;
    private registryLoadPromise: Promise<void> | null = null;
    public registry: any = this.initialRuntimeRegistry();
    public loading: boolean = false;
    public uploadFiles: File[] = [];
    public uploadFamily: string = 'rf-fall-v2';
    public uploadLabel: string = '';
    public uploadDescription: string = '';
    public uploadDataset: string = '';
    public uploadNote: string = '';
    public registrationModelName: string = '';
    public registrationVersion: string = 'v1.0';
    public registrationFramework: string = 'Ultralytics YOLO';
    public registrationBackbone: string = 'YOLO11n';
    public registrationDeveloper: string = '';
    public registrationDescription: string = '';
    public registrationSource: string = 'official_pretrained';
    public officialImportBusy: boolean = false;
    public poseRegistrationFamily: string = 'yolo-pose';
    public showAdvancedPoseModels: boolean = false;
    public showAdvancedRegistration: boolean = false;
    public faceAnalysisMode: string = 'expression';
    public registrationVariantId: string = 'rf-fall-v2';
    public lastRegisteredModelId: string = '';
    public compatibilityModelId: string = '';
    public modelLibraryCategory: 'registered' | 'tested' = 'registered';
    public deployingModelId: string = '';
    public rollingBackFamily: string = '';
    public poseVariantId: string = 'yolo26s-pose';
    public poseDatasetManifest: string = '';
    public poseDatasetId: string = '';
    public poseDatasetName: string = '';
    public poseDatasetSourceType: string = 'user';
    public poseDatasetInputMode: string = 'zip';
    public poseDatasetZipFile: File | null = null;
    public poseDatasetFormOpen: boolean = false;
    public poseDatasetRegisterBusy: boolean = false;
    public poseTrainingEpochs: number = 100;
    public poseTrainingImageSize: number = 640;
    public poseTrainingBatch: number = 16;
    public poseTrainingLearningRate: number = 0.001;
    public poseTrainingOptimizer: string = 'AdamW';
    public poseTrainingDevice: string = 'auto';
    public poseTrainingWorkers: number = 2;
    public poseTrainingBusy: boolean = false;
    public poseTrainingMessage: string = '';
    public poseTrainingMessageType: string = 'info';
    public uploading: boolean = false;
    public uploadDone: number = 0;
    public uploadProgressPercent: number = 0;
    public uploadBytesSent: number = 0;
    public uploadBytesTotal: number = 0;
    public uploadSpeedMbps: number = 0;
    public uploadPhase: 'idle' | 'uploading' | 'checking' = 'idle';
    public uploadMessage: string = '';
    public uploadMessageType: string = 'info';
    public familyFilter: string = 'all';
    public compareMetric: string = 'f1';
    public comparisonCategory: string = 'fall';
    public deletingId: string = '';
    public leftComparisonModelId: string = '';
    public rightComparisonModelId: string = '';
    public selectedModelId: string = '';
    public selectedComparisonIds: string[] = [];
    public savingFamily: string = '';
    public cleanupBusy: boolean = false;
    public bundleLabel: string = '';
    public bundleSaving: boolean = false;
    public applyingBundleId: string = '';
    public deletingBundleId: string = '';
    public cancelingDeleteId: string = '';
    public showDeleteOnly: boolean = false;
    public sensitivityLevel: number = 50;
    public sensitivitySaving: boolean = false;
    public modelManagerMode: string = 'overview';
    public modelStudioTab: string = 'training';
    public poseBenchmarkModelId: string = '';
    public poseBenchmarkManifest: string = '';
    public poseEvaluationBusy: boolean = false;
    public poseRollbackBusy: boolean = false;
    public wizardOpen: boolean = false;
    public registrationStep: number = 1;
    public selectedAiKind: string = 'fall';
    public lastRegisteredLabel: string = '';
    public applyConfirmOpen: boolean = false;
    public applyBusy: boolean = false;
    public selectedArchiveItem: any = null;
    public expandedArchiveItemId: string = '';
    public applyingArchiveId: string = '';
    public validatingFilterId: string = '';
    public archiveKindFilter: string = 'model';
    public promotionReviewBucket: string = 'B1';
    public promotionReviewCandidateId: string = '';
    public promotionReviewStatusFilter: string = 'pending';
    public promotionReviewSelectedIds: string[] = [];
    public promotionReviewRejectReason: string = '';
    public promotionReviewReviewer: string = '';
    public promotionReviewBusy: boolean = false;
    public promotionReviewAutoNext: boolean = true;
    public promotionReviewMessage: string = '';
    public promotionReviewMessageType: string = 'info';
    public promotionReviewAnnotationSaving: boolean = false;
    public facialContinuousStatus: any = null;
    public facialContinuousLoading: boolean = false;
    public facialContinuousError: string = '';
    private filterValidationPollTimer: any = null;
    private filterValidationPollBusy: boolean = false;
    private poseTrainingPollTimer: any = null;
    private poseTrainingPollBusy: boolean = false;
    private facialContinuousPollTimer: any = null;
    private facialContinuousPollBusy: boolean = false;
    private readonly facialContinuousCacheKey: string = 'fallai:facial-continuous-status:v1';
    private uploadStartedAt: number = 0;
    private uploadLastRenderAt: number = 0;
    private readonly pipelineFamilyOrder: string[] = ['pose-backbone', 'rf-pipeline', 'rf-fall-v2', 'xg-posture', 'environment-agent', 'xg-posture-occlusion-aux', 'static-object-filter', 'pose-entity-filter', 'facial-aihub82', 'driver-aihub173'];
    private readonly overviewModelDisplayMap: { [key: string]: any } = {
        'rf-pipeline': { title: '낙상 판단 모듈 (RF-Pipeline)', codeBase: 'RF-Pipeline' },
        'rf-fall-v2': { title: '낙상 판단 모듈 (RF-Fall v2)', fixedCode: 'RF-Fall v2' },
        'xg-posture': { title: '자세 설명 모델', codeBase: 'XG-Posture', fallbackVersion: 'v1' },
        'pose-backbone': { title: '관절점 추출 모델', fixedCode: 'Pose Backbone' },
        'environment-agent': { title: '환경 위험 분석 모델', fixedCode: 'Environment Agent MVP v1' },
        'xg-posture-occlusion-aux': { title: '가림 보정 모델', fixedCode: 'XG-Posture 가림 보조' },
        'static-object-filter': { title: '정지 사물 필터 v1', fixedCode: 'Static Object Filter v1' },
        'pose-entity-filter': { title: '사람/사물 판정 필터 v1', fixedCode: 'Person/Object Decision Filter v1' },
        'facial-aihub82': { title: '표정 보조 모델', codeBase: 'AI-Hub 82', fallbackVersion: 'v240' },
        'driver-aihub173': { title: '상태 보조 모델', codeBase: 'AI-Hub 173', fallbackVersion: 'v60' },
    };

    private readonly rfPipelineFeatures: any[] = [
        { code: 'detection_rate', label: '사람 검출률', description: '샘플링한 프레임 중 대표 인물이 검출된 비율' },
        { code: 'center_y_mean', label: '평균 중심 Y 위치', description: '사람 위치 상자 중심의 평균 세로 좌표' },
        { code: 'center_y_std', label: '중심 Y 변동', description: '사람 위치 상자 중심의 세로 위치 표준편차' },
        { code: 'height_mean', label: '평균 상자 높이', description: '사람 위치 상자 높이의 평균값' },
        { code: 'height_std', label: '상자 높이 변동', description: '사람 위치 상자 높이의 표준편차' },
        { code: 'aspect_ratio_mean', label: '평균 가로세로비', description: '사람 위치 상자 너비÷높이의 평균값' },
        { code: 'aspect_ratio_std', label: '가로세로비 변동', description: '사람 위치 상자 가로세로비의 표준편차' },
        { code: 'delta_y_mean', label: '평균 하강 변화량', description: '연속 검출 프레임 사이 아래 방향 이동량의 평균' },
        { code: 'delta_y_max', label: '최대 하강 변화량', description: '한 검출 프레임 간격에서 관측된 최대 하강량' },
        { code: 'delta_height_mean', label: '평균 높이 변화량', description: '연속 검출 프레임 사이 상자 높이 변화량의 평균' },
        { code: 'delta_width_mean', label: '평균 너비 변화량', description: '연속 검출 프레임 사이 상자 너비 변화량의 평균' },
        { code: 'delta_y_accel_max', label: '최대 하강 속도 증가량', description: '연속 하강 변화량의 증가분 최댓값이며 물리 단위 가속도는 아닙니다.' },
        { code: 'final_height_ratio', label: '마지막 높이 비율', description: '마지막 3개 검출 프레임 평균 높이를 전체 평균 높이로 나눈 값' },
    ];

    private readonly rfFallV2FeatureGroups: any[] = [
        {
            "title": "검출 품질·커버리지",
            "description": "사람이 영상에서 얼마나 안정적으로, 빠짐없이 검출됐는지 나타냅니다.",
            "features": [
                {
                    "code": "detection_rate",
                    "label": "사람 검출률",
                    "description": "샘플링한 전체 프레임 중 대표 인물이 검출된 비율"
                },
                {
                    "code": "sample_coverage",
                    "label": "6fps 기준 시계열 커버리지",
                    "description": "검출 샘플 수를 영상 길이×6으로 나눈 값이며, 운영 추출 fps가 더 높으면 1을 넘을 수 있습니다."
                },
                {
                    "code": "bbox_conf_mean",
                    "label": "평균 사람 검출 신뢰도",
                    "description": "사람 위치 상자 검출 신뢰도의 평균값"
                },
                {
                    "code": "bbox_conf_min",
                    "label": "최저 사람 검출 신뢰도",
                    "description": "사람 위치 상자 검출 신뢰도의 최저값"
                }
            ]
        },
        {
            "title": "몸 중심 위치·하강 흐름",
            "description": "화면에서 몸 중심이 아래로 얼마나, 얼마나 빠르게 이동했는지 요약합니다.",
            "features": [
                {
                    "code": "center_y_mean",
                    "label": "평균 중심 Y 위치",
                    "description": "전체 구간의 평균 세로 중심 위치로, 값이 클수록 화면 아래쪽입니다."
                },
                {
                    "code": "center_y_std",
                    "label": "중심 위치 변동",
                    "description": "구간 동안 세로 중심 위치가 얼마나 흔들렸는지 나타냅니다."
                },
                {
                    "code": "center_y_range",
                    "label": "중심 이동 범위",
                    "description": "가장 위쪽 중심과 가장 아래쪽 중심의 차이"
                },
                {
                    "code": "center_y_start",
                    "label": "초기 중심 위치",
                    "description": "시작부 최대 5개 검출 프레임의 평균 중심 위치"
                },
                {
                    "code": "center_y_end",
                    "label": "마지막 중심 위치",
                    "description": "종료부 최대 5개 검출 프레임의 평균 중심 위치"
                },
                {
                    "code": "center_y_drop",
                    "label": "중심 하강량",
                    "description": "마지막 중심 위치에서 초기 중심 위치를 뺀 실제 하강량"
                },
                {
                    "code": "center_y_drop_ratio",
                    "label": "키 대비 중심 하강비",
                    "description": "중심 하강량을 평균 사람 상자 높이로 나눈 비율"
                },
                {
                    "code": "center_y_slope",
                    "label": "중심 이동 추세",
                    "description": "시간에 따른 중심 Y 위치의 기울기"
                },
                {
                    "code": "max_down_speed_norm",
                    "label": "최대 하강 속도",
                    "description": "정규화된 좌표에서 측정한 초당 최대 하강 속도"
                },
                {
                    "code": "down_motion_ratio",
                    "label": "하강 구간 비율",
                    "description": "이전 샘플보다 중심이 0.5%p 이상 내려간 구간의 비율"
                }
            ]
        },
        {
            "title": "사람 상자 높이",
            "description": "사람 위치 상자의 세로 길이가 낙상 전후로 어떻게 변했는지 봅니다.",
            "features": [
                {
                    "code": "height_mean",
                    "label": "평균 상자 높이",
                    "description": "전체 구간 사람 위치 상자 높이의 평균"
                },
                {
                    "code": "height_std",
                    "label": "상자 높이 변동",
                    "description": "사람 위치 상자 높이의 표준편차"
                },
                {
                    "code": "height_start",
                    "label": "초기 상자 높이",
                    "description": "시작부 최대 5개 검출 프레임의 평균 높이"
                },
                {
                    "code": "height_end",
                    "label": "마지막 상자 높이",
                    "description": "종료부 최대 5개 검출 프레임의 평균 높이"
                },
                {
                    "code": "height_drop_ratio",
                    "label": "상자 높이 감소율",
                    "description": "초기 높이 대비 마지막 높이의 감소 비율"
                },
                {
                    "code": "height_min_ratio",
                    "label": "최소 높이 비율",
                    "description": "구간의 최소 높이를 전체 평균 높이로 나눈 값"
                },
                {
                    "code": "height_range_ratio",
                    "label": "높이 변화 범위비",
                    "description": "최대·최소 높이 차이를 평균 높이로 나눈 값"
                }
            ]
        },
        {
            "title": "사람 상자 너비·면적",
            "description": "사람 상자가 넓어지거나 작아지는 형태 변화를 측정합니다.",
            "features": [
                {
                    "code": "width_mean",
                    "label": "평균 상자 너비",
                    "description": "전체 구간 사람 위치 상자 너비의 평균"
                },
                {
                    "code": "width_std",
                    "label": "상자 너비 변동",
                    "description": "사람 위치 상자 너비의 표준편차"
                },
                {
                    "code": "area_mean",
                    "label": "평균 상자 면적",
                    "description": "정규화된 사람 위치 상자 면적의 평균"
                },
                {
                    "code": "area_std",
                    "label": "상자 면적 변동",
                    "description": "사람 위치 상자 면적의 표준편차"
                },
                {
                    "code": "area_start",
                    "label": "초기 상자 면적",
                    "description": "시작부 최대 5개 검출 프레임의 평균 면적"
                },
                {
                    "code": "area_end",
                    "label": "마지막 상자 면적",
                    "description": "종료부 최대 5개 검출 프레임의 평균 면적"
                },
                {
                    "code": "area_drop_ratio",
                    "label": "상자 면적 감소율",
                    "description": "초기 면적 대비 마지막 면적의 감소 비율"
                },
                {
                    "code": "area_range_ratio",
                    "label": "면적 변화 범위비",
                    "description": "최대·최소 면적 차이를 평균 면적으로 나눈 값"
                }
            ]
        },
        {
            "title": "세로·가로 형상 전환",
            "description": "서 있는 세로형 상자가 눕는 가로형 상자로 바뀌는 흐름을 측정합니다.",
            "features": [
                {
                    "code": "aspect_ratio_mean",
                    "label": "평균 가로세로비",
                    "description": "사람 상자 너비를 높이로 나눈 값의 평균"
                },
                {
                    "code": "aspect_ratio_std",
                    "label": "가로세로비 변동",
                    "description": "가로세로비가 구간 동안 얼마나 달라졌는지 나타냅니다."
                },
                {
                    "code": "aspect_start",
                    "label": "초기 가로세로비",
                    "description": "시작부 최대 5개 검출 프레임의 평균 가로세로비"
                },
                {
                    "code": "aspect_end",
                    "label": "마지막 가로세로비",
                    "description": "종료부 최대 5개 검출 프레임의 평균 가로세로비"
                },
                {
                    "code": "aspect_rise",
                    "label": "가로세로비 증가량",
                    "description": "마지막 가로세로비에서 초기값을 뺀 값"
                },
                {
                    "code": "aspect_max",
                    "label": "최대 가로세로비",
                    "description": "구간에서 관측된 가장 큰 너비÷높이 값"
                }
            ]
        },
        {
            "title": "샘플 간 변화·낙상 후 정지",
            "description": "연속 샘플 사이의 급격한 변화와 하강 뒤 움직임이 멈췄는지 확인합니다.",
            "features": [
                {
                    "code": "delta_y_mean",
                    "label": "평균 하강 변화량",
                    "description": "연속 샘플 사이에서 아래쪽으로 이동한 양의 평균"
                },
                {
                    "code": "delta_y_max",
                    "label": "최대 하강 변화량",
                    "description": "한 샘플 간격에서 관측된 가장 큰 중심 하강량"
                },
                {
                    "code": "delta_height_mean",
                    "label": "평균 높이 변화량",
                    "description": "연속 샘플 사이 상자 높이 절대 변화량의 평균"
                },
                {
                    "code": "delta_width_mean",
                    "label": "평균 너비 변화량",
                    "description": "연속 샘플 사이 상자 너비 절대 변화량의 평균"
                },
                {
                    "code": "delta_area_mean",
                    "label": "평균 면적 변화량",
                    "description": "연속 샘플 사이 상자 면적 절대 변화량의 평균"
                },
                {
                    "code": "delta_y_accel_max",
                    "label": "최대 하강 속도 증가량",
                    "description": "연속 하강 속도의 양의 증가분 최댓값이며 물리 단위의 가속도는 아닙니다."
                },
                {
                    "code": "final_height_ratio",
                    "label": "마지막 높이 비율",
                    "description": "종료부 평균 상자 높이를 전체 평균 높이로 나눈 값"
                },
                {
                    "code": "post_peak_stillness",
                    "label": "최하단 이후 세로 안정도",
                    "description": "몸 중심이 가장 아래에 도달한 뒤 Y 위치 변화가 적을수록 커지며, 남은 샘플이 짧으면 높게 나올 수 있습니다."
                },
                {
                    "code": "tail_stillness",
                    "label": "종료부 정지성",
                    "description": "마지막 최대 5개 검출 프레임에서 중심 변화가 적을수록 커지는 값"
                }
            ]
        },
        {
            "title": "화면 하단·바닥 근접",
            "description": "깊이 센서의 실제 바닥 좌표가 아니라, 사람 상자 하단이 화면 아래쪽에 가까운지를 대리 지표로 사용합니다.",
            "features": [
                {
                    "code": "floor_proximity",
                    "label": "평균 화면 하단 근접도",
                    "description": "사람 상자 하단의 평균 세로 위치"
                },
                {
                    "code": "floor_contact_ratio",
                    "label": "화면 하단 근접 프레임 비율",
                    "description": "상자 하단 Y가 화면 높이의 82% 이상인 프레임 비율"
                },
                {
                    "code": "low_height_floor_score",
                    "label": "낮은 높이·하단 복합점수",
                    "description": "상자 높이가 작고 화면 하단에 가까운 정도를 합친 0~1 점수"
                }
            ]
        },
        {
            "title": "관절점 신뢰도·가림",
            "description": "17개 관절점이 얼마나 잘 보이며, 특히 하체가 가려졌는지 측정합니다.",
            "features": [
                {
                    "code": "avg_keypoint_conf",
                    "label": "평균 관절점 신뢰도",
                    "description": "17개 관절점 검출 신뢰도의 전체 평균"
                },
                {
                    "code": "visible_keypoint_ratio",
                    "label": "보이는 관절점 비율",
                    "description": "신뢰도 0.25 이상인 관절점의 비율"
                },
                {
                    "code": "lower_body_visibility",
                    "label": "하체 가시성",
                    "description": "엉덩이·무릎·발목 6개 관절점이 보이는 비율"
                },
                {
                    "code": "upper_body_visibility",
                    "label": "상체 가시성",
                    "description": "코·어깨·팔꿈치·손목 7개 관절점이 보이는 비율"
                },
                {
                    "code": "visibility_gap",
                    "label": "상·하체 가시성 차이",
                    "description": "상체 가시성에서 하체 가시성을 뺀 값으로, 양수면 하체가 더 가려진 상태입니다."
                },
                {
                    "code": "occlusion_ratio",
                    "label": "관절 미가시·저신뢰 비율",
                    "description": "1에서 신뢰도 0.25 이상인 관절점 비율을 뺀 값"
                }
            ]
        },
        {
            "title": "골격 기울기·자세 형상",
            "description": "어깨·엉덩이와 보이는 관절점 범위로 직립, 수평, 눕기 형태를 요약합니다.",
            "features": [
                {
                    "code": "torso_tilt_mean",
                    "label": "평균 몸통 기울기",
                    "description": "수직선 기준 어깨–엉덩이 몸통 축 각도의 평균"
                },
                {
                    "code": "torso_tilt_max",
                    "label": "최대 몸통 기울기",
                    "description": "구간에서 관측된 가장 큰 몸통 기울기"
                },
                {
                    "code": "torso_tilt_change",
                    "label": "몸통 기울기 변화폭",
                    "description": "최대 몸통 기울기와 최소값의 차이"
                },
                {
                    "code": "pose_height_mean",
                    "label": "평균 골격 높이",
                    "description": "보이는 관절점의 위·아래 범위 평균"
                },
                {
                    "code": "pose_height_min",
                    "label": "최소 골격 높이",
                    "description": "구간에서 관측된 가장 작은 관절점 세로 범위"
                },
                {
                    "code": "pose_width_mean",
                    "label": "평균 골격 너비",
                    "description": "보이는 관절점의 좌·우 범위 평균"
                },
                {
                    "code": "horizontal_pose_score",
                    "label": "골격 가로세로 펼침비",
                    "description": "보이는 관절점의 가로 범위를 세로 범위로 나눈 값의 평균"
                },
                {
                    "code": "lying_skeleton_score",
                    "label": "눕기 골격 비율",
                    "description": "골격이 가로로 넓거나 몸통 기울기가 45도 이상인 프레임 비율"
                },
                {
                    "code": "standing_skeleton_score",
                    "label": "서기 골격 비율",
                    "description": "골격 높이가 충분하고 몸통 기울기가 25도 이하인 프레임 비율"
                },
                {
                    "code": "pose_height_drop",
                    "label": "골격 높이 감소량",
                    "description": "초기 골격 높이에서 마지막 골격 높이를 뺀 값"
                }
            ]
        },
        {
            "title": "수동 설계 복합점수",
            "description": "여러 원시 특성을 결합한 보조 입력값이며, 이 점수 하나가 최종 낙상 판정을 뜻하지는 않습니다.",
            "features": [
                {
                    "code": "fall_kinematic_score",
                    "label": "낙상 운동학 점수",
                    "description": "중심 하강·높이와 면적 감소·가로세로비 증가·최대 하강 속도를 가중 합산한 0~1 점수"
                },
                {
                    "code": "occlusion_fall_risk",
                    "label": "가림 상황 낙상 위험점수",
                    "description": "가림 45%·낮은 높이와 화면 하단 근접 35%·운동학 점수 20%를 합친 0~1 점수"
                }
            ]
        }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init(this);
        try {
            this.promotionReviewReviewer = String(localStorage.getItem('fallai-promotion-reviewer') || '').trim();
            const requestedCategory = String(localStorage.getItem('fallai-model-library-category') || '');
            if (requestedCategory === 'tested') {
                this.modelLibraryCategory = 'tested';
                localStorage.removeItem('fallai-model-library-category');
            }
        } catch (_e) { }
        this.restoreRegistryCache();
        this.restoreFacialContinuousStatusCache();
        await this.service.render();
        await this.loadRegistrySnapshot();
        void this.loadRegistry(true);
        void this.loadFacialContinuousStatus();
        this.startFacialContinuousPolling();
    }

    public ngOnDestroy() {
        this.stopFilterValidationPolling();
        this.stopPoseTrainingPolling();
        this.stopFacialContinuousPolling();
    }

    private restoreFacialContinuousStatusCache() {
        try {
            const cached = JSON.parse(String(sessionStorage.getItem(this.facialContinuousCacheKey) || 'null'));
            if (cached?.status && Number(cached?.saved_at || 0) > 0) {
                this.facialContinuousStatus = cached.status;
            }
        } catch (_e) { }
    }

    private saveFacialContinuousStatusCache() {
        try {
            sessionStorage.setItem(this.facialContinuousCacheKey, JSON.stringify({
                saved_at: Date.now(),
                status: this.facialContinuousStatus,
            }));
        } catch (_e) { }
    }

    private startFacialContinuousPolling() {
        this.stopFacialContinuousPolling();
        this.facialContinuousPollTimer = setInterval(() => {
            void this.loadFacialContinuousStatus();
        }, 30000);
    }

    private stopFacialContinuousPolling() {
        if (this.facialContinuousPollTimer) clearInterval(this.facialContinuousPollTimer);
        this.facialContinuousPollTimer = null;
    }

    public async loadFacialContinuousStatus(showLoading: boolean = false) {
        if (this.facialContinuousPollBusy) return;
        this.facialContinuousPollBusy = true;
        this.facialContinuousLoading = showLoading;
        this.facialContinuousError = '';
        try {
            const response = await fetch('/wiz/api/page.models/facial_continuous_training_status');
            const json = await this.readJsonResponse(response);
            const data = this.responsePayload(json);
            if (!response.ok || data?.ok === false) {
                throw new Error(String(data?.message || '표정 모델 연속 학습 상태를 불러오지 못했습니다.'));
            }
            this.facialContinuousStatus = data;
            this.saveFacialContinuousStatusCache();
        } catch (error: any) {
            this.facialContinuousError = String(error?.message || error || '표정 모델 상태 확인 실패');
        } finally {
            this.facialContinuousPollBusy = false;
            this.facialContinuousLoading = false;
            await this.service.render();
        }
    }

    public facialContinuousStageText() {
        const stage = String(this.facialContinuousStatus?.stage || this.facialContinuousStatus?.status || '').toLowerCase();
        if (stage === 'running' || stage === 'queued') return '최신 후보 생성·검증 중';
        if (stage === 'completed') return '최근 후보 검증 완료';
        if (stage === 'paused' || stage === 'stopped') return '연속 후보 생성 중지';
        if (stage === 'blocked' || stage === 'failed' || stage === 'stale') return '확인 필요';
        return this.facialContinuousLoading ? '상태 확인 중' : '대기';
    }

    public facialContinuousStageClass() {
        const stage = String(this.facialContinuousStatus?.stage || this.facialContinuousStatus?.status || '').toLowerCase();
        if (stage === 'running' || stage === 'queued') return 'border-sky-200 bg-sky-50 text-sky-700';
        if (stage === 'completed') return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (stage === 'paused' || stage === 'stopped') return 'border-amber-200 bg-amber-50 text-amber-700';
        if (stage === 'blocked' || stage === 'failed' || stage === 'stale') return 'border-rose-200 bg-rose-50 text-rose-700';
        return 'border-zinc-200 bg-zinc-50 text-zinc-600';
    }

    public facialContinuousActiveVersionText() {
        return String(this.facialContinuousStatus?.active_version_text || '운영 버전 확인 중');
    }

    public facialContinuousCandidateVersionText() {
        return String(this.facialContinuousStatus?.candidate_version_text || '새 후보 준비 중');
    }

    public facialContinuousMetricText(value: any) {
        const number = Number(value);
        return Number.isFinite(number) && number > 0 ? `${(number * 100).toFixed(1)}%` : '평가 중';
    }

    public facialContinuousProgressPercent() {
        const value = Number(this.facialContinuousStatus?.progress || 0);
        if (!Number.isFinite(value) || value <= 0) return 0;
        return Math.max(0, Math.min(100, Math.round(value <= 1 ? value * 100 : value)));
    }

    public facialContinuousUpdatedText() {
        const raw = String(this.facialContinuousStatus?.updated_at || '').trim();
        if (!raw) return '확인 중';
        const date = new Date(raw);
        return Number.isNaN(date.getTime()) ? raw : date.toLocaleString('ko-KR');
    }

    public isAdminUser() {
        return this.service.auth?.check?.role('admin') === true;
    }

    private async readJsonResponse(res: Response): Promise<any> {
        const text = await res.text();
        const trimmed = String(text || '').trim();
        if (!trimmed) throw new Error(`서버 응답이 비어 있습니다. HTTP ${res.status || 'unknown'}`);
        if (/^<!doctype\s+html/i.test(trimmed) || /^<html[\s>]/i.test(trimmed)) {
            throw new Error(`서버가 JSON 대신 HTML 오류 페이지를 반환했습니다. HTTP ${res.status || 'unknown'}`);
        }
        return JSON.parse(trimmed);
    }

    private responsePayload(json: any): any {
        return json?.data && typeof json.data === 'object' ? json.data : (json || {});
    }

    private initialRuntimeRegistry(): any {
        const active = (model_id: string, family: string, family_label: string, label: string, version: string, metrics: any = {}) => ({
            model_id, family, family_label, label, display_name: label,
            display_version: version, version_badge: version,
            source: 'active', active: true, missing: false, metrics,
        });
        const items = [
            active('active:rf-dual', 'rf-dual', 'RF-Dual 통합', 'RF-Dual 통합 v2 · 현재 운영 조합', 'v2', { f1: 0.9302, recall: 0.954, sample_count: 1592 }),
            active('active:pose-backbone', 'pose-backbone', 'Pose 추출 모델', 'YOLOv8n-Pose 기본값', 'baseline'),
            active('active:rf-fall-v2', 'rf-fall-v2', 'RF-Fall', 'RF-Fall v2', 'v2', { f1: 0.9302, recall: 0.954, sample_count: 1592, feature_count: 65 }),
            active('active:xg-posture', 'xg-posture', 'XG-Posture', 'XG-Posture', 'v1', { f1: 0.9431, accuracy: 0.9432, sample_count: 8181 }),
            active('active:xg-posture-occlusion-aux', 'xg-posture-occlusion-aux', '가림 보조', 'XG-Posture 가림 보조', 'v20260617030130', { f1: 0.9596, accuracy: 0.9531, sample_count: 6119 }),
            active('active:facial-aihub82', 'facial-aihub82', 'AI-Hub 82 표정', 'AI-Hub 82 표정', 'v240', { f1: 0.9167, accuracy: 0.9167, sample_count: 14000 }),
            active('active:driver-aihub173', 'driver-aihub173', 'AI-Hub 173 상태', 'AI-Hub 173 상태', 'v60', { f1: 0.9333, accuracy: 0.9322, sample_count: 41854 }),
            {
                ...active('active:pose-entity-filter', 'pose-entity-filter', '사람/사물 판정 필터 v1', '사람/사물 판정 필터 v1', 'v1', { recall: 1, sample_count: 411 }),
                validation_gate: { person_tracks: 540, critical_false_exclusions: 0, equipment_ghost_tracks: 30, equipment_ghost_classified_object: 30 },
            },
            {
                model_id: 'candidate:static-object-filter:20260709-v1-static-object-filter', family: 'static-object-filter',
                family_label: '정지 사물 필터 v1', label: '정지 사물 필터 v1', display_version: 'v1', version_badge: 'v1',
                source: 'candidate', active: false, missing: false, metrics: { recall: 1, sample_count: 411 },
                validation_gate: { actual_replay_samples: 411, critical_false_exclusions: 0 },
            },
            {
                model_id: 'spec:environment-agent-mvp-v1', family: 'environment-agent', family_label: '환경 Agent (Context)',
                label: '환경 Agent (Context)', display_version: 'v1', version_badge: 'v1', source: 'spec', active: false,
                runtime_status: { pipeline_integration_ready: true, object_recognition_ready: true, risk_vector_emission_ready: true },
                summary: { object_recognition: { runtime_model: 'yolo11n.pt + YOLOE-26s Seg + SAM2.1 Tiny' } }, metrics: {},
            },
        ];
        return {
            items,
            families: [],
            runtime_selection: { 'static-object-filter': 'candidate:static-object-filter:20260709-v1-static-object-filter' },
            runtime_composition: [],
            fall_sensitivity: { level: 50, label: '균형', threshold_delta: 0 },
            comparison: [],
            pose_studio: { catalog: [], jobs: [], evaluation_jobs: [], datasets: [] },
            bootstrap: true,
        };
    }

    private restoreRegistryCache() {
        try {
            const cached = JSON.parse(String(sessionStorage.getItem(this.registryCacheKey) || 'null'));
            const savedAt = Number(cached?.saved_at || 0);
            if (!cached?.registry || !savedAt || Date.now() - savedAt > this.registryCacheMaxAgeMs) return;
            this.registry = cached.registry;
            this.loading = false;
            this.syncFallSensitivity();
            this.syncComparisonSelection();
        } catch (_e) {
            // Corrupt or unavailable browser storage must not block the live request.
        }
    }

    private saveRegistryCache() {
        if (!this.registry) return;
        try {
            sessionStorage.setItem(this.registryCacheKey, JSON.stringify({
                saved_at: Date.now(),
                registry: this.registry,
            }));
        } catch (_e) {
            // Storage limits are non-fatal; the live registry remains authoritative.
        }
    }

    private async loadRegistrySnapshot() {
        try {
            const response = await fetch('/wiz/api/page.models/model_registry_snapshot');
            const json = await this.readJsonResponse(response);
            const code = Number(json?.code || response.status || 0);
            const data = json?.data && typeof json.data === 'object' ? json.data : json;
            if (code !== 200 || data?.available !== true || !Array.isArray(data?.items)) return;
            this.registry = data;
            this.loading = false;
            this.syncFallSensitivity();
            this.syncComparisonSelection();
            await this.service.render();
        } catch (_e) {
            // No snapshot yet: continue with the authoritative full request.
        }
    }

    public async loadRegistry(silent: boolean = false) {
        if (this.registryLoadPromise) {
            await this.registryLoadPromise;
            return;
        }
        this.registryLoadPromise = this.performRegistryLoad(silent);
        try {
            await this.registryLoadPromise;
        } finally {
            this.registryLoadPromise = null;
        }
    }

    private async performRegistryLoad(silent: boolean = false) {
        if (!silent && !this.registry) {
            this.loading = true;
            await this.service.render();
        }
        try {
            const { code, data, message }: any = await wiz.call('model_registry', { scope: 'model-management' });
            if (code === 200) {
                this.registry = data || {};
                this.saveRegistryCache();
                this.syncFallSensitivity();
                this.syncComparisonSelection();
                this.syncFilterValidationPolling();
                this.syncPoseTrainingPolling();
            } else {
                this.uploadMessage = message || data?.message || '모델 목록을 불러오지 못했습니다.';
                this.uploadMessageType = 'error';
            }
        } catch (e: any) {
            this.uploadMessage = e?.message || '모델 목록을 불러오지 못했습니다.';
            this.uploadMessageType = 'error';
        }
        if (!silent) this.loading = false;
        await this.service.render();
    }

    private stopFilterValidationPolling() {
        if (this.filterValidationPollTimer) {
            clearInterval(this.filterValidationPollTimer);
            this.filterValidationPollTimer = null;
        }
    }

    private syncFilterValidationPolling() {
        const hasRunningJob = this.allItems().some((item: any) => this.isFilterValidationRunning(item));
        if (!hasRunningJob) {
            this.stopFilterValidationPolling();
            return;
        }
        if (this.filterValidationPollTimer) return;
        this.filterValidationPollTimer = setInterval(() => this.pollFilterValidationStatus(), 5000);
    }

    private async pollFilterValidationStatus() {
        if (this.filterValidationPollBusy) return;
        const item = this.allItems().find((row: any) => this.isFilterValidationRunning(row));
        if (!item?.model_id) {
            this.stopFilterValidationPolling();
            return;
        }
        this.filterValidationPollBusy = true;
        try {
            const params = new URLSearchParams();
            params.set('model_id', String(item.model_id));
            const res = await fetch(`/wiz/api/page.models/static_object_filter_validation_status?${params.toString()}`);
            const json = await this.readJsonResponse(res);
            const payload = this.responsePayload(json);
            if (json.code === 200 && payload?.job) {
                item.validation_job = payload.job;
                if (payload?.decision) item.validation_decision = payload.decision;
                if (!payload.job.running) {
                    this.stopFilterValidationPolling();
                    await this.loadRegistry(true);
                }
            }
        } catch (_e) {
            // A transient poll failure should not interrupt the background validation.
        }
        this.filterValidationPollBusy = false;
        await this.service.render();
    }

    private stopPoseTrainingPolling() {
        if (this.poseTrainingPollTimer) {
            clearInterval(this.poseTrainingPollTimer);
            this.poseTrainingPollTimer = null;
        }
    }

    private syncPoseTrainingPolling() {
        const running = [...this.poseTrainingJobs(), ...this.poseEvaluationJobs()]
            .some((job: any) => ['queued', 'running'].includes(String(job?.status || '').toLowerCase()));
        if (!running) {
            this.stopPoseTrainingPolling();
            return;
        }
        if (this.poseTrainingPollTimer) return;
        this.poseTrainingPollTimer = setInterval(() => this.pollPoseTrainingStatus(), 5000);
    }

    private async pollPoseTrainingStatus() {
        if (this.poseTrainingPollBusy) return;
        this.poseTrainingPollBusy = true;
        try {
            await this.loadRegistry(true);
        } catch (_e) {
            // A transient refresh error must not stop a running training job.
        }
        this.poseTrainingPollBusy = false;
    }

    public families(): any[] {
        return Array.isArray(this.registry?.families) ? this.registry.families : [];
    }

    public allItems(): any[] {
        return Array.isArray(this.registry?.items) ? this.registry.items : [];
    }

    public registeredModelLibraryItems(): any[] {
        return this.allItems().filter((item: any) => {
            const source = String(item?.source || '').toLowerCase();
            return source === 'uploaded'
                && !!String(item?.primary_model_path || '');
        });
    }

    public modelLibraryItems(): any[] {
        const items = this.modelLibraryCategory === 'tested'
            ? this.testCompletedModelItems()
            : this.registeredModelLibraryItems();
        return [...items].sort((left: any, right: any) => {
            const dateOrder = String(right?.updated_at || right?.created_at || '')
                .localeCompare(String(left?.updated_at || left?.created_at || ''));
            return dateOrder || this.managementModelName(left).localeCompare(this.managementModelName(right));
        });
    }

    public modelCandidateTest(item: any): any {
        const value = item?.summary?.candidate_test || item?.candidate_test;
        return value && typeof value === 'object' ? value : {};
    }

    public isTestCompletedModel(item: any): boolean {
        return String(this.modelCandidateTest(item)?.status || '').toLowerCase() === 'completed';
    }

    public testCompletedModelItems(): any[] {
        return this.allItems().filter((item: any) => (
            this.isTestCompletedModel(item)
            && !!String(item?.primary_model_path || '')
            && String(item?.source || '').toLowerCase() !== 'active'
        ));
    }

    public modelLibraryCategories(): any[] {
        return [
            { key: 'registered', label: '등록 모델', count: this.registeredModelLibraryItems().length },
            { key: 'tested', label: 'Test 완료 모델', count: this.testCompletedModelItems().length },
        ];
    }

    public selectModelLibraryCategory(category: 'registered' | 'tested') {
        if (!['registered', 'tested'].includes(category)) return;
        this.modelLibraryCategory = category;
        this.expandedArchiveItemId = '';
        this.selectedArchiveItem = null;
        this.service.render();
    }

    public modelLibraryCategoryClass(category: string): string {
        return this.modelLibraryCategory === category
            ? 'border-sky-600 bg-sky-600 text-white shadow-sm'
            : 'border-zinc-200 bg-white text-zinc-600 hover:border-sky-300 hover:text-sky-700';
    }

    public testCompletedDate(item: any): string {
        const value = String(this.modelCandidateTest(item)?.completed_at || '');
        return value ? value.slice(0, 10) : '-';
    }

    public managementModelName(item: any): string {
        return String(item?.registration_metadata?.model_name || item?.display_name || item?.label || item?.model_id || '-');
    }

    public managementInfo(item: any): any {
        return item?.management || {};
    }

    public managementStatus(item: any): string {
        return String(this.managementInfo(item)?.status || item?.management_status || 'NOT_EVALUATED');
    }

    public fallModelDatasetText(item: any): string {
        return String(item?.dataset || item?.summary?.dataset_name || item?.summary?.dataset?.name || '-');
    }

    public fallModelPoseExtractorText(item: any): string {
        const extractor = item?.pose_extractor || item?.summary?.pose_extractor || {};
        return String(typeof extractor === 'string' ? extractor : (extractor?.label || extractor?.model_id || '-'));
    }

    public fallModelFeatureVersionText(item: any): string {
        return String(item?.feature_schema_version || item?.summary?.feature_schema_version || '-');
    }

    public managementStatusClass(item: any): string {
        const status = this.managementStatus(item);
        if (status === 'DEPLOYED') return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (status === 'READY') return 'border-sky-200 bg-sky-50 text-sky-700';
        if (status === 'TRAINABLE') return 'border-violet-200 bg-violet-50 text-violet-700';
        if (status === 'ADAPTER_REQUIRED') return 'border-amber-200 bg-amber-50 text-amber-700';
        if (status === 'ERROR') return 'border-rose-200 bg-rose-50 text-rose-700';
        return 'border-zinc-200 bg-zinc-50 text-zinc-600';
    }

    public managementRegisteredDate(item: any): string {
        const raw = String(this.managementInfo(item)?.registered_at || item?.created_at || item?.updated_at || '');
        return raw ? raw.slice(0, 10) : '미등록';
    }

    public canTrainRegisteredModel(item: any): boolean {
        if (String(item?.family || '') !== 'pose-backbone') return false;
        if (String(item?.source || '').toLowerCase() !== 'uploaded') return false;
        if (!/\.pt$/i.test(String(item?.primary_model_path || ''))) return false;
        const variantId = String(item?.pose_variant_id || item?.registration_metadata?.pose_variant_id || item?.summary?.pose_variant_id || '');
        const catalog = Array.isArray(this.registry?.pose_studio?.catalog) ? this.registry.pose_studio.catalog : [];
        const variant = catalog.find((row: any) => String(row?.key || '') === variantId);
        return variant?.training_supported === true;
    }

    public openTrainingWithModel(item: any) {
        if (!this.canTrainRegisteredModel(item)) return;
        try {
            localStorage.setItem('fallai-open-training-mode', '1');
            localStorage.setItem('fallai-pose-training-base-model', String(item.model_id || ''));
        } catch (_e) { }
        // view의 routerLink가 번들을 다시 받지 않고 학습 화면으로 즉시 전환합니다.
    }

    public startCatalogRegistration(item: any) {
        const variant = this.poseModelCatalog().find((row: any) => String(row?.key || '') === String(item?.pose_variant_id || ''));
        this.selectedAiKind = 'pose';
        this.uploadFamily = 'pose-backbone';
        const group = String(variant?.group || '').toLowerCase();
        this.poseRegistrationFamily = group.startsWith('yolo') ? 'yolo-pose'
            : (group === 'rtmpose' ? 'rtmpose' : (group === 'vitpose' ? 'vitpose' : (group === 'hrnet' ? 'hrnet' : (group === 'rtmo' ? 'rtmo' : 'custom'))));
        this.startNewModelWizard();
        if (variant) this.selectRegistrationPoseVariant(variant);
    }

    public versionHistoryGroups(): any[] {
        const groups: any = {};
        for (const item of this.registeredModelLibraryItems()) {
            const name = this.managementModelName(item);
            if (!groups[name]) groups[name] = { name, family: item.family, versions: [] };
            groups[name].versions.push(item);
        }
        return Object.values(groups).map((group: any) => ({
            ...group,
            versions: group.versions.sort((a: any, b: any) => String(b?.updated_at || '').localeCompare(String(a?.updated_at || ''))),
        })).sort((a: any, b: any) => a.name.localeCompare(b.name));
    }

    public rollbackFamilies(): string[] {
        const rows = this.registry?.model_management?.rollback_families;
        return Array.isArray(rows) ? rows.map((item: any) => String(item || '')) : [];
    }

    public canRollbackFamily(family: string): boolean {
        return this.rollbackFamilies().includes(String(family || ''));
    }

    public compatibilityItems(): any[] {
        const rows = [...this.testCompletedModelItems(), ...this.registeredModelLibraryItems()];
        const seen = new Set<string>();
        return rows.filter((item: any) => {
            const modelId = String(item?.model_id || '');
            if (!modelId || seen.has(modelId)) return false;
            seen.add(modelId);
            return true;
        });
    }

    public selectedCompatibilityItem(): any {
        const id = String(this.compatibilityModelId || this.lastRegisteredModelId || '');
        return this.compatibilityItems().find((item: any) => String(item?.model_id || '') === id)
            || this.compatibilityItems()[0] || {};
    }

    public compatibilityStatusClass(status: string): string {
        if (status === 'PASS') return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (status === 'FAIL') return 'border-rose-200 bg-rose-50 text-rose-700';
        return 'border-amber-200 bg-amber-50 text-amber-700';
    }

    private compatibilityFileName(path: any): string {
        const normalized = String(path || '').replace(/\\/g, '/');
        const parts = normalized.split('/').filter(Boolean);
        return parts.length ? parts[parts.length - 1] : '';
    }

    public compatibilityUploadedFiles(item: any): string[] {
        const management = this.managementInfo(item);
        const paths = [
            item?.primary_model_path,
            management?.primary_model_path,
            ...(Array.isArray(item?.artifact_paths) ? item.artifact_paths : []),
            ...(Array.isArray(management?.artifact_paths) ? management.artifact_paths : []),
        ];
        return Array.from(new Set(paths.map((path: any) => this.compatibilityFileName(path)).filter(Boolean)));
    }

    private compatibilityLooksLikeDetectionCheckpoint(item: any): boolean {
        const checkText = (Array.isArray(this.managementInfo(item)?.checks) ? this.managementInfo(item).checks : [])
            .map((check: any) => String(check?.message || '')).join(' ');
        const uploadedFiles = this.compatibilityUploadedFiles(item);
        return /DetectionModel|detect(?:ion)?\s+(?:model|checkpoint)|task[=: ]+detect/i.test(checkText)
            || uploadedFiles.some((name: string) => /^yolo(?!.*pose).*\.pt$/i.test(name));
    }

    private compatibilityIssueMessage(item: any, check: any): string {
        const key = String(check?.key || '').toLowerCase();
        const raw = String(check?.message || '').trim();
        if (String(item?.family || '') === 'pose-backbone' && this.compatibilityLooksLikeDetectionCheckpoint(item)) {
            if (key === 'inference' || key === 'task' || key === 'model_load') {
                return '업로드한 파일은 객체 검출용 YOLO Detection checkpoint입니다. Pose 등록에는 사람 관절점(COCO-17)을 출력하는 Pose checkpoint가 필요합니다.';
            }
        }
        if (/weights_only|Unsupported global|safe_globals/i.test(raw)) {
            return '안전 격리 로더가 checkpoint 구조를 읽지 못했습니다. 선택한 모델 종류와 일치하는 공식 checkpoint 또는 FallAI 실행 규격에 맞춘 파일인지 확인해 주세요.';
        }
        if (key === 'adapter') {
            return '모델 출력값을 FallAI 관절점 규격으로 변환할 실행 어댑터가 없습니다. 지원 모델 파일을 사용하거나 Custom ONNX 어댑터 설정을 함께 등록해야 합니다.';
        }
        if (key === 'keypoints') {
            return 'FallAI가 요구하는 COCO-17 관절점 출력 형식을 확인하지 못했습니다.';
        }
        return raw || '선택한 모델 종류와 업로드 파일의 실행 규격이 일치하지 않습니다.';
    }

    public compatibilityIssueRows(item: any): any[] {
        const checks = Array.isArray(this.managementInfo(item)?.checks) ? this.managementInfo(item).checks : [];
        return checks
            .filter((check: any) => ['FAIL', 'WARNING'].includes(String(check?.status || '').toUpperCase()))
            .sort((left: any, right: any) => {
                const priority: any = { FAIL: 0, WARNING: 1 };
                return (priority[String(left?.status || '').toUpperCase()] ?? 2)
                    - (priority[String(right?.status || '').toUpperCase()] ?? 2);
            })
            .map((check: any) => ({
                ...check,
                explanation: this.compatibilityIssueMessage(item, check),
                technicalMessage: String(check?.message || '').trim(),
            }));
    }

    public compatibilityExpectedFileGuide(item: any): any {
        const management = this.managementInfo(item);
        const metadata = item?.registration_metadata || {};
        const family = String(item?.family || metadata?.family || '').toLowerCase();
        const framework = String(management?.framework || metadata?.framework || '').toLowerCase();
        const poseFamily = String(item?.pose_family || metadata?.pose_family || '').toLowerCase();
        const variantId = String(item?.pose_variant_id || metadata?.pose_variant_id || item?.summary?.pose_variant_id || '');
        const variant = this.poseModelCatalog().find((row: any) => String(row?.key || '') === variantId);

        if (family === 'pose-backbone' && this.compatibilityLooksLikeDetectionCheckpoint(item)) {
            return {
                title: '객체 검출 파일이 아닌 Pose checkpoint를 올려주세요',
                why: '선택한 등록 종류는 Pose Estimation인데 현재 파일은 객체 위치만 찾는 DetectionModel이라 COCO-17 관절점을 출력하지 못합니다.',
                required: ['YOLO Pose checkpoint (*.pt)', '예: yolo11n-pose.pt 또는 yolo26s-pose.pt'],
                optional: ['Custom ONNX 사용 시 checkpoint.onnx + fallai_adapter.json'],
                action: '현재 Detection용 파일은 제거하고, 모델 이름에 -pose가 포함된 공식 Pose checkpoint 또는 FallAI 규격의 Custom Pose 파일로 다시 등록하세요.',
            };
        }

        if (family === 'pose-backbone') {
            const adapter = String(variant?.adapter || metadata?.adapter || '').toLowerCase();
            const isMmpose = adapter === 'mmpose' || framework.includes('mmpose')
                || ['rtmpose', 'vitpose', 'hrnet', 'rtmo'].some((name: string) => poseFamily.includes(name) || variantId.includes(name));
            if (isMmpose) {
                return {
                    title: `${variant?.label || variantId || '선택한 MMPose 모델'} checkpoint가 필요합니다`,
                    why: '선택한 MMPose 계열·크기와 checkpoint 구조가 정확히 일치해야 합니다.',
                    required: ['checkpoint.pth 1개'],
                    optional: ['모델 설정(config)은 선택한 종류에 맞춰 시스템이 자동 연결합니다.'],
                    action: 'Detection용 .pt 또는 다른 MMPose 계열·크기의 .pth가 아닌, 선택한 모델의 학습 완료 checkpoint.pth를 올려주세요.',
                };
            }
            if (variantId && (String(variant?.adapter || '') === 'ultralytics' || poseFamily.includes('yolo'))) {
                return {
                    title: `${variant?.label || variantId}와 일치하는 파일이 필요합니다`,
                    why: '등록 화면에서 선택한 Pose 모델 종류와 checkpoint의 모델 구조가 같아야 합니다.',
                    required: [this.poseVariantRegistrationInfo(variant || { key: variantId }).files],
                    optional: [],
                    action: '같은 모델명과 크기의 공식 *-pose.pt 파일을 다시 올려주세요.',
                };
            }
            return {
                title: 'COCO-17 관절점을 출력하는 Custom Pose 모델이 필요합니다',
                why: '일반 객체 검출 모델이나 출력 규격이 없는 checkpoint는 낙상 분석용 관절점으로 변환할 수 없습니다.',
                required: ['학습 완료 Pose checkpoint (.pt 또는 .pth)', '또는 checkpoint.onnx + fallai_adapter.json'],
                optional: ['출력은 사람별 bbox, confidence, COCO-17 keypoints를 제공해야 합니다.'],
                action: '자체 모델이면 입력 크기·정규화·출력 매핑을 fallai_adapter.json에 명시해 함께 등록하세요.',
            };
        }
        if (family.includes('rf-') || family.includes('fall')) {
            return {
                title: 'FallAI 특징 규격으로 학습한 낙상 판별 파일이 필요합니다',
                why: '일반 분류 모델은 Pose 시계열 특징 순서와 낙상 확률 출력 계약이 달라 사용할 수 없습니다.',
                required: ['학습 완료 모델 .pkl 또는 .joblib'], optional: ['학습 summary/feature schema JSON'],
                action: 'Training Mode에서 생성된 낙상 판별 artifact를 등록하세요.',
            };
        }
        if (family.includes('environment') || family.includes('object')) {
            return {
                title: '객체 탐지 모델 파일이 필요합니다', why: '환경 객체 분석은 탐지 bbox와 class 정보를 출력해야 합니다.',
                required: ['객체 탐지 checkpoint .pt 또는 .onnx'], optional: ['class 이름 .yaml, .yml 또는 .json'],
                action: '선택한 탐지 프레임워크와 같은 형식의 학습 완료 파일을 등록하세요.',
            };
        }
        return {
            title: '선택한 분석 종류와 일치하는 학습 완료 파일이 필요합니다',
            why: '파일 확장자만 같아도 모델 구조·입출력 규격이 다르면 호환성 검사에 실패합니다.',
            required: ['학습 완료 checkpoint .pt, .pth 또는 .onnx'], optional: ['class/전처리 설정 .yaml 또는 .json'],
            action: '모델 종류와 학습 프레임워크를 확인한 뒤 같은 구조의 checkpoint를 다시 등록하세요.',
        };
    }

    public selectedCompareRows(): any[] {
        return this.comparisonCategoryRows().filter((row: any) => this.selectedComparisonIds.includes(String(row?.model_id || ''))).slice(0, 4);
    }

    public comparisonCategoryOptions(): any[] {
        const options = [
            { key: 'fall', label: '낙상 판단', families: ['rf-dual', 'rf-pipeline', 'rf-fall-v2'] },
            { key: 'pose', label: '관절점 추출', families: ['pose-backbone'] },
            { key: 'posture', label: '자세·가림', families: ['xg-posture', 'xg-posture-occlusion-aux'] },
            { key: 'object', label: '환경 객체', families: ['environment-agent'] },
            { key: 'face', label: '표정·얼굴 상태', families: ['facial-aihub82', 'driver-aihub173'] },
        ];
        return options.map((option: any) => ({
            ...option,
            count: this.comparisonCandidateRows().filter((row: any) => option.families.includes(String(row?.family || ''))).length,
        }));
    }

    public comparisonCategoryRows(): any[] {
        const category = this.comparisonCategoryOptions().find((item: any) => item.key === this.comparisonCategory)
            || this.comparisonCategoryOptions()[0];
        const families = Array.isArray(category?.families) ? category.families : [];
        return this.comparisonCandidateRows().filter((row: any) => families.includes(String(row?.family || '')));
    }

    public selectComparisonCategory(category: string) {
        if (!this.comparisonCategoryOptions().some((item: any) => item.key === category)) return;
        this.comparisonCategory = category;
        this.selectedComparisonIds = [];
        this.selectedModelId = '';
        this.service.render();
    }

    public compareMetricDefinitions(): any[] {
        return [
            { key: 'map50', label: 'mAP50', percent: true },
            { key: 'map50_95', label: 'mAP50-95', percent: true },
            { key: 'precision', label: 'Precision', percent: true },
            { key: 'recall', label: 'Recall', percent: true },
            { key: 'f1', label: 'F1', percent: true },
            { key: 'fps', label: 'FPS', percent: false },
            { key: 'inference_ms', label: 'Inference Time', percent: false, suffix: 'ms' },
        ];
    }

    public compareMetricDisplay(row: any, definition: any): string {
        const value = Number(row?.[definition.key] ?? row?.metrics?.[definition.key]);
        if (!Number.isFinite(value) || value <= 0) return '-';
        if (definition.percent) return `${(value * 100).toFixed(1)}%`;
        return `${value.toFixed(1)}${definition.suffix || ''}`;
    }

    public compareMetricBar(row: any, key: string): number {
        const rows = this.selectedCompareRows();
        const value = Number(row?.[key] ?? row?.metrics?.[key] ?? 0);
        const best = Math.max(...rows.map((item: any) => Number(item?.[key] ?? item?.metrics?.[key] ?? 0)), 0.0001);
        return Math.max(2, Math.min(100, value / best * 100));
    }

    public deployedManagementModels(): any[] {
        return this.allItems().filter((item: any) => this.managementInfo(item)?.deployed === true);
    }

    public deployableManagementModels(): any[] {
        return this.compatibilityItems().filter((item: any) => this.managementInfo(item)?.deployable === true);
    }

    public registrationSteps(): any[] {
        return [
            { id: 1, label: '모델 종류' },
            { id: 2, label: '모델 정보' },
            { id: 3, label: '파일 등록' },
            { id: 4, label: '호환성 검사' },
        ];
    }

    public registrationSourceOptions(): any[] {
        return [
            { key: 'official_pretrained', label: '공식 사전학습 모델', description: '모델 개발팀이 공개한 원본 checkpoint를 그대로 등록할 때 선택' },
            { key: 'fine_tuned', label: '직접 학습한 모델', description: '내 데이터로 새로 학습하거나 공식 모델을 추가 학습한 checkpoint를 등록할 때 선택' },
            { key: 'external', label: '외부 모델', description: '학교·협력사·인터넷 등 다른 곳에서 받은 checkpoint를 등록할 때 선택' },
            { key: 'custom', label: 'Custom', description: '직접 만든 모델 파일과 실행 계약 등록' },
        ];
    }

    public registrationSourceOptionsForSelection(): any[] {
        if (this.isCustomRegistration()) return this.registrationSourceOptions().filter((item: any) => item.key === 'custom');
        if (this.selectedAiKind === 'pose') {
            const adapter = String(this.selectedPoseCatalogItem()?.adapter || '');
            return this.registrationSourceOptions().filter((item: any) => (
                adapter === 'mmpose'
                    ? ['official_pretrained', 'fine_tuned', 'external'].includes(item.key)
                    : ['official_pretrained', 'fine_tuned'].includes(item.key)
            ));
        }
        if (this.selectedAiKind === 'fall' || this.selectedAiKind === 'face') {
            return this.registrationSourceOptions().filter((item: any) => ['fine_tuned', 'external'].includes(item.key));
        }
        return this.registrationSourceOptions().filter((item: any) => ['official_pretrained', 'fine_tuned', 'external'].includes(item.key));
    }

    public selectRegistrationSource(source: string) {
        if (!this.registrationSourceOptions().some((item: any) => item.key === source)) return;
        this.registrationSource = source;
        this.clearUploadFiles();
    }

    public registrationSourceLabel(source: string): string {
        return String(this.registrationSourceOptions().find((item: any) => item.key === source)?.label || source || '외부 모델');
    }

    public selectedPoseCatalogItem(): any {
        return this.poseModelCatalog().find((item: any) => String(item?.key || '') === this.poseVariantId) || {};
    }

    public officialPretrainedAvailable(): boolean {
        const item = this.selectedPoseCatalogItem();
        return this.selectedAiKind === 'pose'
            && String(item?.adapter || '') === 'ultralytics'
            && !!String(item?.checkpoint || '').trim();
    }

    public officialCheckpointName(): string {
        return String(this.selectedPoseCatalogItem()?.checkpoint || '공식 checkpoint');
    }

    public isCustomRegistration(): boolean {
        return this.poseRegistrationFamily === 'custom'
            || String(this.registrationVariantId || '').startsWith('custom-');
    }

    public poseRecommendedModels(): any[] {
        const descriptions: any = {
            'yolo26s-pose': '빠른 실시간 분석',
            'yolo26m-pose': '정확도 중심',
            'yolo11n-pose': '가벼운 모델',
            'yolo11x-pose': '정확도 중심',
        };
        const order = ['yolo26s-pose', 'yolo26m-pose', 'yolo11n-pose', 'yolo11x-pose'];
        return order.map(key => {
            const item = this.poseModelCatalog().find((row: any) => row?.key === key) || { key, label: key };
            return { ...item, description: descriptions[key], recommended: key === 'yolo26s-pose' };
        });
    }

    public advancedPoseRegistrationFamilies(): any[] {
        return this.poseRegistrationFamilies().filter((item: any) => item.key !== 'yolo-pose');
    }

    public poseRegistrationGroups(): any[] {
        return this.poseRegistrationFamilies()
            .filter((family: any) => family.key !== 'custom')
            .map((family: any) => ({
                ...family,
                models: this.poseModelCatalog().filter((model: any) => {
                    const groups: any = {
                        'yolo-pose': ['YOLO11', 'YOLO26'],
                        rtmpose: ['RTMPose'], vitpose: ['ViTPose'], hrnet: ['HRNet'], rtmo: ['RTMO'],
                    };
                    return (groups[family.key] || []).includes(String(model?.group || ''));
                }),
            }));
    }

    public registrationAiKindOptions(): any[] {
        return this.aiKindOptions().filter((item: any) => item.key === 'pose');
    }

    public selectedPoseFamilyLabel(): string {
        return String(this.selectedPoseRegistrationFamily()?.label || '-');
    }

    public selectedPoseInputOutput(): string {
        const item = this.selectedPoseCatalogItem();
        return String(item?.adapter || '') === 'ultralytics'
            ? '이미지 → 사람 bbox + COCO-17 관절점'
            : '사람 영역 이미지 → COCO-17 관절점';
    }

    public poseVariantRegistrationInfo(item: any): any {
        const details: any = {
            'yolo26s-pose': { balance: '빠른 균형형', description: '속도와 정확도의 균형이 좋아 실시간 낙상 분석의 첫 선택으로 적합합니다.', use: '실시간 운영 시작', files: 'yolo26s-pose.pt 1개' },
            'yolo26m-pose': { balance: '정확도 강화형', description: 'YOLO26s보다 크고 느리지만 관절점 정확도를 더 우선합니다.', use: 'GPU 여유가 있는 운영', files: 'yolo26m-pose.pt 1개' },
            'yolo11n-pose': { balance: '최경량형', description: '11개 중 가장 가벼운 축으로, 낮은 사양에서 빠른 처리에 유리합니다.', use: '저사양·속도 우선', files: 'yolo11n-pose.pt 1개' },
            'yolo11x-pose': { balance: '대형 정확도형', description: 'YOLO11의 큰 모델로 정확도를 우선하지만 GPU 사용량과 지연이 큽니다.', use: '정밀 검증·서버 GPU', files: 'yolo11x-pose.pt 1개' },
            'rtmpose-m': { balance: '속도·정확도 균형', description: 'RTMPose의 중간 크기 모델로, MMPose 후보를 처음 비교할 때 적합합니다.', use: 'RTMPose 균형형 비교', files: 'checkpoint.pth (설정 자동 연결)' },
            'rtmpose-l': { balance: '정확도 우선', description: 'RTMPose-m보다 큰 모델로 관절점 정확도를 우선하며 더 많은 GPU 자원이 필요합니다.', use: 'RTMPose 정밀 비교', files: 'checkpoint.pth (설정 자동 연결)' },
            'vitpose-b': { balance: 'Transformer 기본형', description: 'Transformer 기반 기본 크기로 정확도와 자원 사용량을 함께 비교하기 좋습니다.', use: 'Transformer 기준 모델', files: 'checkpoint.pth (설정 자동 연결)' },
            'vitpose-l': { balance: 'Transformer 대형', description: 'ViTPose-B보다 정확도 지향이지만 처리 속도와 GPU 메모리를 꼭 확인해야 합니다.', use: '오프라인 정밀 평가', files: 'checkpoint.pth (설정 자동 연결)' },
            'hrnet-w32': { balance: '고해상도 경량형', description: '고해상도 특징을 유지하면서 W48보다 가벼워 작은 관절 위치 비교에 적합합니다.', use: '정밀도·속도 균형', files: 'checkpoint.pth (설정 자동 연결)' },
            'hrnet-w48': { balance: '고해상도 정확도형', description: 'W32보다 넓은 모델로 관절 위치 정확도를 우선하며 연산량이 더 큽니다.', use: '작은 관절 정밀 검증', files: 'checkpoint.pth (설정 자동 연결)' },
            rtmo: { balance: '다중 사람 실시간형', description: '여러 사람의 관절점을 한 번에 처리하는 장면에 특화된 MMPose 모델입니다.', use: '다중 사람 장면', files: 'checkpoint.pth (설정 자동 연결)' },
        };
        return details[String(item?.key || '')] || {
            balance: '직접 추가 모델', description: '목록에 없는 Pose 모델입니다. FallAI 출력 규격에 맞는 실행 설정이 필요합니다.',
            use: '자체 모델 연결', files: '모델 파일 + 입력·출력 설정',
        };
    }

    public selectedPoseRegistrationInfo(): any {
        return this.poseVariantRegistrationInfo(this.selectedPoseCatalogItem());
    }

    public poseAutomaticConfigLabel(): string {
        return String(this.selectedPoseCatalogItem()?.config_label || `${this.registrationModelName} 설정 자동 적용`);
    }

    public compatibilityKeypointSchema(): string {
        const item = this.selectedCompatibilityItem();
        return String(item?.registration_metadata?.keypoint_schema || 'coco17').toUpperCase().replace('COCO17', 'COCO-17');
    }

    public compatibilityInferenceTime(): string {
        const item = this.selectedCompatibilityItem();
        const value = Number(item?.metrics?.inference_time_ms ?? item?.summary?.pose_evaluation?.metrics?.inference_time_ms);
        return Number.isFinite(value) && value > 0 ? `${value.toFixed(1)} ms` : '평가 전';
    }

    public faceAnalysisOptions(): any[] {
        return [
            { key: 'expression', label: '표정 분석', description: '행복·불안·슬픔·중립 등 표정과 불편 신호 분석' },
            { key: 'state', label: '상태 분석', description: '졸림·하품·주의 상태 등 얼굴 상태 분석' },
            { key: 'custom', label: 'Custom', description: '직접 만든 얼굴 분석 모델 연결' },
        ];
    }

    public selectFaceAnalysisMode(key: string) {
        this.faceAnalysisMode = key;
        const selected = this.visibleRegistrationModelOptions()[0];
        if (selected) this.selectRegistrationModelOption(selected);
    }

    public visibleRegistrationModelOptions(): any[] {
        const rows = this.registrationModelOptions();
        if (this.selectedAiKind !== 'face') return rows;
        if (this.faceAnalysisMode === 'expression') return rows.filter((item: any) => ['aihub82-expression', 'custom-expression'].includes(item.key));
        if (this.faceAnalysisMode === 'state') return rows.filter((item: any) => ['aihub173-state', 'custom-state'].includes(item.key));
        return rows.filter((item: any) => item.key === 'custom-face');
    }

    public registrationRole(): string {
        return this.selectedAiKind === 'pose' ? '사람 관절점 추출'
            : this.selectedAiKind === 'fall' ? '낙상 / 비낙상 판단'
            : this.selectedAiKind === 'object' ? '환경 위험 객체 탐지'
            : this.faceAnalysisMode === 'state' ? '얼굴 상태 분석' : '표정 분석';
    }

    public registrationOutput(): string {
        return String(this.selectedRegistrationGuide()?.output || this.selectedAiKindOption()?.output || '-');
    }

    public registrationStatusLabel(): string {
        if (this.isCustomRegistration()) return 'Custom 모델';
        if (this.registrationSource === 'official_pretrained') return '공식 사전학습 모델';
        return '학습 완료 모델';
    }

    public environmentDetectionTargets(): string[] {
        return ['침대', '의자', '보행기', '휠체어', '장애물', '전선'];
    }

    public registrationFileHelp(): string {
        const framework = String(this.registrationFramework || '').toLowerCase();
        if (this.registrationSource === 'official_pretrained') {
            return framework.includes('mmpose')
                ? '공식 checkpoint.pth와 실행에 필요한 config.py를 등록하세요. training_summary.json은 필요하지 않습니다.'
                : '공식 checkpoint만 등록하면 됩니다. training_summary.json은 학습·평가 후 시스템이 생성합니다.';
        }
        if (this.registrationSource === 'fine_tuned') {
            return framework.includes('mmpose')
                ? `checkpoint.pth만 선택하세요. ${this.poseAutomaticConfigLabel()}은 시스템이 자동 연결합니다.`
                : 'best.pt를 선택하세요. 학습 결과 파일은 있으면 함께 선택할 수 있습니다.';
        }
        if (this.registrationSource === 'custom') {
            return 'Custom ONNX는 checkpoint.onnx와 fallai_adapter.json을 함께 등록하면 격리 실행 검사 후 FallAI COCO-17 어댑터로 연결됩니다.';
        }
        return framework.includes('mmpose')
            ? 'checkpoint.pth와 config.py를 등록하세요. 외부 summary는 선택 사항입니다.'
            : '실제 checkpoint를 등록하세요. summary와 설정 파일은 선택 사항입니다.';
    }

    public aiKindOptions(): any[] {
        return [
            {
                key: 'pose', label: 'Pose Estimation', description: '사람의 COCO-17 관절점을 추출하는 전처리 모델', families: ['pose-backbone'],
                dataRequirement: '프레임별 COCO-17 관절점 annotation', output: '사람 bbox와 17개 관절점',
                beginnerTip: '낙상 여부만 표시된 일반 영상으로는 Pose 모델을 재학습할 수 없습니다.',
            },
            {
                key: 'fall', label: 'Fall Detection', description: '시간에 따른 사람 움직임으로 낙상 여부를 판단하는 모델', families: ['rf-fall-v2'],
                dataRequirement: '낙상·비낙상 영상과 사건 라벨', output: '낙상 원시 확률과 이진 판단',
                beginnerTip: '학교 데이터가 낙상/비낙상 영상이라면 RF-Fall v2부터 선택하는 것이 가장 적합합니다.',
            },
            {
                key: 'object', label: 'Object Detection', description: '침대·매트·장애물 같은 환경 객체를 검출하는 모델', families: ['environment-agent'],
                dataRequirement: '객체 bbox 또는 segmentation mask', output: '객체 종류·위치·외곽선',
                beginnerTip: '낙상을 직접 판정하지 않고 바닥·매트 접근과 주변 위험 근거를 제공합니다.',
            },
            {
                key: 'face', label: 'Face Analysis', description: '표정·불편·졸림 등 얼굴 상태를 분석하는 보조 모델', families: ['facial-aihub82'],
                dataRequirement: '얼굴 이미지와 표정·상태 라벨', output: '표정 또는 얼굴 상태 확률',
                beginnerTip: '낙상 모델을 대체하지 않으며 신뢰 가능한 얼굴이 보일 때만 보조 근거로 사용합니다.',
            },
        ];
    }

    public poseRegistrationFamilies(): any[] {
        return [
            {
                key: 'yolo-pose', label: 'YOLO Pose', framework: 'Ultralytics YOLO',
                description: '사람 검출과 관절점 추출을 한 번에 수행', input: '영상/이미지 + COCO-17 라벨', output: 'bbox + COCO-17 관절점',
                recommended: '실시간 분석과 현재 RF-Dual 연동', caution: '등록 모델은 COCO-17 및 fallai-pose-v1 계약을 충족해야 합니다.',
            },
            {
                key: 'rtmpose', label: 'RTMPose', framework: 'MMPose',
                description: '속도와 정확도의 균형을 목표로 하는 MMPose 계열', input: '영상/이미지 + COCO-17 라벨', output: 'COCO-17 관절점',
                recommended: 'MMPose 기반 균형형 Pose 후보', caution: '운영 적용 전에 MMPose adapter 호환성 검사가 필요합니다.',
            },
            {
                key: 'vitpose', label: 'ViTPose', framework: 'MMPose',
                description: 'Vision Transformer 기반 정확도 지향 Pose 계열', input: '영상/이미지 + COCO-17 라벨', output: 'COCO-17 관절점',
                recommended: '연산량보다 관절점 정확도가 중요한 검증', caution: '실시간 처리속도와 GPU 메모리를 별도로 검증해야 합니다.',
            },
            {
                key: 'hrnet', label: 'HRNet', framework: 'MMPose',
                description: '고해상도 특징을 유지해 관절 위치를 정밀 추정', input: '영상/이미지 + COCO-17 라벨', output: 'COCO-17 관절점',
                recommended: '작은 관절과 정밀 위치 검증', caution: '모델 크기별 지연시간과 adapter 호환성을 확인해야 합니다.',
            },
            {
                key: 'rtmo', label: 'RTMO', framework: 'MMPose',
                description: '여러 사람을 실시간으로 처리하는 Pose 계열', input: '다중 사람 영상/이미지 + 관절점 라벨', output: '사람별 COCO-17 관절점',
                recommended: '다중 사람 장면의 실시간 후보', caution: '사람별 tracking과 출력 순서 계약을 함께 검증해야 합니다.',
            },
            {
                key: 'custom', label: 'Custom', framework: 'Custom',
                description: '직접 만든 Pose 모델과 adapter 등록', input: '모델별 입력 + COCO-17 라벨', output: 'FallAI 호환 COCO-17 관절점',
                recommended: '기본 카탈로그에 없는 자체 모델', caution: 'COCO-17, 좌표계, confidence, fallai-pose-v1 adapter가 모두 필요합니다.',
            },
        ];
    }

    public registrationModelOptions(kind: string = this.selectedAiKind): any[] {
        const options: any = {
            fall: [
                {
                    key: 'rf-fall-v2', label: 'RF-Fall', description: '낙상 / 비낙상 판단', family: 'rf-fall-v2', framework: 'scikit-learn', backbone: 'RandomForest + ExtraTrees',
                    input: 'Pose 시계열에서 만든 65개 특징', output: '낙상/비낙상 원시 확률', recommended: '낙상·비낙상 라벨 영상 학습',
                    caution: '원시 모델 확률 뒤에 사건 병합과 event-risk 후처리가 별도로 적용됩니다.',
                },
                {
                    key: 'rf-pipeline', label: 'RF-Pipeline', description: '현재 Fall AI 계열 낙상 판단 모델', family: 'rf-pipeline', framework: 'scikit-learn', backbone: 'Random Forest Pipeline',
                    input: 'bbox 중심·높이·종횡비 등 13개 특징', output: '보조 낙상 확률', recommended: 'RF-Fall v2 불가·오류 시 호환용',
                    caution: '레거시 보조 계열이며 신규 학교 데이터 학습은 RF-Fall v2를 우선 권장합니다.',
                },
                {
                    key: 'temporal-fall', label: '시계열 행동 모델', description: '여러 프레임의 움직임으로 낙상 판단', family: 'rf-fall-v2', framework: 'PyTorch', backbone: 'Temporal Model',
                    input: '여러 프레임의 Pose 또는 영상 특징', output: '시계열 낙상 확률', recommended: '행동 흐름 기반 낙상 모델 등록',
                    caution: '입력 길이와 프레임 간격 계약을 함께 등록해야 합니다.',
                },
                {
                    key: 'custom-fall', label: 'Custom', description: '직접 만든 낙상 판단 모델 등록', family: 'rf-fall-v2', framework: 'Custom', backbone: 'Custom',
                    input: '직접 정의한 특징 계약', output: 'FallAI 호환 낙상 확률', recommended: '자체 낙상 분류기 연동',
                    caution: '입력 특징 순서, 클래스 순서, 확률 출력과 threshold 호환 adapter가 필요합니다.',
                },
            ],
            object: [
                {
                    key: 'yolo-detection', label: 'YOLO Detection', description: '침대·보행기·장애물 등 객체 검출', family: 'environment-agent', framework: 'Ultralytics YOLO', backbone: 'YOLO Detection',
                    input: '이미지 + 클래스별 bbox 라벨', output: '객체 클래스·bbox·confidence', recommended: '환경 객체의 빠른 실시간 검출', caution: '낙상을 직접 판정하지 않고 환경 근거만 제공합니다.',
                },
                {
                    key: 'yolo-segmentation', label: 'YOLO Segmentation', description: '객체 영역까지 검출', family: 'environment-agent', framework: 'Ultralytics YOLO', backbone: 'YOLO Segmentation',
                    input: '이미지 + 객체 mask/segmentation 라벨', output: '객체 클래스·bbox·mask', recommended: '매트·침대 경계를 정밀하게 사용할 때', caution: 'bbox 라벨만 있는 데이터로는 segmentation 학습이 부족합니다.',
                },
                {
                    key: 'custom-object', label: 'Custom Detection', description: '직접 만든 환경 객체 모델 등록', family: 'environment-agent', framework: 'Custom', backbone: 'Custom',
                    input: '모델별 이미지·라벨 계약', output: 'FallAI 호환 bbox 또는 mask', recommended: '자체 환경 객체 모델 연동', caution: '클래스 매핑과 좌표계·confidence adapter가 필요합니다.',
                },
            ],
            face: [
                {
                    key: 'aihub82-expression', label: 'AI-Hub 82 표정', description: '표정과 불편/비불편 안전 신호를 분석', family: 'facial-aihub82', framework: 'PyTorch', backbone: 'MobileNetV3',
                    input: '얼굴 이미지 + AI-Hub 82 라벨 계약', output: '불편 신호와 표정 보조 확률', recommended: '낙상 의심 구간의 얼굴 보조 근거', caution: 'AI-Hub 82는 알고리즘명이 아니라 데이터·라벨 계약 이름입니다.',
                },
                {
                    key: 'aihub173-state', label: 'AI-Hub 173 상태', description: '정상주시·졸림·하품·통화·흡연 상태를 분석', family: 'driver-aihub173', framework: 'PyTorch', backbone: 'MobileNetV3',
                    input: '얼굴 이미지 + 5개 상태 라벨', output: '얼굴 상태별 확률', recommended: '주의저하·졸림 위험 보조', caution: 'AI-Hub 173은 데이터·라벨 계약이며 낙상 판단 모델이 아닙니다.',
                },
                {
                    key: 'custom-expression', label: 'Custom Emotion Model', description: '직접 만든 표정 분석 모델', family: 'facial-aihub82', framework: 'Custom', backbone: 'Custom',
                    input: '얼굴 이미지 + 표정 라벨', output: '표정 클래스별 확률', recommended: '자체 표정 모델 연동', caution: '얼굴 crop과 클래스 순서 계약이 필요합니다.',
                },
                {
                    key: 'custom-state', label: 'Custom State Model', description: '직접 만든 얼굴 상태 모델', family: 'driver-aihub173', framework: 'Custom', backbone: 'Custom',
                    input: '얼굴 이미지 + 상태 라벨', output: '상태 클래스별 확률', recommended: '자체 상태 모델 연동', caution: '얼굴 crop과 클래스 순서 계약이 필요합니다.',
                },
                {
                    key: 'custom-face', label: 'Custom', description: '직접 만든 얼굴 분석 모델 등록', family: 'facial-aihub82', framework: 'Custom', backbone: 'Custom',
                    input: '모델별 얼굴 입력·라벨 계약', output: 'FallAI 호환 얼굴 상태 확률', recommended: '자체 얼굴 모델 연동', caution: '얼굴 crop, 정규화, 클래스 순서 adapter가 필요합니다.',
                },
            ],
        };
        return Array.isArray(options[kind]) ? options[kind] : [];
    }

    public selectedAiKindOption(): any {
        return this.aiKindOptions().find((item: any) => item.key === this.selectedAiKind) || this.aiKindOptions()[0] || {};
    }

    public selectedPoseRegistrationFamily(): any {
        return this.poseRegistrationFamilies().find((item: any) => item.key === this.poseRegistrationFamily) || {};
    }

    public selectedRegistrationGuide(): any {
        return this.selectedAiKind === 'pose' ? this.selectedPoseRegistrationFamily() : this.selectedRegistrationModelOption();
    }

    public selectedRegistrationModelOption(): any {
        return this.registrationModelOptions().find((item: any) => item.key === this.registrationVariantId) || {};
    }

    public selectRegistrationModelOption(item: any) {
        this.registrationVariantId = String(item?.key || '');
        this.registrationModelName = String(item?.label || '');
        this.registrationFramework = String(item?.framework || 'Custom');
        this.registrationBackbone = String(item?.backbone || 'Custom');
        this.uploadFamily = String(item?.family || this.uploadFamily || 'rf-fall-v2');
        this.registrationSource = String(item?.key || '').startsWith('custom-') ? 'custom'
            : (this.selectedAiKind === 'object' ? 'official_pretrained' : 'fine_tuned');
        this.showAdvancedRegistration = false;
        this.service.render();
    }

    public poseVariantsForRegistration(): any[] {
        const groupMap: any = {
            'yolo-pose': ['YOLO11', 'YOLO26'],
            rtmpose: ['RTMPose'],
            vitpose: ['ViTPose'],
            hrnet: ['HRNet'],
            rtmo: ['RTMO'],
        };
        const groups = groupMap[this.poseRegistrationFamily] || [];
        return this.poseModelCatalog().filter((item: any) => groups.includes(String(item?.group || '')));
    }

    public selectPoseRegistrationFamily(option: any) {
        this.poseRegistrationFamily = String(option?.key || 'custom');
        this.registrationFramework = String(option?.framework || 'Custom');
        this.registrationSource = this.poseRegistrationFamily === 'custom' ? 'custom' : 'official_pretrained';
        this.showAdvancedRegistration = false;
        const first = this.poseVariantsForRegistration()[0];
        if (first) this.selectRegistrationPoseVariant(first);
        else {
            this.poseVariantId = '';
            this.registrationBackbone = '';
        }
        this.service.render();
    }

    public startCustomPoseRegistration() {
        const custom = this.poseRegistrationFamilies().find((item: any) => item.key === 'custom');
        if (custom) this.selectPoseRegistrationFamily(custom);
        this.registrationVariantId = 'custom-pose';
        this.registrationModelName = '';
        this.registrationVersion = 'v1.0';
        this.registrationFramework = 'Custom';
        this.registrationBackbone = 'Custom';
        this.registrationDeveloper = '';
        this.registrationDescription = '';
        this.registrationSource = 'custom';
        this.service.render();
    }

    public selectRegistrationPoseVariant(item: any) {
        this.poseVariantId = String(item?.key || '');
        this.registrationVariantId = this.poseVariantId;
        this.registrationModelName = String(item?.label || this.registrationModelName || '');
        this.registrationBackbone = `${String(item?.group || '')}${item?.size ? `-${item.size}` : ''}`;
        this.registrationFramework = String(item?.adapter || '') === 'mmpose' ? 'MMPose' : 'Ultralytics YOLO';
        this.registrationSource = 'official_pretrained';
        this.service.render();
    }

    private familyForAiKind(option: any): string {
        const installed = new Set(this.families().map((family: any) => String(family?.key || '')));
        const families = Array.isArray(option?.families) ? option.families : [];
        return families.find((family: string) => installed.has(family)) || families[0] || 'rf-fall-v2';
    }

    public filterFamilyOptions(): any[] {
        return [
            { family: 'static-object-filter', label: '정지 사물 필터 v1', description: '장시간 반복 검출되는 정지 사물·마네킹 후보 판정' },
            { family: 'pose-entity-filter', label: '사람/사물 판정 필터 v1', description: 'P2처럼 짧게 잡힌 희소·저신뢰 사람 형태 후보 판정' },
        ];
    }

    public isFilterAiKindSelected(): boolean {
        return this.selectedAiKind === 'filter';
    }

    public selectFilterFamily(family: string) {
        if (!this.filterFamilyOptions().some((item: any) => item.family === family)) return;
        this.uploadFamily = family;
        this.service.render();
    }

    public filterFamilyOptionClass(family: string): string {
        return this.uploadFamily === family
            ? 'border-amber-300 bg-amber-50 text-amber-950 shadow-sm'
            : 'border-zinc-200 bg-white text-zinc-700 hover:border-zinc-300';
    }

    public startNewModelWizard() {
        this.wizardOpen = true;
        this.registrationStep = 1;
        this.registrationSource = 'official_pretrained';
        this.uploadMessage = '';
        const option = this.aiKindOptions().find((item: any) => item.key === 'pose') || this.aiKindOptions()[0];
        this.selectAiKind(option);
        this.service.render();
        setTimeout(() => this.scrollToSection('add-new-model'), 0);
    }

    public closeWizard() {
        this.wizardOpen = false;
        this.service.render();
    }

    public selectAiKind(option: any) {
        this.selectedAiKind = String(option?.key || 'fall');
        this.uploadFamily = this.familyForAiKind(option);
        if (this.selectedAiKind === 'pose') {
            const poseFamily = this.poseRegistrationFamilies().find((item: any) => item.key === this.poseRegistrationFamily)
                || this.poseRegistrationFamilies()[0];
            this.selectPoseRegistrationFamily(poseFamily);
        } else {
            const modelOptions = this.registrationModelOptions(this.selectedAiKind);
            const selected = modelOptions.find((item: any) => item.key === this.registrationVariantId) || modelOptions[0];
            if (selected) this.selectRegistrationModelOption(selected);
        }
        this.service.render();
    }

    public poseModelCatalog(): any[] {
        return Array.isArray(this.registry?.pose_studio?.catalog) ? this.registry.pose_studio.catalog : [];
    }

    public poseTrainingJobs(): any[] {
        return Array.isArray(this.registry?.pose_studio?.jobs) ? this.registry.pose_studio.jobs : [];
    }

    public poseEvaluationJobs(): any[] {
        return Array.isArray(this.registry?.pose_studio?.evaluation_jobs) ? this.registry.pose_studio.evaluation_jobs : [];
    }

    public poseDatasets(): any[] {
        return Array.isArray(this.registry?.pose_studio?.datasets) ? this.registry.pose_studio.datasets : [];
    }

    public poseDatasetSources(): any[] {
        return Array.isArray(this.registry?.pose_studio?.dataset_sources) ? this.registry.pose_studio.dataset_sources : [];
    }

    public readyPoseDatasets(): any[] {
        return this.poseDatasets().filter((item: any) => item?.ready === true);
    }

    public poseCandidates(): any[] {
        return this.allItems().filter((item: any) => String(item?.family || '') === 'pose-backbone' && !String(item?.model_id || '').startsWith('active:'));
    }

    public selectedPoseDataset(): any {
        return this.poseDatasets().find((item: any) => String(item?.dataset_id || '') === this.poseDatasetId) || {};
    }

    public selectPoseDataset(datasetId: string) {
        this.poseDatasetId = String(datasetId || '');
        const item = this.selectedPoseDataset();
        if (item?.manifest_path) this.poseDatasetManifest = String(item.manifest_path);
        this.service.render();
    }

    public openPoseDatasetForm(mode: string = 'zip') {
        this.poseDatasetInputMode = mode === 'path' ? 'path' : 'zip';
        this.poseDatasetFormOpen = true;
        this.poseTrainingMessage = '';
        this.service.render();
    }

    public closePoseDatasetForm() {
        this.poseDatasetFormOpen = false;
        this.poseDatasetZipFile = null;
        this.service.render();
    }

    public selectPoseDatasetInputMode(mode: string) {
        this.poseDatasetInputMode = mode === 'path' ? 'path' : 'zip';
        this.service.render();
    }

    public onPoseDatasetZipSelected(event: any) {
        const file = event?.target?.files?.[0] || null;
        this.poseDatasetZipFile = file;
        if (file && !String(this.poseDatasetName || '').trim()) {
            this.poseDatasetName = String(file.name || 'Custom Dataset').replace(/\.zip$/i, '');
        }
        this.service.render();
    }

    public setModelStudioTab(tab: string) {
        this.modelStudioTab = String(tab || 'library');
        this.service.render();
    }

    public modelStudioTabClass(tab: string): string {
        return this.modelStudioTab === tab
            ? 'border-violet-600 bg-violet-600 text-white shadow-sm'
            : 'border-zinc-200 bg-white text-zinc-600 hover:border-violet-300';
    }

    public async registerPoseDataset() {
        if (this.poseDatasetRegisterBusy) return;
        this.poseDatasetRegisterBusy = true;
        this.poseTrainingMessage = '데이터셋 구조와 COCO-17 label을 검사하고 있습니다.';
        this.poseTrainingMessageType = 'info';
        await this.service.render();
        try {
            let res: any;
            if (this.poseDatasetInputMode === 'zip') {
                if (!this.poseDatasetZipFile) throw new Error('업로드할 ZIP 파일을 선택하세요.');
                const params = new URLSearchParams();
                params.set('name', String(this.poseDatasetName || '').trim());
                params.set('source_type', this.poseDatasetSourceType);
                const form = new FormData();
                form.append('dataset', this.poseDatasetZipFile, this.poseDatasetZipFile.name);
                res = await fetch(`/wiz/api/page.models/upload_pose_dataset?${params.toString()}`, { method: 'POST', body: form });
            } else {
                const params = new URLSearchParams();
                params.set('name', String(this.poseDatasetName || '').trim());
                params.set('source_type', this.poseDatasetSourceType);
                params.set('manifest_path', String(this.poseDatasetManifest || '').trim());
                res = await fetch(`/wiz/api/page.models/register_pose_dataset?${params.toString()}`, { method: 'POST' });
            }
            const json = await this.readJsonResponse(res);
            const payload = this.responsePayload(json);
            if (json.code !== 200) throw new Error(payload?.message || json?.message || '데이터셋 등록 실패');
            this.poseDatasetId = String(payload?.dataset?.dataset_id || '');
            this.poseTrainingMessage = payload?.dataset?.ready
                ? '데이터셋 검증 완료: 학습을 시작할 수 있습니다.'
                : `데이터셋은 등록했지만 학습할 수 없습니다: ${payload?.dataset?.validation?.message || '구조 확인 필요'}`;
            this.poseTrainingMessageType = payload?.dataset?.ready ? 'success' : 'error';
            if (payload?.dataset?.manifest_path) this.poseDatasetManifest = String(payload.dataset.manifest_path);
            if (payload?.dataset?.ready) {
                this.poseDatasetFormOpen = false;
                this.poseDatasetZipFile = null;
            }
            await this.loadRegistry(true);
        } catch (error: any) {
            this.poseTrainingMessage = error?.message || '데이터셋 등록 실패';
            this.poseTrainingMessageType = 'error';
        }
        this.poseDatasetRegisterBusy = false;
        await this.service.render();
    }

    public selectedPoseModel(): any {
        return this.poseModelCatalog().find((item: any) => String(item?.key || '') === this.poseVariantId) || this.poseModelCatalog()[0] || {};
    }

    public selectPoseModel(item: any) {
        this.poseVariantId = String(item?.key || 'yolo11n-pose');
        this.service.render();
    }

    public poseModelCardClass(item: any): string {
        return String(item?.key || '') === this.poseVariantId
            ? 'border-sky-300 bg-sky-50 shadow-sm'
            : 'border-zinc-200 bg-white hover:border-zinc-300';
    }

    public poseTrainingStatusClass(job: any): string {
        const status = String(job?.status || '').toLowerCase();
        if (status === 'completed') return 'bg-emerald-100 text-emerald-700';
        if (status === 'failed') return 'bg-rose-100 text-rose-700';
        if (status === 'running') return 'bg-sky-100 text-sky-700';
        if (status === 'blocked') return 'bg-amber-100 text-amber-700';
        return 'bg-zinc-100 text-zinc-600';
    }

    public poseTrainingStatusText(job: any): string {
        const status = String(job?.status || '').toLowerCase();
        if (status === 'completed') return '학습 완료';
        if (status === 'failed') return '학습 실패';
        if (status === 'running') return String(job?.stage || '') === 'evaluating' ? '자동 평가 중' : '학습 중';
        if (status === 'blocked') return '검증 차단';
        return '대기';
    }

    public poseMetric(job: any, key: string): string {
        const value = Number(job?.pose_evaluation?.metrics?.[key] ?? job?.metrics?.[key] ?? job?.report?.candidate?.[key]);
        return Number.isFinite(value) ? `${(value * 100).toFixed(1)}%` : '-';
    }

    public poseFallMetric(job: any, key: string): string {
        const report = job?.report?.candidate || job?.summary?.fall_e2e?.candidate || {};
        const direct = Number(report?.[key]);
        if (Number.isFinite(direct)) return `${(direct * 100).toFixed(1)}%`;
        if (key === 'false_alarm_rate') {
            const denominator = Number(report?.tn || 0) + Number(report?.fp || 0);
            return denominator > 0 ? `${(Number(report?.fp || 0) / denominator * 100).toFixed(1)}%` : '-';
        }
        if (key === 'miss_detection_rate') {
            const denominator = Number(report?.tp || 0) + Number(report?.fn || 0);
            return denominator > 0 ? `${(Number(report?.fn || 0) / denominator * 100).toFixed(1)}%` : '-';
        }
        return '-';
    }

    public poseInferenceText(job: any): string {
        const value = Number(job?.report?.candidate?.inference_ms ?? job?.summary?.fall_e2e?.candidate?.inference_ms);
        return Number.isFinite(value) && value > 0 ? `${value.toFixed(1)}ms` : '-';
    }

    public poseJobProgress(job: any): number {
        const value = Number(job?.progress || 0);
        return Math.max(0, Math.min(100, Number.isFinite(value) ? value * 100 : 0));
    }

    public poseEtaText(job: any): string {
        const seconds = Number(job?.eta_sec);
        if (!Number.isFinite(seconds) || seconds <= 0) return '-';
        const minutes = Math.ceil(seconds / 60);
        return minutes < 60 ? `약 ${minutes}분` : `약 ${Math.floor(minutes / 60)}시간 ${minutes % 60}분`;
    }

    public poseGpuText(job: any): string {
        const value = Number(job?.gpu?.utilization_pct);
        if (Number.isFinite(value)) return `${value.toFixed(0)}%`;
        return String(job?.gpu?.name || job?.device || '-');
    }

    public poseLatestMapText(job: any): string {
        const rows = Array.isArray(job?.history) ? job.history : [];
        const value = Number(rows.length ? rows[rows.length - 1]?.map50 : job?.metrics?.map50);
        return Number.isFinite(value) ? `${(value * 100).toFixed(1)}%` : '-';
    }

    public latestPoseJob(): any {
        return this.poseTrainingJobs()[0] || {};
    }

    public poseJobHistory(job: any): any[] {
        const rows = Array.isArray(job?.history) ? job.history : [];
        return rows.slice(-12);
    }

    public startPoseRegistration(item?: any) {
        this.selectedAiKind = 'pose';
        this.uploadFamily = 'pose-backbone';
        if (item?.group) {
            const group = String(item.group).toLowerCase();
            this.poseRegistrationFamily = group.startsWith('yolo') ? 'yolo-pose'
                : (group === 'rtmpose' ? 'rtmpose' : (group === 'vitpose' ? 'vitpose' : (group === 'hrnet' ? 'hrnet' : (group === 'rtmo' ? 'rtmo' : 'custom'))));
        }
        this.startNewModelWizard();
        if (item?.key) this.selectRegistrationPoseVariant(item);
    }

    public showPoseComparison() {
        this.modelStudioTab = 'comparison';
        this.familyFilter = 'pose-backbone';
        this.service.render();
    }

    public poseComparisonRows(): any[] {
        const rows = Array.isArray(this.registry?.comparison?.rows) ? this.registry.comparison.rows : [];
        return this.sortComparisonRows(rows.filter((row: any) => String(row?.family || '') === 'pose-backbone'));
    }

    public poseComparisonMetric(row: any, key: string): number {
        const value = Number(row?.[key] ?? row?.metrics?.[key]);
        return Number.isFinite(value) ? value : 0;
    }

    public poseComparisonMetricText(row: any, key: string): string {
        const value = this.poseComparisonMetric(row, key);
        if (key === 'inference_ms') return value > 0 ? `${value.toFixed(1)}ms` : '-';
        if (key === 'fps') return value > 0 ? value.toFixed(1) : '-';
        return value > 0 ? `${(value * 100).toFixed(1)}%` : '-';
    }

    public poseComparisonBarWidth(row: any, key: string): number {
        const rows = this.poseComparisonRows();
        const best = Math.max(...rows.map((item: any) => this.poseComparisonMetric(item, key)), 0.01);
        return Math.max(3, Math.min(100, this.poseComparisonMetric(row, key) / best * 100));
    }

    public activePoseModel(): any {
        return this.poseComparisonRows().find((row: any) => row?.active || String(row?.source || '').toLowerCase() === 'active') || {};
    }

    public poseDeploymentHistory(): any[] {
        return Array.isArray(this.registry?.pose_studio?.deployment_history) ? this.registry.pose_studio.deployment_history : [];
    }

    public poseModelNameById(modelId: string): string {
        if (!String(modelId || '')) return '기본 Pose 모델';
        const row = this.poseComparisonRows().find((item: any) => String(item?.model_id || '') === String(modelId));
        return row ? this.comparisonDisplayName(row) : String(modelId);
    }

    public async rollbackPoseModel() {
        if (this.poseRollbackBusy || this.registry?.pose_studio?.rollback_available !== true) return;
        const confirmed = await this.service.modal.show({
            title: 'Pose 모델 Rollback',
            message: '직전 운영 Pose 모델로 되돌리시겠습니까? 이전 모델도 현재 검증 gate를 다시 통과해야 합니다.',
            action: 'Rollback',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning',
        });
        if (!confirmed) return;
        this.poseRollbackBusy = true;
        await this.service.render();
        try {
            const params = new URLSearchParams();
            params.set('family', 'pose-backbone');
            const res = await fetch(`/wiz/api/page.models/rollback_runtime_model_selection?${params.toString()}`, { method: 'POST' });
            const json = await this.readJsonResponse(res);
            const payload = this.responsePayload(json);
            if (json.code !== 200) throw new Error(payload?.message || json?.message || 'Pose 모델 Rollback 실패');
            this.poseTrainingMessage = '직전 운영 Pose 모델로 Rollback했습니다.';
            this.poseTrainingMessageType = 'success';
            await this.loadRegistry(true);
        } catch (error: any) {
            this.poseTrainingMessage = error?.message || 'Pose 모델 Rollback 실패';
            this.poseTrainingMessageType = 'error';
        }
        this.poseRollbackBusy = false;
        await this.service.render();
    }

    public async rollbackModelFamily(family: string) {
        family = String(family || '');
        if (!family || this.rollingBackFamily || !this.canRollbackFamily(family)) return;
        const confirmed = await this.service.modal.show({
            title: '이전 버전으로 Rollback',
            message: '직전에 운영하던 검증 완료 모델로 되돌립니다. 서버가 호환성과 평가 조건을 다시 확인합니다.',
            action: 'Rollback',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning',
        });
        if (!confirmed) return;
        this.rollingBackFamily = family;
        await this.service.render();
        try {
            const params = new URLSearchParams({ family });
            const res = await fetch(`/wiz/api/page.models/rollback_runtime_model_selection?${params.toString()}`, { method: 'POST' });
            const json = await this.readJsonResponse(res);
            const payload = this.responsePayload(json);
            if (json.code !== 200) throw new Error(payload?.message || json?.message || 'Rollback 실패');
            this.uploadMessage = '이전 운영 모델로 Rollback했습니다.';
            this.uploadMessageType = 'success';
            await this.loadRegistry(true);
        } catch (error: any) {
            this.uploadMessage = error?.message || 'Rollback 실패';
            this.uploadMessageType = 'error';
        }
        this.rollingBackFamily = '';
        await this.service.render();
    }

    public async deployManagementModel(item: any) {
        const management = this.managementInfo(item);
        const family = String(item?.family || '');
        const modelId = String(item?.model_id || '');
        if (!family || !modelId || management?.deployable !== true || this.deployingModelId) return;
        const confirmed = await this.service.modal.show({
            title: '검증 모델 운영 적용',
            message: `${this.managementModelName(item)}을 운영 모델로 변경하시겠습니까? 서버에서 Compatibility PASS와 Evaluation PASS를 다시 확인합니다.`,
            action: 'Deploy',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning',
        });
        if (!confirmed) return;
        this.deployingModelId = modelId;
        await this.service.render();
        try {
            const params = new URLSearchParams({ family, model_id: modelId });
            const res = await fetch(`/wiz/api/page.models/set_runtime_model_selection?${params.toString()}`, { method: 'POST' });
            const json = await this.readJsonResponse(res);
            const payload = this.responsePayload(json);
            if (json.code !== 200) throw new Error(payload?.message || json?.message || 'Deploy 실패');
            this.uploadMessage = `${this.managementModelName(item)}을 운영 모델로 적용했습니다.`;
            this.uploadMessageType = 'success';
            await this.loadRegistry(true);
        } catch (error: any) {
            this.uploadMessage = error?.message || 'Deploy 실패';
            this.uploadMessageType = 'error';
        }
        this.deployingModelId = '';
        await this.service.render();
    }

    public deployPoseModel(item: any) {
        if (!item?.model_id || item?.selectable !== true || this.applyBusy) return;
        const current = this.activePoseModel();
        if (!current?.model_id || String(current.model_id) === String(item.model_id)) return;
        this.familyFilter = 'pose-backbone';
        this.leftComparisonModelId = String(current.model_id);
        this.rightComparisonModelId = String(item.model_id);
        this.applyConfirmOpen = true;
        this.service.render();
    }

    public scrollToSection(id: string) {
        if (typeof document === 'undefined') return;
        document.getElementById(String(id || ''))?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    public async startPoseTraining() {
        if (this.poseTrainingBusy) return;
        const selected = this.selectedPoseModel();
        if (!selected?.training_supported) {
            this.poseTrainingMessage = selected?.training_note || '이 모델의 사이트 학습 어댑터가 준비되지 않았습니다.';
            this.poseTrainingMessageType = 'error';
            await this.service.render();
            return;
        }
        this.poseTrainingBusy = true;
        this.poseTrainingMessage = '학습 시작 조건을 확인하는 중입니다.';
        this.poseTrainingMessageType = 'info';
        await this.service.render();
        try {
            const params = new URLSearchParams();
            params.set('variant_id', this.poseVariantId);
            params.set('dataset_manifest', String(this.poseDatasetManifest || '').trim());
            params.set('epochs', String(this.poseTrainingEpochs || 100));
            params.set('imgsz', String(this.poseTrainingImageSize || 640));
            params.set('batch', String(this.poseTrainingBatch || 16));
            params.set('lr0', String(this.poseTrainingLearningRate || 0.001));
            params.set('optimizer', String(this.poseTrainingOptimizer || 'AdamW'));
            params.set('device', String(this.poseTrainingDevice || 'auto'));
            params.set('workers', String(this.poseTrainingWorkers || 2));
            params.set('note', 'Model Center Pose Studio 수동 학습 요청');
            const res = await fetch(`/wiz/api/page.models/start_pose_model_training?${params.toString()}`, { method: 'POST' });
            const json = await this.readJsonResponse(res);
            const payload = this.responsePayload(json);
            if (json.code !== 200) throw new Error(payload?.message || json?.message || 'Pose 모델 학습 시작 실패');
            this.poseTrainingMessage = `${selected?.label || this.poseVariantId} 학습을 시작했습니다. 완료 후 후보가 보관함과 비교 화면에 자동 등록됩니다.`;
            this.poseTrainingMessageType = 'success';
            await this.loadRegistry(true);
        } catch (error: any) {
            this.poseTrainingMessage = error?.message || 'Pose 모델 학습 시작 실패';
            this.poseTrainingMessageType = 'error';
        }
        this.poseTrainingBusy = false;
        await this.service.render();
    }

    public async startPoseEvaluation() {
        if (this.poseEvaluationBusy) return;
        this.poseEvaluationBusy = true;
        this.poseTrainingMessage = '낙상 benchmark 실행 조건을 확인하고 있습니다.';
        this.poseTrainingMessageType = 'info';
        await this.service.render();
        try {
            const params = new URLSearchParams();
            params.set('model_id', this.poseBenchmarkModelId);
            params.set('benchmark_manifest', String(this.poseBenchmarkManifest || '').trim());
            const res = await fetch(`/wiz/api/page.models/start_pose_model_evaluation?${params.toString()}`, { method: 'POST' });
            const json = await this.readJsonResponse(res);
            const payload = this.responsePayload(json);
            if (json.code !== 200) throw new Error(payload?.message || json?.message || '낙상 E2E 평가 시작 실패');
            this.poseTrainingMessage = '현재 Pose와 후보 Pose의 paired 낙상 E2E 평가를 시작했습니다.';
            this.poseTrainingMessageType = 'success';
            await this.loadRegistry(true);
        } catch (error: any) {
            this.poseTrainingMessage = error?.message || '낙상 E2E 평가 시작 실패';
            this.poseTrainingMessageType = 'error';
        }
        this.poseEvaluationBusy = false;
        await this.service.render();
    }

    public canContinueRegistration(): boolean {
        if (this.registrationStep === 1) {
            return !!this.selectedAiKind && (
                this.selectedAiKind === 'pose'
                    ? !!this.poseRegistrationFamily
                    : !!this.registrationVariantId
            );
        }
        if (this.registrationStep === 2) {
            return !!String(this.registrationModelName || '').trim()
                && !!String(this.registrationVersion || '').trim()
                && !!String(this.registrationFramework || '').trim()
                && !!String(this.registrationBackbone || '').trim();
        }
        if (this.registrationStep === 3) {
            return this.uploadFileChecks().filter((check: any) => check.required).every((check: any) => check.ok);
        }
        return true;
    }

    public nextRegistrationStep() {
        if (!this.canContinueRegistration()) return;
        this.registrationStep = Math.min(4, this.registrationStep + 1);
        this.service.render();
    }

    public previousRegistrationStep() {
        this.registrationStep = Math.max(1, this.registrationStep - 1);
        this.service.render();
    }

    public onUploadDragOver(event: DragEvent) {
        event.preventDefault();
    }

    public onUploadDrop(event: DragEvent) {
        event.preventDefault();
        this.uploadFiles = Array.from(event.dataTransfer?.files || []) as File[];
        this.uploadMessage = '';
        this.service.render();
    }

    public uploadFileChecks(): any[] {
        const names = this.uploadFiles.map(file => this.displayName(file).toLowerCase());
        const framework = String(this.registrationFramework || '').toLowerCase();
        const checkpoint = (extensions: string[]) => names.some(name => extensions.some(ext => name.endsWith(ext)));
        const summary = names.some(name => name.endsWith('training_summary.json'));
        const customOnnx = this.registrationSource === 'custom' && checkpoint(['.onnx']);
        if (this.registrationSource === 'custom') {
            return [
                { label: '모델 파일', required: true, ok: checkpoint(['.pkl', '.joblib', '.pt', '.pth', '.onnx', '.bin']) },
                { label: customOnnx ? 'fallai_adapter.json' : '입력·출력 설정', required: customOnnx, ok: customOnnx ? names.some(name => name.endsWith('fallai_adapter.json')) : names.some(name => /\.(py|yaml|yml|json)$/.test(name)) },
                { label: '학습 결과', required: false, ok: summary || names.some(name => /\.(csv|log)$/.test(name)) },
            ];
        }
        if (this.selectedAiKind === 'fall') {
            return [
                { label: '낙상 모델 .pkl / .joblib', required: true, ok: checkpoint(['.pkl', '.joblib']) },
                { label: 'training_summary.json', required: false, ok: summary },
            ];
        }
        if (this.selectedAiKind === 'object') {
            return [
                { label: 'Detection 모델 .pt / .onnx', required: true, ok: checkpoint(['.pt', '.onnx']) },
                { label: 'Dataset / Class 정보', required: false, ok: names.some(name => /\.(yaml|yml|json)$/.test(name)) },
                { label: '학습 결과', required: false, ok: summary || names.some(name => name.endsWith('results.csv')) },
            ];
        }
        if (this.selectedAiKind === 'face') {
            return [
                { label: '얼굴 분석 모델 .pt / .pth / .onnx', required: true, ok: checkpoint(['.pt', '.pth', '.onnx']) },
                { label: '클래스 / 전처리 정보', required: false, ok: names.some(name => /\.(yaml|yml|json)$/.test(name)) },
                { label: '학습 결과', required: false, ok: summary || names.some(name => /\.(csv|log)$/.test(name)) },
            ];
        }
        if (framework.includes('mmpose')) {
            return [
                { label: '모델 파일 · checkpoint.pth', required: true, ok: checkpoint(['.pth']) },
                { label: '추가 파일', required: false, ok: names.some(name => /\.(csv|yaml|yml|json|log)$/.test(name)) },
            ];
        }
        if (framework.includes('yolo') || framework.includes('ultralytics')) {
            return [
                { label: `모델 파일 · ${this.registrationSource === 'official_pretrained' ? '공식 checkpoint.pt' : 'best.pt'}`, required: true, ok: checkpoint(['.pt']) },
                { label: '추가 파일', required: false, ok: summary || names.some(name => /\.(csv|yaml|yml|json|log)$/.test(name)) },
            ];
        }
        return [{ label: '실제 checkpoint', required: true, ok: checkpoint(['.pkl', '.joblib', '.pt', '.pth', '.onnx', '.bin']) }];
    }

    public uploadFileCheckStatus(check: any): string {
        if (check?.ok) return '확인됨';
        return check?.required ? '필요' : '없어도 등록 가능';
    }

    public canRegisterSelectedModels(): boolean {
        return this.uploadFiles.length > 0
            && this.uploadFileChecks().filter((check: any) => check.required).every((check: any) => check.ok)
            && !!String(this.registrationModelName || '').trim()
            && !!String(this.registrationVersion || '').trim();
    }

    public async importOfficialPretrained() {
        if (!this.officialPretrainedAvailable() || this.officialImportBusy || this.uploading) return;
        this.officialImportBusy = true;
        this.uploadMessage = `${this.officialCheckpointName()} 공식 가중치를 가져오는 중입니다.`;
        this.uploadMessageType = 'info';
        await this.service.render();
        try {
            const label = this.registrationModelName || this.selectedPoseCatalogItem()?.label || this.poseVariantId;
            const metadata = {
                registration_source: 'official_pretrained',
                model_type: 'pose',
                model_name: label,
                model_version: this.registrationVersion || 'pretrained',
                framework: 'Ultralytics YOLO',
                developer: this.registrationDeveloper || 'Ultralytics',
                description: this.registrationDescription || 'Ultralytics 공식 COCO-17 사전학습 Pose checkpoint',
                pose_family: 'yolo-pose',
                pose_variant_id: this.poseVariantId,
                model_variant: this.poseVariantId,
                keypoint_schema: 'coco17',
                pipeline_contract_version: 'fallai-pose-v1',
            };
            const form = new FormData();
            form.append('family', 'pose-backbone');
            form.append('label', label);
            form.append('metadata', JSON.stringify(metadata));
            const res = await fetch('/wiz/api/page.models/upload_model_asset', { method: 'POST', body: form });
            const json = await this.readJsonResponse(res);
            const payload = this.responsePayload(json);
            if (json.code !== 200) throw new Error(payload?.message || json?.message || '공식 가중치 등록 실패');
            this.lastRegisteredLabel = this.registrationModelName || this.selectedPoseCatalogItem()?.label || this.poseVariantId;
            this.lastRegisteredModelId = String(payload?.model_id || '');
            this.compatibilityModelId = this.lastRegisteredModelId;
            this.registrationStep = 4;
            this.uploadMessage = `공식 사전학습 모델 등록 완료: ${this.lastRegisteredLabel}`;
            this.uploadMessageType = 'success';
            await this.loadRegistry();
        } catch (error: any) {
            this.uploadMessage = error?.message || '공식 가중치 등록 실패';
            this.uploadMessageType = 'error';
        }
        this.officialImportBusy = false;
        await this.service.render();
    }

    private uploadCombinedNote(): string {
        const bits = [];
        if (this.registrationDescription.trim()) bits.push(`설명: ${this.registrationDescription.trim()}`);
        if (this.registrationDeveloper.trim()) bits.push(`개발자: ${this.registrationDeveloper.trim()}`);
        if (this.uploadNote.trim()) bits.push(`메모: ${this.uploadNote.trim()}`);
        return bits.join('\n');
    }

    public goCompareAfterUpload() {
        this.wizardOpen = false;
        this.familyFilter = this.uploadFamily || 'all';
        this.service.render();
    }

    private findActiveItemByFamilies(families: string[]): any {
        for (const family of families) {
            const composition = this.runtimeCompositionRows().find((row: any) => String(row?.family || '').trim() === family);
            const effectiveModelId = String(composition?.effective_model_id || '').trim();
            if (!effectiveModelId) continue;
            const effectiveItem = this.allItems().find((item: any) => String(item?.model_id || '').trim() === effectiveModelId);
            if (effectiveItem) return effectiveItem;
        }
        const rows = this.allItems().filter((item: any) => {
            return families.includes(this.modelFamily(item)) && this.isAppliedArchiveItem(item);
        });
        return this.pipelineSortedItems(rows)[0] || {};
    }

    private cleanInternalName(value: any, fallback: string = '모델'): string {
        const raw = String(value || '').trim();
        if (!raw) return fallback;
        return raw
            .replace(/RF-Dual\s*통합/gi, '통합 모델')
            .replace(/RF-Pipeline/gi, '낙상 감지 모델')
            .replace(/RF-Fall/gi, '낙상 감지 모델')
            .replace(/XG-Posture/gi, '자세 분석 모델')
            .replace(/Environment\s*Agent/gi, '환경 위험 분석 모델')
            .replace(/AI-Hub\s*82/gi, '표정 분석 모델')
            .replace(/AI-Hub\s*173/gi, '상태 분석 모델')
            .replace(/\bcandidate\b/gi, '시험 중')
            .replace(/\bactive\b/gi, '현재 사용 중');
    }

    private isCompatibilityFallArtifact(item: any): boolean {
        const status = String(item?.summary?.operational_status || '').trim();
        return this.modelFamily(item) === 'rf-fall-v2' && status.startsWith('compatibility_artifact_active');
    }

    private eligibleRfFallCandidate(): any {
        const rows = this.allItems().filter((item: any) => {
            const summary = item?.summary || {};
            return this.modelFamily(item) === 'rf-fall-v2'
                && String(item?.source || '').toLowerCase() === 'candidate'
                && (summary?.candidate_eligible === true || summary?.eligible === true);
        });
        return [...rows].sort((a: any, b: any) => {
            return this.parseTimestampMs(b?.artifact_updated_at || b?.updated_at || b?.created_at)
                - this.parseTimestampMs(a?.artifact_updated_at || a?.updated_at || a?.created_at);
        })[0] || {};
    }

    public hasFallCompatibilityRisk(): boolean {
        return this.isCompatibilityFallArtifact(this.activeFallDecisionItem());
    }

    public fallCompatibilityRiskText(): string {
        return '현재 기본 최종 판단기 RF-Fall v2는 원본 학습 파일 유실 뒤 만든 임시 호환 복구본입니다. 카드의 1,592건·F1 93.02%·Recall 95.40%는 과거 best-recorded 복구 메타데이터이며, 현재 로드된 바이너리를 그 검증셋으로 다시 평가한 결과가 아닙니다.';
    }

    public fallCompatibilityCandidateText(): string {
        const candidate = this.eligibleRfFallCandidate();
        if (!candidate?.model_id) {
            return '실데이터 재학습 후보를 같은 독립 holdout에서 현재 emergency repair와 직접 비교하고, 설치 각도·저조도·짧은 실시간 청크·후처리 포함 E2E를 통과한 뒤 명시적으로 승격해야 합니다.';
        }
        const summary = candidate?.summary || {};
        const validation = summary?.validation || {};
        const jobId = String(summary?.candidate_job_id || summary?.job_id || candidate?.label || '후보').trim();
        const samples = Number(summary?.training_samples || candidate?.metrics?.sample_count || 0);
        const groups = Number(summary?.group_count || 0);
        const f1 = Number(validation?.f1 ?? summary?.f1 ?? candidate?.metrics?.f1 ?? 0);
        const recall = Number(validation?.recall ?? summary?.recall ?? candidate?.metrics?.recall ?? 0);
        const bits = [
            jobId,
            samples > 0 ? `${samples.toLocaleString()}건` : '',
            groups > 0 ? `${groups.toLocaleString()}그룹` : '',
            f1 > 0 ? `F1 ${(f1 * 100).toFixed(2)}%` : '',
            recall > 0 ? `Recall ${(recall * 100).toFixed(2)}%` : '',
        ].filter(Boolean);
        return `실데이터 후보 ${bits.join(' · ')}가 승격 대기 중입니다. 00015 C2/C3 원본은 각 600프레임으로 복구·SHA-256 고정됐지만 annotation과 현재/후보 paired E2E가 아직 완료되지 않았습니다. 짧은 청크·설치 각도·저조도·후처리 포함 독립 holdout을 모두 통과한 뒤 명시 적용해야 합니다.`;
    }

    public promotionHoldoutStatus(): any {
        return this.registry?.promotion_holdout || {};
    }

    public promotionHoldoutBuckets(): any[] {
        return Array.isArray(this.promotionHoldoutStatus()?.buckets)
            ? this.promotionHoldoutStatus().buckets
            : [];
    }

    public promotionHoldoutReady(): boolean {
        return this.promotionHoldoutStatus()?.promotion_evidence_ready === true;
    }

    public promotionHoldoutStatusText(): string {
        const status = this.promotionHoldoutStatus();
        const candidate = String(status?.candidate_id || 'candidate:rf-fall-v2:20260711172011-f4aea744');
        if (status?.promotion_evidence_ready === true) {
            return `${candidate}가 B1~B8 버킷별 기준을 모두 통과했습니다. 자동 적용은 하지 않으며 명시 승격 검토가 필요합니다.`;
        }
        return `${candidate}는 00015 C2/C3 원본을 각 600프레임으로 복구·SHA-256 고정했지만 annotation과 확장 버킷이 미완료라 paired E2E와 승격이 차단돼 있습니다. 현재 303건 성능만으로 운영 적용하지 않습니다.`;
    }

    public promotionReviewQueue(): any {
        return this.promotionHoldoutStatus()?.review_queue || {};
    }

    public promotionReviewBucketOptions(): any[] {
        const summary = this.promotionReviewQueue()?.summary?.buckets || {};
        const progress = this.promotionReviewQueue()?.bucket_progress || {};
        const priorities: any = { B1: 5, B4: 5, B3: 4, B7: 2 };
        return ['B1', 'B4', 'B3', 'B7', 'B5', 'B6'].map((bucket: string) => ({
            id: bucket,
            count: Number(summary?.[bucket]?.candidate_count || 0),
            priority: Number(priorities[bucket] || 0),
            progress: progress?.[bucket] || { total: 0, approved: 0, rejected: 0, remaining: 0, percent: 0 },
        }));
    }

    public promotionReviewCandidates(): any[] {
        const queue = this.promotionReviewQueue();
        const ids = new Set<string>(Array.isArray(queue?.buckets?.[this.promotionReviewBucket])
            ? queue.buckets[this.promotionReviewBucket]
            : []);
        const rows = Array.isArray(queue?.candidates) ? queue.candidates : [];
        return rows.filter((row: any) => {
            const status = String(row?.review_status || 'pending');
            return ids.has(String(row?.candidate_id || ''))
                && (this.promotionReviewStatusFilter === 'all' || status === this.promotionReviewStatusFilter);
        });
    }

    public selectPromotionReviewBucket(bucket: string): void {
        this.promotionReviewBucket = bucket;
        this.promotionReviewCandidateId = '';
        this.promotionReviewSelectedIds = [];
    }

    public setPromotionReviewStatusFilter(status: string): void {
        this.promotionReviewStatusFilter = status;
        this.promotionReviewCandidateId = '';
        this.promotionReviewSelectedIds = [];
    }

    public selectPromotionReviewCandidate(candidateId: string): void {
        this.promotionReviewCandidateId = String(candidateId || '');
    }

    public selectedPromotionReviewCandidate(): any {
        return this.promotionReviewCandidates().find((row: any) => {
            return String(row?.candidate_id || '') === this.promotionReviewCandidateId;
        }) || null;
    }

    public promotionReviewVideoUrl(): string {
        const candidateId = String(this.selectedPromotionReviewCandidate()?.candidate_id || '');
        return candidateId
            ? `/wiz/api/page.models/promotion_holdout_review_video?candidate_id=${encodeURIComponent(candidateId)}`
            : '';
    }

    public promotionReviewActionLabel(actionType: string): string {
        const labels: any = {
            rapid_fall: '급락 낙상 후보',
            general_fall: '일반 낙상 후보',
            fast_normal_sit: '빠른 정상 앉기 후보',
            lying: '눕기 후보',
            object_pickup: '물건 줍기 후보',
            other_normal: '기타 정상 행동 후보',
        };
        return labels[String(actionType || '')] || '행동 확인 필요';
    }

    public promotionReviewIlluminationLabel(row: any): string {
        if (row?.illumination === 'low_light_candidate') return `저조도 후보 · p10 ${Number(row?.luma_p10 || 0).toFixed(1)}`;
        if (row?.illumination === 'normal_light_candidate') return `일반 조도 후보 · p10 ${Number(row?.luma_p10 || 0).toFixed(1)}`;
        return '조도 확인 필요';
    }

    public promotionReviewStatusLabel(status: string): string {
        const labels: any = { pending: 'Pending', approved: 'Approved', rejected: 'Rejected' };
        return labels[String(status || 'pending')] || 'Pending';
    }

    public promotionReviewStatusClass(status: string): string {
        if (status === 'approved') return 'bg-emerald-100 text-emerald-700';
        if (status === 'rejected') return 'bg-rose-100 text-rose-700';
        return 'bg-amber-100 text-amber-700';
    }

    public promotionReviewPriorityStars(bucket: any): string {
        const value = Number(bucket?.priority || 0);
        return value > 0 ? '★'.repeat(value) + '☆'.repeat(5 - value) : '우선순위 미지정';
    }

    public promotionReviewRejectReasons(): string[] {
        const reasons = this.promotionReviewQueue()?.reject_reasons;
        return Array.isArray(reasons) ? reasons : [
            '사람 미검출', 'Track 단절', 'Camera shake', 'Occlusion',
            '급락 불명', 'Annotation 불일치', '조도 불량', '기타',
        ];
    }

    public promotionReviewIsSelected(candidateId: string): boolean {
        return this.promotionReviewSelectedIds.includes(String(candidateId || ''));
    }

    public togglePromotionReviewSelection(candidateId: string, checked: boolean): void {
        const id = String(candidateId || '');
        const selected = new Set(this.promotionReviewSelectedIds);
        if (checked) selected.add(id); else selected.delete(id);
        this.promotionReviewSelectedIds = Array.from(selected);
    }

    public selectAllVisiblePromotionReviewCandidates(): void {
        this.promotionReviewSelectedIds = this.promotionReviewCandidates().map((row: any) => String(row.candidate_id));
    }

    public clearPromotionReviewSelection(): void {
        this.promotionReviewSelectedIds = [];
    }

    public promotionReviewSelectionIds(): string[] {
        if (this.promotionReviewSelectedIds.length) return [...this.promotionReviewSelectedIds];
        return this.promotionReviewCandidateId ? [this.promotionReviewCandidateId] : [];
    }

    public promotionReviewCanApproveSelection(): boolean {
        const ids = this.promotionReviewSelectionIds();
        const rows = Array.isArray(this.promotionReviewQueue()?.candidates) ? this.promotionReviewQueue().candidates : [];
        return ids.length > 0 && ids.every((candidateId: string) => {
            const row = rows.find((item: any) => String(item?.candidate_id || '') === candidateId);
            const checklist = row?.checklist || {};
            return this.promotionReviewChecklistItems().every((item: any) => checklist?.[item.key] === true);
        });
    }

    public async submitPromotionReview(action: 'approved' | 'rejected'): Promise<void> {
        const ids = this.promotionReviewSelectionIds();
        if (!ids.length || this.promotionReviewBusy) {
            this.promotionReviewMessage = '검수할 후보를 선택해주세요.';
            this.promotionReviewMessageType = 'error';
            return;
        }
        const reviewer = String(this.promotionReviewReviewer || '').replace(/\s+/g, ' ').trim().slice(0, 40);
        if (!reviewer) {
            this.promotionReviewMessage = '검수자 이름을 입력해주세요.';
            this.promotionReviewMessageType = 'error';
            return;
        }
        if (action === 'rejected' && !this.promotionReviewRejectReason) {
            this.promotionReviewMessage = '일괄 반려 사유를 선택해주세요.';
            this.promotionReviewMessageType = 'error';
            return;
        }
        try { localStorage.setItem('fallai-promotion-reviewer', reviewer); } catch (_e) { }
        const previousId = this.promotionReviewCandidateId;
        this.promotionReviewBusy = true;
        this.promotionReviewMessage = '검수 결과 저장 중입니다.';
        this.promotionReviewMessageType = 'info';
        await this.service.render();
        try {
            const params = new URLSearchParams();
            params.set('candidate_ids', JSON.stringify(ids));
            params.set('action', action);
            params.set('reviewer', reviewer);
            params.set('reject_reason', action === 'rejected' ? this.promotionReviewRejectReason : '');
            const response = await fetch(`/wiz/api/page.models/promotion_holdout_review_batch?${params.toString()}`, { method: 'POST' });
            const json = await this.readJsonResponse(response);
            const payload = this.responsePayload(json);
            if (json.code !== 200) throw new Error(payload?.message || json?.message || '검수 결과 저장 실패');
            this.promotionReviewMessage = `${ids.length}개 후보를 ${action === 'approved' ? '승인' : '반려'}했습니다.`;
            this.promotionReviewMessageType = 'success';
            this.promotionReviewSelectedIds = [];
            await this.loadRegistry(true);
            if (this.promotionReviewAutoNext) this.openNextPendingPromotionReviewCandidate(previousId);
        } catch (error: any) {
            this.promotionReviewMessage = error?.message || '검수 결과 저장 실패';
            this.promotionReviewMessageType = 'error';
        }
        this.promotionReviewBusy = false;
        await this.service.render();
    }

    private openNextPendingPromotionReviewCandidate(previousId: string): void {
        const queue = this.promotionReviewQueue();
        const bucketIds = Array.isArray(queue?.buckets?.[this.promotionReviewBucket])
            ? queue.buckets[this.promotionReviewBucket].map((value: any) => String(value)) : [];
        const rows = Array.isArray(queue?.candidates) ? queue.candidates : [];
        const pendingIds = bucketIds.filter((candidateId: string) => {
            const row = rows.find((item: any) => String(item?.candidate_id || '') === candidateId);
            return String(row?.review_status || 'pending') === 'pending';
        });
        if (!pendingIds.length) {
            this.promotionReviewCandidateId = '';
            return;
        }
        const previousIndex = bucketIds.indexOf(String(previousId || ''));
        this.promotionReviewCandidateId = pendingIds.find((candidateId: string) => bucketIds.indexOf(candidateId) > previousIndex)
            || pendingIds[0];
        if (this.promotionReviewStatusFilter !== 'pending') this.promotionReviewStatusFilter = 'pending';
    }

    public seekPromotionReviewFrame(kind: 'start' | 'impact' | 'end'): void {
        const row = this.selectedPromotionReviewCandidate();
        const fps = Number(row?.video_fps || 0);
        const frame = kind === 'start'
            ? row?.fall_start_frame
            : (kind === 'impact' ? row?.impact_frame : (row?.stable_end_frame ?? row?.fall_end_frame));
        if (!Number.isFinite(Number(frame)) || fps <= 0) return;
        const video: any = document.getElementById('promotion-review-video');
        if (video) {
            video.currentTime = Math.max(0, Number(frame) / fps);
            video.play?.().catch?.(() => undefined);
        }
    }

    public promotionReviewHasFrame(kind: 'start' | 'impact' | 'end'): boolean {
        const row = this.selectedPromotionReviewCandidate();
        const frame = kind === 'start'
            ? row?.fall_start_frame
            : (kind === 'impact' ? row?.impact_frame : (row?.stable_end_frame ?? row?.fall_end_frame));
        return Number.isFinite(Number(frame)) && Number(row?.video_fps || 0) > 0;
    }

    public promotionReviewEtaLabel(): string {
        const eta = this.promotionReviewQueue()?.eta || {};
        if (!eta.measured) return '2건 이상 검수하면 ETA를 계산합니다.';
        const seconds = Number(eta.remaining_seconds || 0);
        if (seconds <= 0) return '검수 완료';
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.max(1, Math.ceil((seconds % 3600) / 60));
        return hours > 0 ? `현재 속도로 약 ${hours}시간 ${minutes}분` : `현재 속도로 약 ${minutes}분`;
    }

    public promotionReviewTimelineMarkers(): any[] {
        return [
            { key: 'fall_start_frame', label: 'Start', description: '낙상 시작' },
            { key: 'loss_of_balance_frame', label: 'Balance Lost', description: '균형 상실' },
            { key: 'impact_frame', label: 'Impact', description: '충격' },
            { key: 'lowest_point_frame', label: 'Lowest', description: '최저점' },
            { key: 'stable_end_frame', label: 'Stable', description: '안정 자세' },
        ];
    }

    public promotionReviewChecklistItems(): any[] {
        return [
            { key: 'person_visible_to_end', label: '사람 끝까지 보임' },
            { key: 'track_maintained', label: 'Track 유지' },
            { key: 'impact_confirmed', label: 'Impact 확인' },
            { key: 'stable_pose_confirmed', label: 'Stable Pose 확인' },
            { key: 'no_camera_shake', label: 'Camera Shake 없음' },
            { key: 'annotation_reviewed', label: 'Annotation 검토 완료' },
        ];
    }

    public promotionReviewFrameValue(key: string): number | null {
        const value = this.selectedPromotionReviewCandidate()?.annotation?.[key];
        return value === null || value === undefined || value === '' ? null : Number(value);
    }

    public promotionReviewTimelineMax(): number {
        return Math.max(1, Number(this.selectedPromotionReviewCandidate()?.video_frame_count || 1) - 1);
    }

    public seekPromotionReviewTimelineFrame(key: string): void {
        const frame = this.promotionReviewFrameValue(key);
        const fps = Number(this.selectedPromotionReviewCandidate()?.video_fps || 0);
        const video: any = document.getElementById('promotion-review-video');
        if (frame === null || fps <= 0 || !video) return;
        video.currentTime = Math.max(0, frame / fps);
        video.play?.().catch?.(() => undefined);
    }

    public async setPromotionReviewCurrentFrame(key: string): Promise<void> {
        const row = this.selectedPromotionReviewCandidate();
        const video: any = document.getElementById('promotion-review-video');
        const fps = Number(row?.video_fps || 0);
        if (!row || !video || fps <= 0) return;
        if (!row.annotation || typeof row.annotation !== 'object') row.annotation = {};
        row.annotation[key] = Math.max(0, Math.min(this.promotionReviewTimelineMax(), Math.round(Number(video.currentTime || 0) * fps)));
        row[key] = row.annotation[key];
        await this.savePromotionReviewAnnotation();
    }

    public async updatePromotionReviewTimelineFrame(key: string, value: any): Promise<void> {
        const row = this.selectedPromotionReviewCandidate();
        if (!row) return;
        if (!row.annotation || typeof row.annotation !== 'object') row.annotation = {};
        row.annotation[key] = Math.max(0, Math.min(this.promotionReviewTimelineMax(), Number(value || 0)));
        row[key] = row.annotation[key];
        await this.savePromotionReviewAnnotation();
    }

    public async updatePromotionReviewChecklist(key: string, checked: boolean): Promise<void> {
        const row = this.selectedPromotionReviewCandidate();
        if (!row) return;
        if (!row.checklist || typeof row.checklist !== 'object') row.checklist = {};
        row.checklist[key] = checked === true;
        await this.savePromotionReviewAnnotation();
    }

    public promotionReviewChecklistComplete(): boolean {
        const checklist = this.selectedPromotionReviewCandidate()?.checklist || {};
        return this.promotionReviewChecklistItems().every((item: any) => checklist?.[item.key] === true);
    }

    public async savePromotionReviewAnnotation(): Promise<void> {
        const row = this.selectedPromotionReviewCandidate();
        const reviewer = String(this.promotionReviewReviewer || '').replace(/\s+/g, ' ').trim().slice(0, 40);
        if (!row || this.promotionReviewAnnotationSaving) return;
        if (!reviewer) {
            this.promotionReviewMessage = 'Timeline 저장 전에 검수자 이름을 입력해주세요.';
            this.promotionReviewMessageType = 'error';
            await this.service.render();
            return;
        }
        try { localStorage.setItem('fallai-promotion-reviewer', reviewer); } catch (_e) { }
        this.promotionReviewAnnotationSaving = true;
        try {
            const params = new URLSearchParams();
            params.set('candidate_id', String(row.candidate_id || ''));
            params.set('reviewer', reviewer);
            params.set('annotation', JSON.stringify(row.annotation || {}));
            params.set('checklist', JSON.stringify(row.checklist || {}));
            const response = await fetch(`/wiz/api/page.models/promotion_holdout_review_annotation?${params.toString()}`, { method: 'POST' });
            const json = await this.readJsonResponse(response);
            const payload = this.responsePayload(json);
            if (json.code !== 200) throw new Error(payload?.message || json?.message || 'Timeline annotation 저장 실패');
            Object.assign(row, payload?.candidate || {});
            this.promotionReviewMessage = `Timeline 저장 · 품질 ${Number(row?.annotation_quality?.quality_score || 0)}% ${row?.annotation_quality?.quality_label || ''}`;
            this.promotionReviewMessageType = 'success';
        } catch (error: any) {
            this.promotionReviewMessage = error?.message || 'Timeline annotation 저장 실패';
            this.promotionReviewMessageType = 'error';
        }
        this.promotionReviewAnnotationSaving = false;
        await this.service.render();
    }

    public promotionReviewQualityClass(): string {
        const score = Number(this.selectedPromotionReviewCandidate()?.annotation_quality?.quality_score || 0);
        if (score >= 90) return 'text-emerald-700';
        if (score >= 60) return 'text-amber-700';
        return 'text-rose-700';
    }

    public movingObjectShadowStatus(): any {
        return this.registry?.moving_object_shadow || {
            mode: 'shadow_only',
            decision_effect: false,
            threshold_version: 'shadow-v1',
        };
    }

    public featureModelCards(): any[] {
        const definitions = [
            { title: '통합 분석 조합', families: ['rf-dual'], fallback: '운영 조합 없음' },
            { title: '관절점 추출 모델', families: ['pose-backbone'], fallback: 'YOLOv8n-Pose 기본값' },
            { title: '낙상 최종 판단 모델', families: ['rf-pipeline', 'rf-fall-v2'], fallback: '등록된 모델 없음' },
            { title: '자세·행동 분석 모델', families: ['xg-posture'], fallback: '등록된 모델 없음' },
            { title: '가림 보조 모델', families: ['xg-posture-occlusion-aux'], fallback: '등록된 모델 없음' },
            { title: '환경 사물 분석 런타임', families: ['environment-agent'], fallback: '환경 런타임 미등록' },
            { title: '표정 분석 모델', families: ['facial-aihub82'], fallback: '등록된 모델 없음' },
            { title: '상태 분석 모델', families: ['driver-aihub173'], fallback: '등록된 모델 없음' },
        ];
        return definitions.map((definition: any) => {
            const isEnvironment = definition.families.includes('environment-agent');
            const isFallDecision = definition.families.includes('rf-pipeline') && definition.families.includes('rf-fall-v2');
            const isPoseBackbone = definition.families.includes('pose-backbone');
            const item = isEnvironment
                ? this.latestItemByFamily('environment-agent')
                : (isFallDecision ? this.activeFallDecisionItem() : this.findActiveItemByFamilies(definition.families));
            const hasItem = !!item?.model_id;
            const environmentReady = hasItem && isEnvironment && this.environmentRuntimeReady(item);
            const compatibilityRisk = hasItem && isFallDecision && this.isCompatibilityFallArtifact(item);
            return {
                title: definition.title,
                name: hasItem ? (isEnvironment ? this.environmentRuntimeModelText(item) : this.modelTitle(item)) : definition.fallback,
                internalName: hasItem
                    ? (isEnvironment ? '환경 Agent · 사물 검출·분할·정밀 실루엣' : this.featureModelInternalText(item))
                    : (isEnvironment ? '환경 런타임 계약 파일이 없습니다.' : '운영 모델이 아직 없습니다.'),
                status: compatibilityRisk
                    ? '운영 중 · 승격 필요'
                    : (environmentReady ? '파이프라인 적용 중' : (isEnvironment && hasItem ? 'MVP 계약(구현 전)' : (hasItem ? this.archiveStatusText(item) : '대기'))),
                metricLabel: isEnvironment ? '검증 상태' : (isPoseBackbone ? '출력 계약' : '성능'),
                performance: compatibilityRisk
                    ? '복구 메타데이터 · 현재 바이너리 미검증'
                    : (isPoseBackbone ? 'COCO-17 관절점' : (environmentReady ? '실행 연결 완료 · 전용 mAP 미검증' : (isEnvironment && hasItem ? `${this.itemPrimaryMetricText(item)} · 미측정` : (hasItem ? this.itemPrimaryMetricText(item) : '-')))),
                version: compatibilityRisk ? `${this.versionText(item)} · 호환 복구본` : (hasItem ? this.versionText(item) : '-'),
                updated: hasItem ? this.itemDateText(item) : '-',
                statusClass: compatibilityRisk ? 'text-rose-700' : (hasItem ? (environmentReady ? 'text-emerald-700' : (isEnvironment ? 'text-sky-700' : 'text-emerald-700')) : 'text-zinc-500'),
                dotClass: compatibilityRisk ? 'bg-rose-500' : (hasItem ? (environmentReady ? 'bg-emerald-500' : (isEnvironment ? 'bg-sky-500' : 'bg-emerald-500')) : 'bg-zinc-300'),
                cardClass: isEnvironment ? (environmentReady ? 'border-sky-200 bg-sky-50/60' : 'border-dashed border-sky-300 bg-sky-50/60') : 'border-zinc-200 bg-zinc-50',
                badge: environmentReady ? '환경 전용 학습 전' : (isEnvironment && hasItem ? '운영 모델 아님' : ''),
                roleNote: isFallDecision
                    ? `${this.activeRuntimeModuleText()} · ${this.fallDecisionFeatureCount()}개 입력 특성`
                    : (definition.families.includes('rf-dual')
                        ? 'RF-Fall v2 + XG-Posture + 조건부 가림 보조를 묶는 현재 기본 분석 조합입니다.'
                        : (isPoseBackbone
                            ? '영상에서 관절점을 추출해 낙상·자세 판단 모델에 전달합니다.'
                            : (environmentReady
                            ? '사물 검출·외곽선·RiskVector가 분석 파이프라인에 연결되어 있습니다. 환경 전용 fine-tuning과 독립 mAP 검증은 아직 완료되지 않았습니다.'
                            : (isEnvironment && hasItem ? '환경 분석 계약만 등록되어 있으며 추론 파이프라인 연결 전입니다.' : '')))),
                item,
            };
        });
    }

    private latestItemByFamily(family: string): any {
        const rows = this.allItems().filter((item: any) => this.modelFamily(item) === family);
        return [...rows].sort((a: any, b: any) => {
            const active = Number(b?.active === true || b?.source === 'active') - Number(a?.active === true || a?.source === 'active');
            if (active !== 0) return active;
            const candidate = Number(b?.source === 'candidate') - Number(a?.source === 'candidate');
            if (candidate !== 0) return candidate;
            return this.parseTimestampMs(b?.artifact_updated_at || b?.updated_at || b?.created_at) - this.parseTimestampMs(a?.artifact_updated_at || a?.updated_at || a?.created_at);
        })[0] || {};
    }

    private filterStatusClass(item: any): string {
        const status = this.archiveStatusText(item);
        if (status === '현재 사용 중') return 'text-emerald-700';
        if (status === '시험 중') return 'text-amber-700';
        if (status === '새로 등록됨') return 'text-sky-700';
        return 'text-zinc-500';
    }

    private filterDotClass(item: any): string {
        const status = this.archiveStatusText(item);
        if (status === '현재 사용 중') return 'bg-emerald-500';
        if (status === '시험 중') return 'bg-amber-500';
        if (status === '새로 등록됨') return 'bg-sky-500';
        return 'bg-zinc-300';
    }

    public filterFeatureCards(): any[] {
        const definitions = [
            { title: '정지 사물 필터 v1', family: 'static-object-filter', fallback: '등록된 필터 없음' },
            { title: '사람/사물 판정 필터 v1', family: 'pose-entity-filter', fallback: '등록된 필터 없음' },
        ];
        return definitions.map((definition: any) => {
            const item = this.findAppliedItemByFamily(definition.family);
            const hasItem = !!item?.model_id;
            const gate = item?.validation_gate || {};
            const artifactId = String(item?.model_id || '').trim();
            const isStaticFilter = definition.family === 'static-object-filter';
            const knownPersonCount = isStaticFilter
                ? Number(gate?.actual_replay_samples || item?.metrics?.sample_count || 0)
                : Number(gate?.person_tracks || 0);
            const falseExclusions = Number(gate?.critical_false_exclusions || 0);
            const equipmentGhostTotal = Number(gate?.equipment_ghost_tracks || 0);
            const equipmentGhostObjects = Number(gate?.equipment_ghost_classified_object || 0);
            return {
                title: definition.title,
                name: hasItem ? this.modelTitle(item) : definition.fallback,
                internalName: hasItem
                    ? (isStaticFilter ? '운영 참조 · runtime_selection.static-object-filter' : '운영 참조 · 내장 active:pose-entity-filter')
                    : '운영 적용된 필터가 아직 없습니다.',
                artifactReference: hasItem ? `원본 artifact ID · ${artifactId}` : '',
                status: hasItem ? this.archiveStatusText(item) : '미등록',
                runtime: hasItem ? (artifactId.startsWith('candidate:') ? '후보 artifact 운영 선택' : '내장 active 운영') : '대기',
                metricLabel: '검증 범위',
                performance: hasItem
                    ? `알려진 사람 ${knownPersonCount.toLocaleString()}${isStaticFilter ? '영상' : '트랙'} · 오제외 ${falseExclusions.toLocaleString()}`
                    : '-',
                performanceScope: isStaticFilter
                    ? '알려진 반례 기준 · 사람 유지 안전 검증이며, 사물 제거율 100%나 일반 사물 전체 성능을 뜻하지 않습니다.'
                    : `알려진 반례 기준 · 알려진 장비 ghost ${equipmentGhostObjects.toLocaleString()}/${equipmentGhostTotal.toLocaleString()} 사물 판정이며, 일반 사물 전체 성능을 뜻하지 않습니다.`,
                version: hasItem ? this.versionText(item) : '-',
                updated: hasItem ? this.itemDateText(item) : '-',
                statusClass: hasItem ? this.filterStatusClass(item) : 'text-zinc-500',
                runtimeClass: hasItem ? 'text-emerald-700' : 'text-zinc-500',
                dotClass: hasItem ? this.filterDotClass(item) : 'bg-zinc-300',
                item,
            };
        }).filter((card: any) => !!card?.item?.model_id);
    }

    private featureModelInternalText(item: any): string {
        const family = String(item?.family_label || item?.family || '').trim();
        const modelId = String(item?.model_id || '').trim();
        const source = this.archiveStatusText(item);
        const parts = [family, source, modelId].filter(Boolean);
        return parts.join(' · ') || '모델 정보 없음';
    }

    public openAiDetail(item: any) {
        if (!item?.model_id) return;
        const key = this.archiveItemKey(item);
        if (this.expandedArchiveItemId === key) {
            this.expandedArchiveItemId = '';
            this.selectedArchiveItem = null;
        } else {
            this.expandedArchiveItemId = key;
            this.selectedArchiveItem = item;
        }
        this.service.render();
    }

    public closeAiDetail() {
        this.expandedArchiveItemId = '';
        this.selectedArchiveItem = null;
        this.service.render();
    }

    private archiveItemKey(item: any): string {
        return String(item?.model_id || '');
    }

    public isArchiveDetailOpen(item: any): boolean {
        return !!item?.model_id && this.expandedArchiveItemId === this.archiveItemKey(item);
    }

    public itemDateText(item: any): string {
        const raw = item?.artifact_updated_at || item?.updated_at || item?.registered_at || item?.created_at || item?.applied_at || this.registry?.updated_at || '';
        return this.formatShortDate(raw);
    }

    private formatShortDate(value: any): string {
        const ms = this.parseTimestampMs(value);
        if (!ms) return '-';
        const date = new Date(ms);
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    }

    public itemPrimaryMetricText(item: any): string {
        if (this.isEnvironmentAgentItem(item)) {
            const targets = this.environmentValidationTargets(item);
            const actualMap = Number(item?.metrics?.map || 0);
            if (actualMap > 0) return `mAP ${this.pct(actualMap)}`;
            const mapTarget = Number(targets.environment_hazard_detection_mAP ?? targets.mAP ?? targets.environment_hazard_detection_map ?? targets.map ?? targets.mean_average_precision ?? 0.85);
            return `목표 mAP ${this.pct(mapTarget)}`;
        }
        if (this.isFilterArchiveItem(item) && !this.isFilterOperationallyValidated(item)) {
            const gate = this.filterValidationGate(item);
            const required = Number(gate?.required_replay_samples || 411);
            const actual = Number(gate?.actual_replay_samples || 0);
            const excluded = Number(gate?.critical_false_exclusions || 0);
            return actual >= required && excluded > 0 ? '검증 미달' : '검증 대기';
        }
        const metrics = item?.metrics || item || {};
        if (this.isFilterArchiveItem(item)) {
            const retention = Number(metrics.true_positive_retention_rate || metrics.recall || 0);
            return retention > 0 ? this.pct(retention) : '-';
        }
        const value = Number(metrics.primary_score || metrics.f1 || metrics.macro_f1 || metrics.accuracy || item?.f1 || item?.accuracy || 0);
        return value > 0 ? this.pct(value) : '-';
    }

    private environmentContract(item: any): any {
        return item?.summary && typeof item.summary === 'object' ? item.summary : {};
    }

    private environmentRuntimeStatus(item: any): any {
        return item?.runtime_status || this.environmentContract(item)?.runtime_status || {};
    }

    private environmentRuntimeReady(item: any): boolean {
        const status = this.environmentRuntimeStatus(item);
        return status.object_recognition_ready === true
            && status.pipeline_integration_ready === true
            && status.risk_vector_emission_ready === true;
    }

    private environmentRuntimeModelText(item: any): string {
        const runtimeModel = String(this.environmentContract(item)?.object_recognition?.runtime_model || '').trim();
        if (!runtimeModel) return '환경 Agent 런타임';
        return runtimeModel
            .replace(/yolo11n\.pt/gi, 'YOLO11n')
            .replace(/environment_yoloe26s_seg_open_vocab_v2\.pt/gi, 'YOLOE-26s Seg · 시설 21 프롬프트')
            .replace(/environment_yoloe26s_seg_open_vocab\.pt/gi, 'YOLOE-26s Seg')
            .replace(/sam2\.1_t\.pt/gi, 'SAM2.1 Tiny');
    }

    private environmentListText(values: any, fallback: string = '-'): string {
        if (!Array.isArray(values) || values.length === 0) return fallback;
        const labels = values.map((value: any) => {
            if (typeof value === 'string') return value;
            return String(value?.label_ko || value?.label || value?.name || value?.key || value?.id || '').trim();
        }).filter(Boolean);
        return labels.length > 0 ? labels.join(' · ') : fallback;
    }

    private environmentValidationTargets(item: any): any {
        const contract = this.environmentContract(item);
        return item?.validation_targets || contract?.validation_targets || {};
    }

    public environmentMvpEventsText(item: any): string {
        const contract = this.environmentContract(item);
        return this.environmentListText(item?.mvp_events || contract?.events?.mvp, 'obstacle_detected · low_light · blocked_path');
    }

    public environmentFutureEventsText(item: any): string {
        const contract = this.environmentContract(item);
        return this.environmentListText(item?.future_events || contract?.events?.future, 'cable_risk · slippery_area · furniture_change');
    }

    public environmentInputsText(item: any): string {
        return this.environmentListText(this.environmentContract(item)?.inputs, '실내 영상 · 공간정보 · depth · 조도 센서 · 과거 공간 상태');
    }

    public environmentAlgorithmsText(item: any): string {
        const algorithms = this.environmentContract(item)?.algorithms || {};
        if (Array.isArray(algorithms)) {
            return this.environmentListText(algorithms, 'object_detection · semantic_segmentation · depth_estimation · illumination_estimation · change_detection');
        }
        const mvp = this.environmentListText(algorithms.mvp, 'object_detection · illumination_estimation');
        const future = this.environmentListText(algorithms.future, 'semantic_segmentation · depth_estimation · change_detection');
        return `MVP: ${mvp} / 후속: ${future}`;
    }

    public environmentOutputsText(item: any): string {
        const contract = this.environmentContract(item);
        return this.environmentListText(contract?.outputs || contract?.output_contract?.outputs, '위험요인 종류 · 위치 · 위험도 · 신뢰도 · 공간 위험도 맵 · 개선 권고');
    }

    public environmentRiskVectorText(item: any): string {
        const contract = this.environmentContract(item);
        const riskVector = contract?.risk_vector || contract?.output_contract?.risk_vector || {};
        const fields = this.environmentListText(riskVector.required_fields, 'agent_type · event_type · risk_score · confidence · location');
        return `agent_type=environment · ${fields}`;
    }

    public environmentPreventionText(item: any): string {
        const contract = this.environmentContract(item);
        const policy = contract?.preventive_alert || contract?.prevention_policy || {};
        const canTriggerWithoutPerson = policy.person_event_required === false
            ? policy.environment_high_risk_can_trigger !== false
            : policy.allow_without_person_event !== false;
        return !canTriggerWithoutPerson
            ? '사람 이벤트가 있어야 예방 알림을 생성합니다.'
            : '사람 위험 이벤트가 없어도 환경 위험이 높으면 예방 알림을 생성합니다.';
    }

    public environmentFusionRuleText(item: any): string {
        const contract = this.environmentContract(item);
        const rule = contract?.fusion_rule || contract?.fusion_rules?.[0] || {};
        const boost = Number(rule.score_boost ?? rule.final_risk_score_increment ?? 0.20);
        const minutes = Number(rule.time_window_minutes ?? 10);
        return `${String(rule.rule_id || rule.id || 'RULE_FALL_RISK_003')} · 행동 stumble/unstable_gait + 환경 low_light/obstacle_detected · ${minutes}분 이내 +${boost.toFixed(2)}`;
    }

    public environmentValidationTargetText(item: any): string {
        const targets = this.environmentValidationTargets(item);
        const mapTarget = Number(targets.environment_hazard_detection_mAP ?? targets.mAP ?? targets.environment_hazard_detection_map ?? targets.map ?? targets.mean_average_precision ?? 0.85);
        const riskMapTarget = Number(targets.space_risk_map_agreement ?? targets.risk_map_agreement ?? 0.80);
        return `환경 위험요인 mAP ${this.pct(mapTarget)} 이상 · 공간 위험도 맵 일치도 ${this.pct(riskMapTarget)} 이상`;
    }

    public environmentDatasetsText(item: any): string {
        const datasets = this.environmentContract(item)?.dataset_candidates || this.environmentContract(item)?.datasets || [];
        if (!Array.isArray(datasets) || datasets.length === 0) return 'AI-Hub 71377 · 159 · 71574';
        return datasets.map((dataset: any) => {
            const provider = String(dataset?.provider || 'AI-Hub');
            const id = String(dataset?.dataset_id || dataset?.id || '').trim();
            const name = String(dataset?.name || dataset?.title || '').trim();
            return [`${provider}${id ? ` ${id}` : ''}`, name].filter(Boolean).join(' ');
        }).join(' · ');
    }

    public environmentRuntimeText(item: any): string {
        const status = this.environmentRuntimeStatus(item);
        if (status.pipeline_integration_ready === true && status.detector_training_ready === true) return '학습·파이프라인 연결 완료';
        if (status.pipeline_integration_ready === true && status.sam2_silhouette_refinement_ready === true) return 'YOLO11n·YOLOE 사물 분석 + SAM2.1 비디오 메모리 실루엣 연결 완료 · 환경 전용 학습·독립 mAP 검증 대기';
        if (status.open_vocabulary_segmentation_ready === true) return '시설 사물 외곽선 분할 연결 완료 · 검토형 오픈보캐브 모델';
        if (status.object_recognition_ready === true) return '일반 실내 사물 인식 연결 완료 · 환경 전용 학습 대기';
        return 'RiskVector 계약 준비 · 객체 검출 학습 및 운영 파이프라인 연결 대기';
    }

    public newComparisonRow(): any {
        return this.comparisonRightRow();
    }

    private comparisonMetricValue(row: any, metric: string): number {
        return this.metricValue(row, metric);
    }

    private metricResultText(current: any, next: any, metric: string): string {
        const diff = (this.comparisonMetricValue(next, metric) - this.comparisonMetricValue(current, metric)) * 100;
        if (!Number.isFinite(diff) || Math.abs(diff) < 0.05) return '동일';
        return `${diff > 0 ? '+' : ''}${diff.toFixed(1)}점`;
    }

    private metricResultClass(current: any, next: any, metric: string): string {
        const diff = this.comparisonMetricValue(next, metric) - this.comparisonMetricValue(current, metric);
        if (diff > 0.0005) return 'text-emerald-700';
        if (diff < -0.0005) return 'text-amber-700';
        return 'text-zinc-600';
    }

    public aiComparisonMetricRows(): any[] {
        if (!this.canCompareSelectedModels()) return [];
        const current = this.comparisonLeftRow();
        const next = this.comparisonRightRow();
        const rows = [
            { label: '성능', metric: this.compareMetric || 'f1' },
            { label: '정확도', metric: 'accuracy' },
            { label: '놓치지 않음(Recall)', metric: 'recall' },
            { label: '정확히 맞힘(Precision)', metric: 'precision' },
            { label: '종합 점수(F1)', metric: 'f1' },
            { label: '환경 위험 검출(mAP)', metric: 'map' },
            { label: '공간 위험도 맵 일치도', metric: 'risk_map_agreement' },
        ].map((item: any) => ({
            label: item.label,
            current: this.metricText(current, item.metric),
            next: this.metricText(next, item.metric),
            result: this.metricResultText(current, next, item.metric),
            toneClass: this.metricResultClass(current, next, item.metric),
        }));
        rows.push({
            label: '향상도',
            current: '-',
            next: '-',
            result: this.metricResultText(current, next, this.compareMetric || 'f1'),
            toneClass: this.metricResultClass(current, next, this.compareMetric || 'f1'),
        });
        rows.push({
            label: '추천 여부',
            current: '-',
            next: '-',
            result: this.aiRecommendationText(),
            toneClass: this.aiRecommendationClass().includes('emerald') ? 'text-emerald-700' : 'text-amber-700',
        });
        return rows;
    }

    public aiRecommendationText(): string {
        if (!this.canCompareSelectedModels()) return '모델 선택 필요';
        const current = this.comparisonLeftRow();
        const next = this.comparisonRightRow();
        const applyItem = this.comparisonApplyItem();
        if (this.isEnvironmentAgentItem(applyItem) && applyItem?.selectable === false) return '운영 연결 대기';
        if (this.isRfFallCandidateItem(applyItem) && !this.promotionHoldoutReady()) return 'Holdout 미완료';
        const diff = this.metricValue(next, this.compareMetric || 'f1') - this.metricValue(current, this.compareMetric || 'f1');
        return diff > 0.003 ? '운영 교체 권장' : '추가 검증 필요';
    }

    public aiRecommendationClass(): string {
        return this.aiRecommendationText() === '운영 교체 권장'
            ? 'border-emerald-200 bg-emerald-50 text-emerald-700'
            : 'border-amber-200 bg-amber-50 text-amber-700';
    }

    private comparisonApplyItem(): any {
        const row = this.comparisonRightRow();
        const modelId = String(row?.model_id || '');
        return this.allItems().find((item: any) => String(item?.model_id || '') === modelId) || row || {};
    }

    private isRfFallCandidateItem(item: any): boolean {
        const modelId = String(item?.model_id || '').trim();
        const source = String(item?.source || '').trim().toLowerCase();
        return this.modelFamily(item) === 'rf-fall-v2'
            && !modelId.startsWith('active:')
            && source !== 'active';
    }

    public showComparisonApplyButton(): boolean {
        const item = this.comparisonApplyItem();
        if (!item?.model_id) return false;
        if (this.isEnvironmentAgentItem(item) && item?.selectable === false) return false;
        return true;
    }

    public canApplyComparedModel(): boolean {
        const item = this.comparisonApplyItem();
        if (this.isRfFallCandidateItem(item) && !this.promotionHoldoutReady()) return false;
        return this.showComparisonApplyButton() && item?.selectable !== false && !this.applyBusy;
    }

    public comparisonApplyNotice(): string {
        const item = this.comparisonApplyItem();
        if (this.isFilterArchiveItem(item) && !this.isFilterOperationallyValidated(item)) {
            return this.filterValidationDecisionComment(item);
        }
        if (this.isEnvironmentAgentItem(item) && item?.selectable === false) {
            return '환경 Agent 후보는 mAP·위험도 맵 성능을 비교할 수 있지만, 객체 검출 학습과 운영 파이프라인 연결 전에는 적용할 수 없습니다.';
        }
        if (this.isRfFallCandidateItem(item) && !this.promotionHoldoutReady()) {
            return 'RF-Fall v2 후보는 B1~B8 paired E2E를 모두 통과하기 전에는 운영 적용할 수 없습니다.';
        }
        if (item?.selectable === false) return '이 모델은 아직 운영 적용할 수 없습니다.';
        return '오른쪽 모델을 운영에 적용하려면 아래 버튼을 누르세요.';
    }

    public openApplyConfirm() {
        if (!this.canCompareSelectedModels() || !this.canApplyComparedModel()) return;
        this.applyConfirmOpen = true;
        this.service.render();
    }

    public closeApplyConfirm() {
        this.applyConfirmOpen = false;
        this.service.render();
    }

    public async confirmApplyComparedModel() {
        const row = this.comparisonRightRow();
        const family = String(row?.family || '');
        const modelId = String(row?.model_id || '');
        if (!family || !modelId || !this.canApplyComparedModel()) return;
        this.applyBusy = true;
        this.uploadMessage = `${this.comparisonDisplayName(row)} 운영 적용 중입니다.`;
        this.uploadMessageType = 'info';
        await this.service.render();
        try {
            const params = new URLSearchParams();
            params.set('family', family);
            params.set('model_id', modelId);
            const res = await fetch(`/wiz/api/page.models/set_runtime_model_selection?${params.toString()}`, { method: 'POST' });
            const json = await this.readJsonResponse(res);
            if (json.code === 200) {
                this.uploadMessage = '선택한 모델을 운영에 적용했습니다.';
                this.uploadMessageType = 'success';
                this.applyConfirmOpen = false;
                await this.loadRegistry();
            } else {
                this.uploadMessage = json.data?.message || json.message || '운영 적용 실패';
                this.uploadMessageType = 'error';
            }
        } catch (e: any) {
            this.uploadMessage = e?.message || '운영 적용 실패';
            this.uploadMessageType = 'error';
        }
        this.applyBusy = false;
        await this.service.render();
    }

    private filterValidationJob(item: any): any {
        return item?.validation_job || {};
    }

    private filterUsageDecision(item: any): any {
        return item?.validation_decision || {};
    }

    public filterValidationDecisionLabel(item: any): string {
        return String(this.filterUsageDecision(item)?.label || '검증 필요');
    }

    public filterValidationDecisionComment(item: any): string {
        return String(this.filterUsageDecision(item)?.comment || '사람 보호 검증을 완료해야 사용 여부를 판단할 수 있습니다.');
    }

    public filterValidationDecisionClass(item: any): string {
        const status = String(this.filterUsageDecision(item)?.status || 'pending');
        if (status === 'usable') return 'border-emerald-200 bg-emerald-50 text-emerald-800';
        if (status === 'unusable') return 'border-rose-200 bg-rose-50 text-rose-800';
        if (status === 'review_required') return 'border-amber-200 bg-amber-50 text-amber-800';
        if (status === 'error') return 'border-amber-200 bg-amber-50 text-amber-800';
        return 'border-zinc-200 bg-zinc-100 text-zinc-700';
    }

    public showFilterValidationDecision(item: any): boolean {
        return this.isFilterArchiveItem(item) && !this.isFilterValidationRunning(item);
    }

    public showArchiveApplyButton(item: any): boolean {
        return !(this.isEnvironmentAgentItem(item) && item?.selectable === false);
    }

    private isFilterValidationRunning(item: any): boolean {
        const job = this.filterValidationJob(item);
        const status = String(job?.status || '').toLowerCase();
        return this.isFilterArchiveItem(item) && (job?.running === true || ['starting', 'queued', 'running'].includes(status));
    }

    public canStartFilterValidation(item: any): boolean {
        if (!this.isFilterArchiveItem(item) || this.validatingFilterId) return false;
        if (item?.missing || item?.delete_after || item?.remaining_text) return false;
        const job = this.filterValidationJob(item);
        return job?.supported === true && job?.can_start !== false && !this.isFilterValidationRunning(item);
    }

    public filterValidationButtonText(item: any): string {
        const modelId = String(item?.model_id || '');
        if (this.validatingFilterId === modelId) return '시작 중';
        if (this.isFilterValidationRunning(item)) return '검증 중';
        const gate = this.filterValidationGate(item);
        return Number(gate?.actual_replay_samples || 0) > 0 ? '재검증' : '검증 시작';
    }

    public filterValidationButtonHelp(item: any): string {
        const job = this.filterValidationJob(item);
        if (this.isFilterValidationRunning(item)) return '보유 사람 데이터 검증이 실행 중입니다.';
        if (this.modelFamily(item) === 'pose-entity-filter') {
            return job?.message || '보유 사람 411건·540트랙과 P1/P2 golden-case로 운영 가능 여부를 검증합니다.';
        }
        return job?.message || 'AI-Hub 사람 411건으로 실제 사람 오제외 여부를 검증합니다.';
    }

    public filterValidationProgressPercent(item: any): number {
        const job = this.filterValidationJob(item);
        const explicit = Number(job?.progress_percent);
        const derived = Number(job?.progress || 0) * 100;
        const value = Number.isFinite(explicit) ? explicit : derived;
        return Math.max(0, Math.min(100, Math.round(value)));
    }

    public filterValidationPhaseText(item: any): string {
        if (this.modelFamily(item) === 'pose-entity-filter') return '보유 replay·P1/P2 검증';
        const phase = String(this.filterValidationJob(item)?.phase || 'starting').toLowerCase();
        if (phase === 'preparing' || phase === 'starting') return '검증 준비';
        if (phase === 'people') return 'AI-Hub 사람 검증';
        if (phase === 'auxiliary') return '보조 데이터 검증';
        if (phase === 'finalizing') return '결과 집계';
        return '사람 보호 검증';
    }

    private validationDurationText(value: any): string {
        const seconds = Number(value);
        if (!Number.isFinite(seconds) || seconds <= 0) return '';
        if (seconds < 60) return '1분 미만';
        const minutes = Math.ceil(seconds / 60);
        if (minutes < 60) return `${minutes}분`;
        const hours = Math.floor(minutes / 60);
        const remainder = minutes % 60;
        return remainder > 0 ? `${hours}시간 ${remainder}분` : `${hours}시간`;
    }

    public filterValidationEtaText(item: any): string {
        const job = this.filterValidationJob(item);
        const text = this.validationDurationText(job?.eta_sec);
        if (text) return `약 ${text} 남음`;
        return this.filterValidationProgressPercent(item) >= 98 ? '마무리 중' : '남은 시간 계산 중';
    }

    public filterValidationProgressSummary(item: any): string {
        const job = this.filterValidationJob(item);
        const processed = Math.max(0, Number(job?.processed || 0));
        const total = Math.max(1, Number(job?.total || 411));
        return `${processed.toLocaleString()} / ${total.toLocaleString()}건 · ${this.filterValidationEtaText(item)}`;
    }

    public filterValidationJobText(item: any): string {
        if (this.modelFamily(item) === 'pose-entity-filter') {
            const gate = this.filterValidationGate(item);
            const checksum = String(gate?.artifact_sha256 || '');
            if (gate?.ready === true) {
                return `보유 영상 ${Number(gate?.actual_replay_samples || 0).toLocaleString()}건 · 사람 ${Number(gate?.person_tracks || 0).toLocaleString()}트랙 · checksum ${checksum.slice(0, 12)}…`;
            }
            return gate?.message || '보유 데이터 검증을 실행해야 운영 적용할 수 있습니다.';
        }
        const job = this.filterValidationJob(item);
        const status = String(job?.status || 'idle').toLowerCase();
        if (['starting', 'queued', 'running'].includes(status) || job?.running === true) {
            return `검증 실행 중 · ${this.filterValidationProgressPercent(item)}% · ${this.filterValidationEtaText(item)}`;
        }
        if (status === 'completed') return job?.message || '최근 사람 보호 검증을 통과했습니다.';
        if (status === 'validation_failed') return job?.message || '최근 검증에서 실제 사람 오제외가 확인됐습니다.';
        if (status === 'failed') return `검증 실행 오류 · ${job?.message || '로그를 확인해주세요.'}`;
        return job?.message || '검증 버튼을 눌러 AI-Hub 사람 보호 검증을 실행할 수 있습니다.';
    }

    public async startFilterValidation(item: any) {
        if (!this.canStartFilterValidation(item)) return;
        const modelId = String(item?.model_id || '').trim();
        const isPoseEntityFilter = this.modelFamily(item) === 'pose-entity-filter';
        const confirmed = window.confirm(
            isPoseEntityFilter
                ? '보유 사람 영상 411건·540트랙과 P1/P2 golden-case로 검증합니다. 시작할까요?'
                : 'AI-Hub 사람 영상 411건으로 보호 검증을 시작합니다. 검증에는 시간이 걸릴 수 있습니다. 시작할까요?'
        );
        if (!confirmed) return;
        this.validatingFilterId = modelId;
        this.uploadMessage = `${this.archiveTitle(item)} 사람 보호 검증을 시작합니다.`;
        this.uploadMessageType = 'info';
        await this.service.render();
        try {
            const params = new URLSearchParams();
            params.set('model_id', modelId);
            const res = await fetch(`/wiz/api/page.models/start_static_object_filter_validation?${params.toString()}`, { method: 'POST' });
            const json = await this.readJsonResponse(res);
            const payload = this.responsePayload(json);
            if (json.code === 200) {
                this.uploadMessage = payload?.already_running
                    ? '필터 검증이 이미 실행 중입니다.'
                    : '필터 검증을 시작했습니다. 완료 결과는 카드에 자동 반영됩니다.';
                this.uploadMessageType = 'success';
                await this.loadRegistry(true);
            } else {
                this.uploadMessage = payload?.message || json.message || '필터 검증을 시작하지 못했습니다.';
                this.uploadMessageType = 'error';
            }
        } catch (e: any) {
            this.uploadMessage = e?.message || '필터 검증을 시작하지 못했습니다.';
            this.uploadMessageType = 'error';
        }
        this.validatingFilterId = '';
        this.syncFilterValidationPolling();
        await this.service.render();
    }

    public canApplyArchiveItem(item: any): boolean {
        const family = this.modelFamily(item);
        const modelId = String(item?.model_id || '').trim();
        const source = String(item?.source || '').toLowerCase();
        if (!family || !modelId || this.applyingArchiveId) return false;
        if (family === 'rf-dual' || item?.missing || item?.delete_after || item?.remaining_text) return false;
        if (this.isFilterArchiveItem(item) && !this.isFilterOperationallyValidated(item)) return false;
        if (this.isRfFallCandidateItem(item) && !this.promotionHoldoutReady()) return false;
        if (source === 'active' || source === 'custom-final' || item?.active === true || this.isAppliedArchiveItem(item)) return false;
        return item?.selectable !== false;
    }

    public archiveApplyButtonText(item: any): string {
        if (this.applyingArchiveId === String(item?.model_id || '')) return '적용 중';
        if (this.isAppliedArchiveItem(item)) return '운영 중';
        if (this.isFilterArchiveItem(item) && !this.isFilterOperationallyValidated(item)) return '검증 후 운영 적용';
        if (this.isRfFallCandidateItem(item) && !this.promotionHoldoutReady()) return 'Holdout 통과 후 적용';
        return this.isFilterArchiveItem(item) ? '필터 운영 적용' : '운영 적용';
    }

    public archiveApplyHelpText(item: any): string {
        if (this.isFilterArchiveItem(item) && !this.isFilterOperationallyValidated(item)) {
            return this.filterValidationDecisionComment(item);
        }
        if (this.isEnvironmentAgentItem(item) && item?.selectable === false) {
            return '객체 검출 학습과 운영 파이프라인 연결을 마친 뒤 적용할 수 있습니다.';
        }
        if (this.isRfFallCandidateItem(item) && !this.promotionHoldoutReady()) {
            return 'B1~B8 독립 holdout과 지정 모델 사용 증거를 모두 통과해야 적용할 수 있습니다.';
        }
        return this.isAppliedArchiveItem(item) ? '현재 운영에 적용된 항목입니다.' : '이 항목을 운영에 적용합니다.';
    }

    public async applyArchiveItem(item: any) {
        if (!this.canApplyArchiveItem(item)) return;
        const family = this.modelFamily(item);
        const modelId = String(item?.model_id || '').trim();
        this.applyingArchiveId = modelId;
        this.uploadMessage = `${this.archiveTitle(item)} 운영 적용 중입니다.`;
        this.uploadMessageType = 'info';
        await this.service.render();
        try {
            const params = new URLSearchParams();
            params.set('family', family);
            params.set('model_id', modelId);
            const res = await fetch(`/wiz/api/page.models/set_runtime_model_selection?${params.toString()}`, { method: 'POST' });
            const json = await this.readJsonResponse(res);
            if (json.code === 200) {
                this.uploadMessage = this.isFilterArchiveItem(item) ? '선택한 필터를 운영에 적용했습니다.' : '선택한 모델을 운영에 적용했습니다.';
                this.uploadMessageType = 'success';
                await this.loadRegistry();
            } else {
                this.uploadMessage = json.data?.message || json.message || '운영 적용 실패';
                this.uploadMessageType = 'error';
            }
        } catch (e: any) {
            this.uploadMessage = e?.message || '운영 적용 실패';
            this.uploadMessageType = 'error';
        }
        this.applyingArchiveId = '';
        await this.service.render();
    }

    public archiveItems(): any[] {
        const sorted = [...this.archiveKindFilteredItems()].sort((a: any, b: any) => {
            const status = Number(this.isCurrentComparisonRow(b) || b?.source === 'custom-final') - Number(this.isCurrentComparisonRow(a) || a?.source === 'custom-final');
            if (status !== 0) return status;
            const metricNumber = (item: any): number => {
                const value = Number(this.itemPrimaryMetricText(item).replace('%', ''));
                return Number.isFinite(value) ? value : -1;
            };
            const metric = metricNumber(b) - metricNumber(a);
            if (metric !== 0) return metric;
            return this.archiveTitle(a).localeCompare(this.archiveTitle(b));
        });
        return sorted.slice(0, 24);
    }

    private archiveKindFilteredItems(): any[] {
        const filter = String(this.archiveKindFilter || 'model');
        return this.allItems().filter((item: any) => {
            const isFilter = this.isFilterArchiveItem(item);
            return filter === 'filter' ? isFilter : !isFilter;
        });
    }

    public setArchiveKindFilter(kind: string) {
        this.archiveKindFilter = kind === 'filter' ? 'filter' : 'model';
        this.closeAiDetail();
    }

    public archiveKindFilterLabel(): string {
        return this.archiveKindFilter === 'filter' ? '필터' : '모델';
    }

    public archiveFilterTotalCount(): number {
        return this.archiveKindFilteredItems().length;
    }

    public archiveKindFilterClass(kind: string): string {
        const active = this.archiveKindFilter === kind;
        return active
            ? 'bg-white text-sky-700 shadow-sm'
            : 'text-zinc-500 hover:text-zinc-800';
    }

    public archiveCandidateCount(): number {
        return this.allItems().filter((item: any) => String(item?.source || '').toLowerCase() === 'candidate').length;
    }

    public archiveAutoTrainingHelpText(): string {
        if (this.archiveKindFilter === 'filter') {
            return '필터는 모델처럼 학습하지 않습니다. 고정된 규칙과 임계값이 실제 사람을 잘못 제외하지 않는지 검증한 뒤 운영 적용합니다.';
        }
        const candidateCount = this.archiveCandidateCount();
        const runningCount = this.trainingRunningCount();
        const runningText = runningCount > 0 ? `현재 ${runningCount}개 백그라운드 학습이 실행 중이라` : '백그라운드 학습 결과가 쌓이면';
        return `시험 중 ${candidateCount}개는 자동 학습이 남긴 후보입니다. ${runningText} 후보가 늘 수 있지만, 운영 모델은 자동으로 바뀌지 않습니다.`;
    }

    public archiveTitle(item: any): string {
        return this.modelTitle(item);
    }

    public archiveSubtitle(item: any): string {
        return this.archiveFriendlyKind(item);
    }

    public isFilterArchiveItem(item: any): boolean {
        return ['static-object-filter', 'pose-entity-filter'].includes(this.modelFamily(item));
    }

    public isStaticObjectFilterItem(item: any): boolean {
        return this.modelFamily(item) === 'static-object-filter';
    }

    public isEnvironmentAgentItem(item: any): boolean {
        return this.modelFamily(item) === 'environment-agent';
    }

    public archiveTypeText(item: any): string {
        return this.isFilterArchiveItem(item) ? '필터' : '모델';
    }

    public archiveTypeClass(item: any): string {
        return this.isFilterArchiveItem(item)
            ? 'border-amber-200 bg-amber-50 text-amber-700'
            : 'border-sky-200 bg-sky-50 text-sky-700';
    }

    private archiveFriendlyKind(item: any): string {
        const family = this.modelFamily(item);
        if (family === 'rf-dual') return '통합모델';
        if (family === 'rf-pipeline' || family === 'rf-fall-v2') return '낙상모델';
        if (family === 'xg-posture') return '자세분석모델';
        if (family === 'environment-agent') return '환경위험분석모델';
        if (family === 'xg-posture-occlusion-aux') return '가림보조모델';
        if (family === 'static-object-filter') return '정지사물필터v1';
        if (family === 'pose-entity-filter') return '사람사물판정필터v1';
        if (family === 'facial-aihub82') return '표정분석모델';
        if (family === 'driver-aihub173') return '상태분석모델';
        return this.cleanInternalName(item?.family_label || item?.family || '모델', '모델').replace(/\s+/g, '');
    }

    public archiveStatusText(item: any): string {
        const source = String(item?.source || '').toLowerCase();
        if (item?.delete_after || item?.remaining_text) return '삭제예약';
        if (item?.active === true || source === 'active' || this.isRuntimeSelectedItem(item)) return '현재 사용 중';
        if (this.isFilterArchiveItem(item)) return this.filterValidationDecisionLabel(item);
        if (this.isEnvironmentAgentItem(item) && source === 'spec') return this.environmentRuntimeReady(item) ? '파이프라인 적용 중' : 'MVP 계약(구현 전)';
        if (source === 'custom-final') return '운영 조합';
        if (source === 'uploaded') return '새로 등록됨';
        if (source === 'candidate') return '시험 중';
        return source || '보관';
    }

    public archiveStatusClass(item: any): string {
        const status = this.archiveStatusText(item);
        if (status === '현재 사용 중') return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (status === '파이프라인 적용 중') return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (status === '운영 조합') return 'border-blue-200 bg-blue-50 text-blue-700';
        if (status === '새로 등록됨') return 'border-sky-200 bg-sky-50 text-sky-700';
        if (status === 'MVP 계약(구현 전)') return 'border-sky-200 bg-sky-50 text-sky-700';
        if (status === '시험 중') return 'border-amber-200 bg-amber-50 text-amber-700';
        if (status === '검증 중') return 'border-sky-200 bg-sky-50 text-sky-700';
        if (status === '검증 통과') return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (status === '사용 가능') return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (status === '사용 불가') return 'border-rose-200 bg-rose-50 text-rose-700';
        if (status === '검토 필요') return 'border-amber-200 bg-amber-50 text-amber-700';
        if (status === '검증 오류') return 'border-amber-200 bg-amber-50 text-amber-700';
        if (status === '검증 필요') return 'border-zinc-200 bg-zinc-50 text-zinc-600';
        if (status === '삭제예약') return 'border-rose-200 bg-rose-50 text-rose-700';
        return 'border-zinc-200 bg-zinc-50 text-zinc-600';
    }

    public modelInternalText(item: any): string {
        return `${item?.family_label || '-'} · ${item?.source || '-'} · ${item?.model_id || '-'}`;
    }

    public setModelManagerMode(mode: string) {
        this.modelManagerMode = String(mode || 'overview');
        this.service.render();
    }

    public modelManagerModeClass(mode: string): string {
        return this.modelManagerMode === mode
            ? 'border-zinc-900 bg-zinc-900 text-white shadow-sm'
            : 'border-zinc-200 bg-white text-zinc-600 hover:bg-zinc-50';
    }

    private pct(value: any, digits: number = 1): string {
        const n = Number(value);
        return Number.isFinite(n) && n > 0 ? `${(n * 100).toFixed(digits)}%` : '-';
    }

    private modelFamily(item: any): string {
        return String(item?.family || '').trim();
    }

    private runtimeCompositionRows(): any[] {
        return Array.isArray(this.registry?.runtime_composition?.families) ? this.registry.runtime_composition.families : [];
    }

    private isRuntimeSelectedItem(item: any): boolean {
        const modelId = String(item?.model_id || '').trim();
        const family = this.modelFamily(item);
        if (!modelId) return false;
        return this.runtimeCompositionRows().some((row: any) => {
            if (String(row?.family || '').trim() !== family) return false;
            return String(row?.selected_model_id || '').trim() === modelId || (String(row?.effective_model_id || '').trim() === modelId && !!row?.overridden);
        });
    }

    private isAppliedArchiveItem(item: any): boolean {
        const source = String(item?.source || '').toLowerCase();
        return item?.active === true || source === 'active' || source === 'custom-final' || this.isRuntimeSelectedItem(item);
    }

    private findAppliedItemByFamily(family: string): any {
        const rows = this.allItems().filter((item: any) => this.modelFamily(item) === family && this.isAppliedArchiveItem(item));
        return this.pipelineSortedItems(rows)[0] || {};
    }

    private pipelineFamilyIndex(item: any): number {
        const index = this.pipelineFamilyOrder.indexOf(this.modelFamily(item));
        return index >= 0 ? index : 999;
    }

    private pipelineSortedItems(rows: any[]): any[] {
        return [...rows].sort((a: any, b: any) => {
            const priority = this.pipelineFamilyIndex(a) - this.pipelineFamilyIndex(b);
            if (priority !== 0) return priority;
            const active = Number(!!b?.active || b?.source === 'active') - Number(!!a?.active || a?.source === 'active');
            if (active !== 0) return active;
            return String(a?.label || a?.model_id || '').localeCompare(String(b?.label || b?.model_id || ''));
        });
    }

    public activeModelItems(): any[] {
        const rows = this.allItems().filter((item: any) => {
            const family = this.modelFamily(item);
            return family !== 'rf-dual' && (item?.source === 'active' || item?.source === 'custom-final' || item?.active === true);
        });
        return this.pipelineSortedItems(rows).slice(0, 6);
    }

    public dashboardTrainingItems(): any[] {
        return Array.isArray(this.registry?.training_dashboard?.items) ? this.registry.training_dashboard.items : [];
    }

    private trainingStatus(item: any): string {
        return String(item?.status || item?.stage || '').trim().toLowerCase();
    }

    private trainingItemStageTone(item: any): string {
        const status = this.trainingStatus(item);
        if (status === 'failed') return 'problem';
        if (item?.missing || ['blocked', 'stale', 'stopping', 'deferred', 'preparing', 'running-command'].includes(status)) return 'review';
        if (status === 'running') return 'running';
        if (status === 'completed') return 'done';
        return 'waiting';
    }

    public trainingRunningCount(): number {
        return this.dashboardTrainingItems().filter((item: any) => this.trainingItemStageTone(item) === 'running').length;
    }

    public trainingIssueCount(): number {
        return this.dashboardTrainingItems().filter((item: any) => ['review', 'problem'].includes(this.trainingItemStageTone(item))).length;
    }

    public trainingOtherCount(): number {
        return Math.max(0, this.dashboardTrainingItems().length - this.trainingRunningCount() - this.trainingIssueCount());
    }

    private parseTimestampMs(value: any): number {
        const raw = String(value || '').trim();
        if (!raw) return 0;
        const normalized = raw.includes('T') ? raw : raw.replace(' ', 'T');
        const ms = Date.parse(normalized);
        return Number.isFinite(ms) ? ms : 0;
    }

    private latestTrainingUpdateMs(): number {
        const itemTimes = this.dashboardTrainingItems().map((item: any) => Math.max(
            this.parseTimestampMs(item?.updated_at),
            this.parseTimestampMs(item?.finished_at),
            this.parseTimestampMs(item?.created_at),
            this.parseTimestampMs(item?.applied_at),
        ));
        const latestItemTime = Math.max(0, ...itemTimes);
        return latestItemTime || this.parseTimestampMs(this.registry?.updated_at);
    }

    public backgroundLearningRecentUpdateText(): string {
        const latest = this.latestTrainingUpdateMs();
        if (!latest) return '업데이트 기록 없음';
        const diffSec = Math.max(0, Math.floor((Date.now() - latest) / 1000));
        if (diffSec < 60) return '방금 전';
        const diffMin = Math.floor(diffSec / 60);
        if (diffMin < 60) return `${diffMin}분 전`;
        const diffHour = Math.floor(diffMin / 60);
        if (diffHour < 24) return `${diffHour}시간 전`;
        return `${Math.floor(diffHour / 24)}일 전`;
    }

    public backgroundLearningIndicators(): any[] {
        const feedbackActive = !!this.registry;
        const total = Number(this.registry?.training_dashboard?.total_count || this.dashboardTrainingItems().length || 0);
        const running = this.trainingRunningCount();
        const issue = this.trainingIssueCount();
        const activityValue = running > 0 ? '학습 중' : (issue > 0 ? '확인 필요' : '쉬는 중');
        const activityTone = running > 0 ? 'emerald' : (issue > 0 ? 'amber' : 'zinc');
        return [
            {
                label: '사용자 수정 반영',
                value: feedbackActive ? '켜짐' : '확인 필요',
                note: '틀린 결과를 고치면 다음 학습 자료로 쌓입니다.',
                cardClass: feedbackActive ? 'border-emerald-200 bg-white' : 'border-amber-200 bg-white',
                dotClass: feedbackActive ? 'bg-emerald-500' : 'bg-amber-500',
                valueClass: feedbackActive ? 'text-emerald-700' : 'text-amber-700',
            },
            {
                label: '지금 학습 작업',
                value: activityValue,
                note: `실행 중 ${running}개 · 확인 필요 ${issue}개`,
                cardClass: activityTone === 'emerald' ? 'border-emerald-200 bg-white' : (activityTone === 'amber' ? 'border-amber-200 bg-white' : 'border-zinc-200 bg-white'),
                dotClass: activityTone === 'emerald' ? 'bg-emerald-500' : (activityTone === 'amber' ? 'bg-amber-500' : 'bg-zinc-400'),
                valueClass: activityTone === 'emerald' ? 'text-emerald-700' : (activityTone === 'amber' ? 'text-amber-700' : 'text-zinc-700'),
            },
            {
                label: '최근 상태 확인',
                value: this.backgroundLearningRecentUpdateText(),
                note: `전체 학습 목록 ${total}개 기준입니다.`,
                cardClass: 'border-sky-200 bg-white',
                dotClass: 'bg-sky-500',
                valueClass: 'text-sky-700',
            },
        ];
    }

    public friendlyTrainingItems(): any[] {
        const rows = this.dashboardTrainingItems();
        const running = rows.filter((item: any) => ['queued', 'running'].includes(String(item?.stage || item?.status || '')));
        const important = rows.filter((item: any) => ['aihub82', 'aihub173', 'xg-posture'].includes(String(item?.name || item?.key || '')));
        return Array.from(new Map([...running, ...important, ...rows].map((item: any) => [String(item?.name || item?.key || item?.label || Math.random()), item])).values()).slice(0, 5);
    }

    public trainingItemTitle(item: any): string {
        return String(item?.label || item?.name || item?.key || '학습 상태');
    }

    public trainingItemStageLabel(item: any): string {
        const tone = this.trainingItemStageTone(item);
        if (tone === 'running') return '실행 중';
        if (tone === 'review') return '확인 필요';
        if (tone === 'problem') return '문제';
        if (tone === 'done') return '완료';
        return '대기';
    }

    public trainingItemStageClass(item: any): string {
        const tone = this.trainingItemStageTone(item);
        if (tone === 'running') return 'bg-emerald-50 text-emerald-700 border-emerald-200';
        if (tone === 'review') return 'bg-amber-50 text-amber-700 border-amber-200';
        if (tone === 'problem') return 'bg-rose-50 text-rose-700 border-rose-200';
        return 'bg-zinc-50 text-zinc-600 border-zinc-200';
    }

    public trainingItemMetricText(item: any): string {
        const macro = Number(item?.active_macro_f1 || item?.best_macro_f1 || item?.candidate_macro_f1 || item?.macro_f1 || 0);
        const acc = Number(item?.active_accuracy || item?.candidate_accuracy || item?.accuracy || 0);
        const bits = [];
        if (macro > 0) bits.push(`F1 ${this.pct(macro)}`);
        if (acc > 0) bits.push(`Acc ${this.pct(acc)}`);
        return bits.join(' · ') || String(item?.message || item?.latest_log || '-');
    }

    public trainingItemVersionText(item: any): string {
        return String(item?.training_version_text || item?.candidate_version_text || item?.active_version_text || item?.version_text || '-');
    }

    public trainingItemEtaText(item: any): string {
        return String(item?.eta_text || item?.eta || '-');
    }

    public trainingItemProgressPercent(item: any): number {
        const progress = Number(item?.progress || 0);
        if (Number.isFinite(progress) && progress > 0) return Math.max(2, Math.min(100, Math.round(progress * 100)));
        const percent = Number(item?.download_progress_percent || item?.progress_percent || 0);
        if (Number.isFinite(percent) && percent > 0) return Math.max(2, Math.min(100, Math.round(percent)));
        return ['running', 'queued'].includes(String(item?.stage || item?.status || '')) ? 6 : 0;
    }

    public modelOverviewCards(): any[] {
        const facial = this.registry?.training_dashboard?.facial_bottleneck?.active || {};
        const running = this.trainingRunningCount();
        return [
            {
                label: '현재 운영 조합',
                value: this.activeRuntimeTitle(),
                note: this.activeRuntimeMetricText(),
                subnote: this.activeRuntimeModuleText(),
                tone: 'emerald',
            },
            {
                label: '표정 보조 모델',
                value: this.pct(facial?.macro_f1 || this.findModelMetric('facial-aihub82', 'macro_f1')),
                note: '괜찮음/불편함 표정 구분을 점검 중',
                tone: 'amber',
            },
            {
                label: '백그라운드 학습',
                value: `실제 실행 중 ${running}개`,
                note: `${this.trainingIssueCount()}개 확인 필요 · ${Number(this.registry?.training_dashboard?.total_count || 0)}개 목록 기준`,
                tone: running > 0 ? 'sky' : 'zinc',
            },
            {
                label: '관리 모델',
                value: `${this.allItems().length}개`,
                note: `${this.deletableCount()}개 정리 가능`,
                tone: 'violet',
            },
        ];
    }

    public overviewCardClass(card: any): string {
        const tone = String(card?.tone || 'zinc');
        if (tone === 'emerald') return 'border-emerald-200 bg-emerald-50 text-emerald-950';
        if (tone === 'amber') return 'border-amber-200 bg-amber-50 text-amber-950';
        if (tone === 'sky') return 'border-sky-200 bg-sky-50 text-sky-950';
        if (tone === 'violet') return 'border-violet-200 bg-violet-50 text-violet-950';
        return 'border-zinc-200 bg-white text-zinc-950';
    }

    public facialBottleneckLines(): string[] {
        const report = this.registry?.training_dashboard?.facial_bottleneck || {};
        const lines: string[] = [];
        const active = report?.active || {};
        if (active?.macro_f1) lines.push(`현재 표정 판단 정확도는 약 ${this.pct(active.macro_f1)}입니다.`);
        const confusions = Array.isArray(report?.recurring_confusions) ? report.recurring_confusions : [];
        for (const item of confusions.slice(0, 2)) {
            const truth = String(item?.truth || '');
            const pred = String(item?.pred || '');
            const rate = `${(Number(item?.mean_rate || 0) * 100).toFixed(1)}%`;
            if (truth === 'non_distress' && pred === 'distress') {
                lines.push(`괜찮은 표정을 불편한 표정으로 본 경우가 최근 평균 ${rate}입니다.`);
            } else if (truth === 'distress' && pred === 'non_distress') {
                lines.push(`불편한 표정을 괜찮은 표정으로 본 경우가 최근 평균 ${rate}입니다.`);
            } else {
                lines.push(`서로 헷갈린 표정이 최근 평균 ${rate}입니다.`);
            }
        }
        const actions = Array.isArray(report?.next_actions) ? report.next_actions : [];
        if (actions[0]) lines.push('반복 학습만 더 하기보다 헷갈리는 얼굴 샘플을 따로 모아 보강해야 합니다.');
        return lines.length ? lines : ['표정 모델 점검 내용을 불러오는 중입니다.'];
    }

    private findModelMetric(key: string, metric: string): number {
        const item = this.allItems().find((row: any) => String(row?.family || row?.key || '') === key || String(row?.model_id || '').includes(key));
        return Number(item?.metrics?.[metric] || item?.metrics?.f1 || item?.metrics?.macro_f1 || 0);
    }

    public visibleItems(): any[] {
        let rows = this.allItems();
        if (this.familyFilter !== 'all') {
            rows = rows.filter((item: any) => String(item?.family || '') === this.familyFilter);
        }
        if (this.showDeleteOnly) {
            rows = rows.filter((item: any) => item?.deletable !== false);
        }
        return rows;
    }

    public comparisonRows(): any[] {
        const rows = this.comparisonCandidateRows();
        const selected = rows.filter((item: any) => this.isCompareSelected(item));
        return selected.length > 0 ? this.sortComparisonRows(selected) : rows.slice(0, 6);
    }

    public comparisonCandidateRows(): any[] {
        let rows = Array.isArray(this.registry?.comparison?.rows) ? this.registry.comparison.rows : [];
        if (this.familyFilter !== 'all') {
            rows = rows.filter((item: any) => String(item?.family || '') === this.familyFilter);
        }
        return this.sortComparisonRows(rows);
    }

    public comparisonSelectOptions(): any[] {
        return this.comparisonCandidateRows();
    }

    public comparisonOptionLabel(row: any): string {
        const name = this.comparisonDisplayName(row);
        const status = this.comparisonStatusText(row);
        const version = String(row?.display_version || row?.version_badge || '').trim();
        const metric = this.metricText(row);
        return [name, status, version, metric].filter(Boolean).join(' · ');
    }

    private comparisonRowById(modelId: string): any {
        const id = String(modelId || '');
        if (!id) return {};
        return this.comparisonCandidateRows().find((row: any) => String(row?.model_id || '') === id) || {};
    }

    public comparisonLeftRow(): any {
        return this.comparisonRowById(this.leftComparisonModelId);
    }

    public comparisonRightRow(): any {
        return this.comparisonRowById(this.rightComparisonModelId);
    }

    public setComparisonModel(side: string, modelId: string) {
        if (side === 'left') {
            this.leftComparisonModelId = String(modelId || '');
        } else {
            this.rightComparisonModelId = String(modelId || '');
        }
        this.service.render();
    }

    public canCompareSelectedModels(): boolean {
        const left = this.comparisonLeftRow();
        const right = this.comparisonRightRow();
        return !!left?.model_id && !!right?.model_id && !this.sameComparisonRow(left, right);
    }

    public comparisonSelectionNotice(): string {
        if (this.comparisonSelectOptions().length === 0) return '비교 가능한 모델 성능 수치가 없습니다.';
        const left = this.comparisonLeftRow();
        const right = this.comparisonRightRow();
        if (!left?.model_id && !right?.model_id) return '왼쪽과 오른쪽에 비교할 모델을 선택하세요.';
        if (!left?.model_id) return '왼쪽 모델을 선택하면 비교표가 표시됩니다.';
        if (!right?.model_id) return '오른쪽 모델을 선택하면 비교표가 표시됩니다.';
        if (this.sameComparisonRow(left, right)) return '서로 다른 두 모델을 선택하세요.';
        return '';
    }

    private sortComparisonRows(rows: any[]): any[] {
        return [...rows].sort((a: any, b: any) => {
            const metricDiff = this.metricValue(b) - this.metricValue(a);
            if (metricDiff !== 0) return metricDiff;
            const activeDiff = Number(this.isCurrentComparisonRow(b)) - Number(this.isCurrentComparisonRow(a));
            if (activeDiff !== 0) return activeDiff;
            return this.comparisonDisplayName(a).localeCompare(this.comparisonDisplayName(b));
        });
    }

    private isCurrentComparisonRow(row: any): boolean {
        const source = String(row?.source || '').toLowerCase();
        return !!row?.active || source === 'active';
    }

    public comparisonDisplayName(row: any): string {
        return String(row?.comparison_label || row?.display_name || row?.label || row?.model_id || '-');
    }

    public comparisonMetricLabel(metric?: string): string {
        const key = String(metric || this.compareMetric || 'f1');
        if (key === 'accuracy') return '전체 정확도';
        if (key === 'recall') return '놓치지 않음';
        if (key === 'precision') return '정확히 맞힘';
        if (key === 'map') return '환경 위험 검출 mAP';
        if (key === 'risk_map_agreement') return '공간 위험도 맵 일치도';
        return '종합 점수';
    }

    public comparisonMetricHelp(): string {
        if (this.compareMetric === 'recall') return '낙상 사례를 놓치지 않는 정도입니다.';
        if (this.compareMetric === 'precision') return '낙상이라고 판단한 결과가 맞은 정도입니다.';
        if (this.compareMetric === 'accuracy') return '전체 판단이 맞은 비율입니다.';
        if (this.compareMetric === 'map') return '관절점이나 환경 위험요인의 위치를 검출한 평균 정밀도입니다.';
        if (this.compareMetric === 'risk_map_agreement') return '예측 공간 위험도 맵이 기준 맵과 일치하는 정도입니다.';
        return '전체 균형을 보는 대표 점수입니다.';
    }

    public comparisonWinnerRow(): any {
        return this.comparisonCandidateRows()[0] || {};
    }

    public comparisonCurrentRow(): any {
        return this.comparisonLeftRow();
    }

    public comparisonReadableSummary(): string {
        const best = this.comparisonWinnerRow();
        const current = this.comparisonCurrentRow();
        if (!best?.model_id) return '비교 가능한 성능 수치를 불러오는 중입니다.';
        if (current?.model_id && this.sameComparisonRow(best, current)) {
            return `현재 운영 모델이 ${this.comparisonMetricLabel()} 기준으로 가장 높습니다.`;
        }
        if (current?.model_id) {
            const diff = Math.max(0, (this.metricValue(best) - this.metricValue(current)) * 100);
            return `${this.comparisonDisplayName(best)}가 현재 운영 모델보다 ${diff.toFixed(1)}점 높습니다.`;
        }
        return `${this.comparisonDisplayName(best)}가 현재 필터에서 가장 높은 모델입니다.`;
    }

    public comparisonSummaryCards(): any[] {
        const best = this.comparisonWinnerRow();
        const current = this.comparisonCurrentRow();
        const selected = this.selectedComparisonRow();
        return [
            {
                label: '추천',
                value: best?.model_id ? this.comparisonDisplayName(best) : '추천 없음',
                score: best?.model_id ? this.metricText(best) : '-',
                note: best?.model_id ? '현재 기준에서 가장 높은 점수' : '비교 수치 없음',
                tone: 'emerald',
                row: best,
            },
            {
                label: '현재 운영',
                value: current?.model_id ? this.comparisonDisplayName(current) : '운영 표시 없음',
                score: current?.model_id ? this.metricText(current) : '-',
                note: current?.model_id ? this.comparisonRelativeToBestText(current) : '운영 모델 표시가 없습니다.',
                tone: 'sky',
                row: current,
            },
            {
                label: '보고 있는 모델',
                value: selected?.model_id ? this.comparisonDisplayName(selected) : '모델 선택 필요',
                score: selected?.model_id ? this.metricText(selected) : '-',
                note: selected?.model_id ? this.comparisonRelativeToBestText(selected) : '아래 목록에서 모델을 고르세요.',
                tone: 'amber',
                row: selected,
            },
        ];
    }

    public comparisonSummaryCardClass(card: any): string {
        const tone = String(card?.tone || 'zinc');
        if (tone === 'emerald') return 'cursor-pointer border-emerald-200 bg-emerald-50 text-emerald-950';
        if (tone === 'sky') return 'cursor-pointer border-sky-200 bg-sky-50 text-sky-950';
        if (tone === 'amber') return 'cursor-pointer border-amber-200 bg-amber-50 text-amber-950';
        return 'border-zinc-200 bg-white text-zinc-950';
    }

    public comparisonRelativeToBestText(row: any): string {
        const best = this.comparisonWinnerRow();
        if (!row?.model_id || !best?.model_id) return '비교 기준 없음';
        if (this.sameComparisonRow(row, best)) return '추천과 같은 모델입니다.';
        const diff = Math.max(0, (this.metricValue(best) - this.metricValue(row)) * 100);
        return `추천보다 ${diff.toFixed(1)}점 낮음`;
    }

    public comparisonRowSubtitle(row: any): string {
        const family = String(row?.family_label || '모델 종류 없음');
        const version = String(row?.display_version || row?.version_badge || '-');
        return `${family} · ${this.comparisonStatusText(row)} · ${version}`;
    }

    public comparisonStatusText(row: any): string {
        const source = String(row?.source || '').toLowerCase();
        if (this.isCurrentComparisonRow(row)) return '현재 운영';
        if (source === 'custom-final') return '최종 조합';
        if (source === 'candidate') return '학습 후보';
        if (source === 'uploaded') return '직접 등록';
        return source || '상태 없음';
    }

    public comparisonStatusClass(row: any): string {
        const source = String(row?.source || '').toLowerCase();
        if (this.isCurrentComparisonRow(row)) return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (source === 'custom-final') return 'border-indigo-200 bg-indigo-50 text-indigo-700';
        if (source === 'candidate') return 'border-amber-200 bg-amber-50 text-amber-700';
        if (source === 'uploaded') return 'border-sky-200 bg-sky-50 text-sky-700';
        return 'border-zinc-200 bg-zinc-50 text-zinc-600';
    }

    public comparisonRank(row: any): number {
        const id = String(row?.model_id || '');
        const index = this.comparisonCandidateRows().findIndex((item: any) => String(item?.model_id || '') === id);
        return index >= 0 ? index + 1 : 0;
    }

    public comparisonSampleText(row: any): string {
        const n = Number(row?.sample_count || row?.metrics?.sample_count || row?.summary?.sample_count || 0);
        return n > 0 ? `${n.toLocaleString()}건` : this.comparisonMetricLabel();
    }

    private sameComparisonRow(a: any, b: any): boolean {
        return !!a?.model_id && String(a.model_id) === String(b?.model_id || '');
    }

    private syncComparisonSelection() {
        const rows = this.comparisonCandidateRows();
        const validIds = new Set(rows.map((row: any) => String(row?.model_id || '')));
        if (!validIds.has(String(this.leftComparisonModelId || ''))) this.leftComparisonModelId = '';
        if (!validIds.has(String(this.rightComparisonModelId || ''))) this.rightComparisonModelId = '';
        this.selectedComparisonIds = this.selectedComparisonIds.filter(id => validIds.has(String(id)));
        if (!validIds.has(String(this.selectedModelId || ''))) this.selectedModelId = '';
    }

    public comparisonSelectedCount(): number {
        return this.comparisonCandidateRows().filter((row: any) => this.isCompareSelected(row)).length;
    }

    public metricValue(row: any, metric?: string): number {
        const key = metric || this.compareMetric || 'f1';
        const value = Number(row?.[key] ?? row?.metrics?.[key] ?? 0);
        return Number.isFinite(value) ? value : 0;
    }

    public metricText(row: any, metric?: string): string {
        const value = this.metricValue(row, metric);
        return value > 0 ? `${(value * 100).toFixed(1)}%` : '-';
    }

    public metricBarWidth(row: any): string {
        const rows = this.comparisonRows();
        const best = Math.max(...rows.map((item: any) => this.metricValue(item)), 0.01);
        return `${Math.max(4, Math.round((this.metricValue(row) / best) * 100))}%`;
    }

    public selectComparisonRow(row: any) {
        if (!row?.model_id) return;
        this.selectedModelId = String(row?.model_id || '');
        this.service.render();
    }

    public toggleCompareRow(row: any) {
        const id = String(row?.model_id || '');
        if (!id || !this.comparisonCategoryRows().some((item: any) => String(item?.model_id || '') === id)) return;
        if (this.selectedComparisonIds.includes(id)) {
            this.selectedComparisonIds = this.selectedComparisonIds.filter(item => item !== id);
        } else {
            if (this.selectedComparisonIds.length >= 4) {
                this.uploadMessage = '모델 비교는 최대 4개까지 선택할 수 있습니다.';
                this.uploadMessageType = 'error';
                this.service.render();
                return;
            }
            this.selectedComparisonIds = [...this.selectedComparisonIds, id];
        }
        this.selectedModelId = this.selectedComparisonIds[0] || this.comparisonCandidateRows()[0]?.model_id || '';
        this.service.render();
    }

    public selectBestComparisonRows() {
        this.selectedComparisonIds = this.comparisonCategoryRows().slice(0, 4).map((row: any) => String(row?.model_id || '')).filter(Boolean);
        this.selectedModelId = this.selectedComparisonIds[0] || '';
        this.service.render();
    }

    public clearComparisonSelection() {
        this.selectedComparisonIds = [];
        this.selectedModelId = '';
        this.service.render();
    }

    public selectedComparisonRow(): any {
        const rows = this.comparisonRows();
        return rows.find((row: any) => String(row?.model_id || '') === this.selectedModelId) || rows[0] || {};
    }

    public isSelected(row: any): boolean {
        return !!row?.model_id && String(row.model_id) === String(this.selectedComparisonRow()?.model_id || '');
    }

    public isCompareSelected(row: any): boolean {
        return !!row?.model_id && this.selectedComparisonIds.includes(String(row.model_id));
    }

    public versionText(item: any): string {
        const badge = String(item?.display_version || item?.version_badge || '').trim();
        if (badge && badge !== '-') return badge;
        const text = String(item?.version_text || item?.summary?.model_version || item?.summary?.version || '').trim();
        return text || '-';
    }

    public modelTitle(item: any): string {
        const family = this.modelFamily(item);
        if (family === 'static-object-filter') return `정지 사물 필터 ${this.versionText(item) === '-' ? 'v1' : this.versionText(item)}`;
        if (family === 'pose-entity-filter') return `사람/사물 판정 필터 ${this.versionText(item) === '-' ? 'v1' : this.versionText(item)}`;
        if (family === 'environment-agent') return `환경 Agent (Context) · ${this.versionText(item) === '-' ? 'MVP v1' : this.versionText(item)}`;
        if (item?.display_name) return String(item.display_name);
        const title = String(item?.label || item?.model_id || '-');
        const version = this.versionText(item);
        return version && version !== '-' && !title.includes(version) ? `${title} · ${version}` : title;
    }

    public overviewModelTitle(item: any): string {
        return String(this.overviewModelDisplayMap[this.modelFamily(item)]?.title || this.modelTitle(item));
    }

    public overviewModelSubtitle(item: any): string {
        const display = this.overviewModelDisplayMap[this.modelFamily(item)];
        if (!display) return `코드명 ${this.modelTitle(item)}`;
        if (display.fixedCode) return `코드명 ${display.fixedCode}`;
        const version = this.versionText(item);
        const suffix = version && version !== '-' ? version : String(display.fallbackVersion || '').trim();
        return `코드명 ${display.codeBase}${suffix ? ` ${suffix}` : ''}`;
    }

    public isFallDecisionModel(item: any): boolean {
        return ['rf-pipeline', 'rf-fall-v2'].includes(this.modelFamily(item));
    }

    public activeRuntimeItem(): any {
        return this.allItems().find((item: any) => this.modelFamily(item) === 'rf-dual' && item?.active === true)
            || this.allItems().find((item: any) => this.modelFamily(item) === 'rf-dual' && item?.source === 'active')
            || this.allItems().find((item: any) => this.modelFamily(item) === 'rf-dual')
            || {};
    }

    private runtimeFallOverrideFamily(): string {
        const runtimeSelection = this.registry?.runtime_selection || {};
        if (String(runtimeSelection['rf-pipeline'] || '').trim()) return 'rf-pipeline';
        if (String(runtimeSelection['rf-fall-v2'] || '').trim()) return 'rf-fall-v2';
        return '';
    }

    private activeFamilyItem(family: string): any {
        const rows = this.allItems().filter((item: any) => this.modelFamily(item) === family && !item?.missing);
        return rows.find((item: any) => item?.source === 'active' && item?.active === true)
            || rows.find((item: any) => item?.source === 'active')
            || rows.find((item: any) => item?.source === 'custom-final')
            || rows[0]
            || {};
    }

    private activeFallDecisionItem(): any {
        const runtimeSelection = this.registry?.runtime_selection || {};
        const explicitlySelectedId = String(runtimeSelection['rf-pipeline'] || runtimeSelection['rf-fall-v2'] || '').trim();
        if (explicitlySelectedId) {
            const selected = this.allItems().find((item: any) => String(item?.model_id || '') === explicitlySelectedId);
            if (selected) return selected;
        }

        const v2 = this.activeFamilyItem('rf-fall-v2');
        if (v2?.model_id) return v2;
        return this.activeFamilyItem('rf-pipeline');
    }

    private rfFallV2Item(): any {
        return this.activeFamilyItem('rf-fall-v2');
    }

    private rfPipelineItem(): any {
        return this.activeFamilyItem('rf-pipeline');
    }

    private fallDecisionModelCode(): string {
        return this.modelFamily(this.activeFallDecisionItem()) === 'rf-pipeline' ? 'RF-Pipeline' : 'RF-Fall v2';
    }

    private fallDecisionFeatureCount(): number {
        return this.fallDecisionModelCode() === 'RF-Pipeline' ? this.rfPipelineFeatures.length : this.fallFeatureCount();
    }

    private thresholdNumber(value: any, fallback: number): number {
        let raw = value;
        if (raw && typeof raw === 'object') {
            raw = raw.threshold ?? raw.value ?? raw.confirm ?? raw.score;
        }
        const parsed = Number(raw);
        return Number.isFinite(parsed) ? parsed : fallback;
    }

    private thresholdWithSensitivity(value: number): number {
        const delta = Number(this.fallSensitivity()?.threshold_delta || 0);
        const adjusted = value + (Number.isFinite(delta) ? delta : 0);
        return Math.max(0.03, Math.min(0.99, adjusted));
    }

    private rfFallV2ThresholdValues(): any {
        const effective = this.fallSensitivity()?.effective_thresholds || {};
        const summaryThresholds = this.rfFallV2Item()?.summary?.thresholds || {};
        return {
            suspect: this.thresholdNumber(effective.suspect, this.thresholdWithSensitivity(this.thresholdNumber(summaryThresholds.suspect, 0.335))),
            confirm: this.thresholdNumber(effective.confirm, this.thresholdWithSensitivity(this.thresholdNumber(summaryThresholds.confirm, 0.455))),
            high: this.thresholdNumber(effective.high, this.thresholdWithSensitivity(this.thresholdNumber(summaryThresholds.high, 0.720))),
            bestF1: this.thresholdNumber(summaryThresholds.best_f1, 0.465),
        };
    }

    private rfPipelineThresholdValues(): any {
        const summary = this.rfPipelineItem()?.summary || {};
        const tuned = summary?.tuned_thresholds || {};
        const bestConfig = summary?.best_config || {};
        const baseConfirm = this.thresholdNumber(tuned.confirm ?? bestConfig.threshold, 0.465);
        const baseSuspect = this.thresholdNumber(tuned.suspect, Math.max(0.30, baseConfirm - 0.15));
        const baseHigh = this.thresholdNumber(tuned.high, Math.max(0.75, baseConfirm + 0.15));
        return {
            suspect: this.thresholdWithSensitivity(baseSuspect),
            confirm: this.thresholdWithSensitivity(baseConfirm),
            high: this.thresholdWithSensitivity(baseHigh),
        };
    }

    private activeFallThresholdValues(): any {
        return this.fallDecisionModelCode() === 'RF-Pipeline'
            ? this.rfPipelineThresholdValues()
            : this.rfFallV2ThresholdValues();
    }

    public activeRuntimeTitle(): string {
        const item = this.activeRuntimeItem();
        return item?.model_id ? this.modelTitle(item) : 'RF-Dual 통합 조합';
    }

    public activeRuntimeMetricText(): string {
        const runtimeMetrics = this.activeRuntimeItem()?.metrics || {};
        const metrics = Object.keys(runtimeMetrics).length > 0 ? runtimeMetrics : (this.activeFallDecisionItem()?.metrics || {});
        const f1 = Number(metrics.f1 || metrics.macro_f1 || 0);
        const recall = Number(metrics.recall || 0);
        return `현재 선택 모델 메타데이터: F1 ${this.pct(f1)} · Recall ${this.pct(recall)}`;
    }

    public activeRuntimeModuleText(): string {
        const item = this.activeFallDecisionItem();
        const code = this.fallDecisionModelCode();
        if (!item?.model_id) return `현재 기본 경로: ${code}`;
        const override = this.runtimeFallOverrideFamily();
        return override
            ? `현재 명시 선택: ${this.overviewModelSubtitle(item).replace(/^코드명\s*/, '')}`
            : `현재 기본 판단기: ${this.overviewModelSubtitle(item).replace(/^코드명\s*/, '')}`;
    }

    public fallPipelineFeatures(): any[] {
        return this.rfPipelineFeatures;
    }

    public fallFeatureGroups(): any[] {
        return this.rfFallV2FeatureGroups;
    }

    public fallFeatureCount(): number {
        return this.rfFallV2FeatureGroups.reduce((count: number, group: any) => count + group.features.length, 0);
    }

    public fallFeatureSummaryText(): string {
        return '65개는 65가지 행동명이 아니라, 사람 검출 품질·위치 상자 변화·17개 관절점의 가시성과 자세를 시간 흐름으로 요약한 RF-Fall v2 전용 숫자 입력값입니다.';
    }

    public fallPipelineFeatureSummaryText(): string {
        return 'RF-Pipeline은 bbox 중심·높이·가로세로비·프레임 간 변화만 요약한 13개 입력값을 사용하며, 관절점 기반 65개 계약과는 별도입니다.';
    }

    public overviewModelHelpText(item: any): string {
        const family = this.modelFamily(item);
        if (family === 'rf-pipeline') return 'RF-Dual이 먼저 계산하는 13-feature 낙상 모델이며, 명시 선택 또는 RF-Fall v2 불가·오류 시 최종 fallback으로 사용합니다.';
        if (family === 'rf-fall-v2') return '준비되어 있고 RF-Pipeline 명시 선택이 없으면 RF-Dual의 기본 최종 낙상 확률을 만드는 65-feature 모델입니다.';
        if (family === 'environment-agent') return '장애물·저조도·막힌 동선 3개 MVP 이벤트를 RiskVector로 표준화하며, 실제 객체 검출 학습과 운영 연결 전에는 적용되지 않습니다.';
        if (family === 'static-object-filter') {
            return this.isFilterOperationallyValidated(item)
                ? '정지 사물 필터 v1은 최종 출력 직전에 장시간 정지 사물 오검출을 걸러냅니다.'
                : '보유 실제 사람 자료에서 오제외가 없는지 확인하기 전까지 운영 적용이 차단됩니다.';
        }
        if (family === 'pose-entity-filter') return '사람/사물 판정 필터 v1은 P2 같은 희소·저신뢰 후보를 행동 분석 전에 사람·사물·확인 필요로 구분합니다.';
        return '';
    }

    private filterValidationGate(item: any): any {
        return item?.validation_gate || {};
    }

    public isFilterOperationallyValidated(item: any): boolean {
        if (!this.isFilterArchiveItem(item)) return true;
        const decision = this.filterUsageDecision(item);
        if (Object.keys(decision).length > 0) return decision?.apply_available === true;
        return this.filterValidationGate(item)?.ready === true && !this.isFilterValidationRunning(item);
    }

    public filterValidationText(item: any): string {
        if (!this.isFilterArchiveItem(item)) return '-';
        if (this.modelFamily(item) === 'pose-entity-filter') {
            const gate = this.filterValidationGate(item);
            const version = String(gate?.version || item?.display_version || 'v1');
            return gate?.ready === true
                ? `보유 데이터 검증 완료 · ${version} · 사람 ${Number(gate?.person_tracks || 0).toLocaleString()}트랙 오제외 0건 · P2 사물`
                : gate?.message || '사람/사물 판정 필터 v1 검증 필요';
        }
        const decision = this.filterUsageDecision(item);
        if (decision?.status && decision.status !== 'validating') {
            return `${decision.label || '검증 결과'} · ${decision.comment || ''}`.replace(/\s+·\s*$/, '');
        }
        const gate = this.filterValidationGate(item);
        const required = Number(gate?.required_replay_samples || 411);
        const actual = Number(gate?.actual_replay_samples || 0);
        const excluded = Number(gate?.critical_false_exclusions || 0);
        if (gate?.ready === true) return `사람 보호 검증 완료 · ${actual.toLocaleString()}건 · 오제외 ${excluded.toLocaleString()}건`;
        return `${actual.toLocaleString()} / ${required.toLocaleString()}건 · ${gate?.message || '사람 보호 검증 대기'}`;
    }

    public filterCollectionText(item: any): string {
        if (this.modelFamily(item) === 'pose-entity-filter') {
            return '사람 411건·540트랙 + P2 사물 1건 검증 · 일반 사물 정답 20건 확보 후 재검증 필요';
        }
        const intake = item?.validation_intake || {};
        const staticCount = Number(intake?.static_object_false_positive_count || 0);
        const personCount = Number(intake?.protected_true_person_count || 0);
        return `운영 선행 조건 아님 · 사물 오검출 ${staticCount.toLocaleString()}건 · 실제 사람 ${personCount.toLocaleString()}건 · 운영 중 효과 모니터링`;
    }

    public itemMetricText(item: any): string {
        if (this.isEnvironmentAgentItem(item)) {
            const map = Number(item?.metrics?.map || 0);
            const agreement = Number(item?.metrics?.risk_map_agreement || 0);
            if (map > 0 || agreement > 0) {
                return [map > 0 ? `mAP ${this.pct(map)}` : '', agreement > 0 ? `위험도 맵 ${this.pct(agreement)}` : ''].filter(Boolean).join(' · ');
            }
            return this.environmentValidationTargetText(item);
        }
        if (this.isFilterArchiveItem(item) && !this.isFilterOperationallyValidated(item)) {
            const gate = this.filterValidationGate(item);
            const retention = Number(item?.metrics?.true_positive_retention_rate || item?.metrics?.recall || 0);
            const excluded = Number(gate?.critical_false_exclusions || 0);
            if (Number(gate?.actual_replay_samples || 0) >= Number(gate?.required_replay_samples || 411)) {
                return `사람 유지 ${this.pct(retention)} · 오제외 ${excluded.toLocaleString()}건 · 운영 적용 차단`;
            }
            return 'AI-Hub 사람 보호 검증 대기 · 운영 적용 차단';
        }
        const metrics = item?.metrics || {};
        if (this.isFilterArchiveItem(item)) {
            if (this.modelFamily(item) === 'pose-entity-filter') {
                const gate = this.filterValidationGate(item);
                return `사람 유지 ${this.pct(Number(gate?.true_person_retention_rate || 0))} · P2 ${gate?.p2_entity === 'object' ? '사물 통과' : '검증 필요'}`;
            }
            const retention = Number(metrics.true_positive_retention_rate || metrics.recall || 0);
            return retention > 0
                ? `규칙 기반 필터 · 사람 유지 ${this.pct(retention)}`
                : '규칙 기반 필터 · 사람 보호 검증 대기';
        }
        const bits = [];
        if (metrics.algorithm) bits.push(String(metrics.algorithm));
        if (Number(metrics.false_positive_reduction_rate || 0) > 0) bits.push(`오검출 감소 ${this.metricText(metrics, 'false_positive_reduction_rate')}`);
        if (Number(metrics.true_positive_retention_rate || 0) > 0) bits.push(`정탐 유지 ${this.metricText(metrics, 'true_positive_retention_rate')}`);
        if (Number(metrics.f1 || metrics.macro_f1 || 0) > 0) bits.push(`F1 ${this.metricText(metrics, metrics.f1 ? 'f1' : 'macro_f1')}`);
        if (Number(metrics.accuracy || 0) > 0) bits.push(`Acc ${this.metricText(metrics, 'accuracy')}`);
        if (Number(metrics.recall || 0) > 0) bits.push(`Recall ${this.metricText(metrics, 'recall')}`);
        return bits.join(' · ') || '성능 수치 없음';
    }

    public itemSampleText(item: any): string {
        if (this.isEnvironmentAgentItem(item) && String(item?.source || '').toLowerCase() === 'spec') return '학습 데이터 준비 중';
        if (this.isFilterArchiveItem(item) && !this.isFilterOperationallyValidated(item)) {
            const gate = this.filterValidationGate(item);
            return `${Number(gate?.actual_replay_samples || 0).toLocaleString()} / ${Number(gate?.required_replay_samples || 411).toLocaleString()}건`;
        }
        const n = Number(item?.metrics?.sample_count || 0);
        return n > 0 ? `${n.toLocaleString()}건` : '-';
    }

    public itemManageText(item: any): string {
        if (item?.active_reference) return '운영 참조 보호';
        if (item?.deletable !== false) return item?.source === 'candidate' ? '삭제 예약 가능' : '삭제 가능';
        if (item?.source === 'active') return '운영 보호';
        if (item?.source === 'custom-final') return '사용 중 보호';
        if (item?.source === 'candidate') return '사용 중 보호';
        return '보호됨';
    }

    public deletableCount(): number {
        return this.allItems().filter((item: any) => item?.deletable !== false).length;
    }

    public toggleDeleteOnly() {
        this.showDeleteOnly = !this.showDeleteOnly;
        this.service.render();
    }

    private syncFallSensitivity() {
        const level = Number(this.registry?.fall_sensitivity?.level ?? 50);
        this.sensitivityLevel = Number.isFinite(level) ? Math.max(0, Math.min(100, Math.round(level))) : 50;
    }

    public fallSensitivity(): any {
        return this.registry?.fall_sensitivity || {};
    }

    public sensitivityLabel(): string {
        return String(this.fallSensitivity()?.label || '균형');
    }

    private thresholdPercent(value: any): string {
        const n = Number(value);
        return Number.isFinite(n) && n > 0 ? `${(n * 100).toFixed(1)}%` : '-';
    }

    public sensitivityHelpText(): string {
        if (this.sensitivityLevel >= 75) return '민감: 작은 낙상 가능성도 더 빨리 잡습니다.';
        if (this.sensitivityLevel <= 25) return '보수: 오탐을 줄이는 방향으로 판정합니다.';
        return '균형: 현재 검증 기준 threshold를 그대로 사용합니다.';
    }

    public async setSensitivityPreset(level: number) {
        this.sensitivityLevel = Math.max(0, Math.min(100, Math.round(Number(level) || 50)));
        await this.saveFallSensitivity();
    }

    public async saveFallSensitivity() {
        if (this.sensitivitySaving) return;
        this.sensitivitySaving = true;
        this.uploadMessage = '낙상 감도를 저장하는 중입니다.';
        this.uploadMessageType = 'info';
        await this.service.render();
        try {
            const params = new URLSearchParams();
            params.set('level', String(Math.max(0, Math.min(100, Math.round(Number(this.sensitivityLevel) || 50)))));
            params.set('enabled', 'true');
            const res = await fetch(`/wiz/api/page.models/set_fall_sensitivity?${params.toString()}`, { method: 'POST' });
            const json = await this.readJsonResponse(res);
            if (json.code === 200) {
                this.registry = json.registry || json.data?.registry || this.registry;
                if (json.fall_sensitivity && this.registry) this.registry.fall_sensitivity = json.fall_sensitivity;
                this.syncFallSensitivity();
                this.uploadMessage = `낙상 감도 저장 완료: ${this.sensitivityLabel()} ${this.sensitivityLevel}`;
                this.uploadMessageType = 'success';
            } else {
                this.uploadMessage = json.data?.message || json.message || '낙상 감도 저장 실패';
                this.uploadMessageType = 'error';
            }
        } catch (e: any) {
            this.uploadMessage = e?.message || '낙상 감도 저장 실패';
            this.uploadMessageType = 'error';
        }
        this.sensitivitySaving = false;
        await this.service.render();
    }

    public selectedFileSummary(): string {
        if (this.uploadFiles.length === 0) return '선택된 파일 없음';
        const names = this.uploadFiles.slice(0, 3).map(file => this.displayName(file)).join(', ');
        return `${this.uploadFiles.length}개 선택 · ${names}${this.uploadFiles.length > 3 ? ` 외 ${this.uploadFiles.length - 3}개` : ''}`;
    }

    public displayName(file: File): string {
        return String((file as any)?.webkitRelativePath || file.name || '파일');
    }

    public onModelFilesSelected(event: any) {
        this.uploadFiles = Array.from(event?.target?.files || []) as File[];
        this.uploadMessage = '';
        if (event?.target) event.target.value = '';
        this.service.render();
    }

    public clearUploadFiles() {
        this.uploadFiles = [];
        this.uploadDone = 0;
        this.resetUploadProgress();
        this.uploadMessage = '';
        this.service.render();
    }

    private resetUploadProgress() {
        this.uploadProgressPercent = 0;
        this.uploadBytesSent = 0;
        this.uploadBytesTotal = 0;
        this.uploadSpeedMbps = 0;
        this.uploadPhase = 'idle';
        this.uploadStartedAt = 0;
        this.uploadLastRenderAt = 0;
    }

    public uploadProgressLabel(): string {
        if (this.uploadPhase === 'checking') return '파일 전송 완료 · 서버에서 호환성 확인 중';
        return `파일 전송 중 · ${this.uploadDone + 1}/${Math.max(1, this.uploadFiles.length)}`;
    }

    public uploadSizeLabel(): string {
        const mb = (value: number) => `${(Math.max(0, value) / (1024 * 1024)).toFixed(value >= 100 * 1024 * 1024 ? 0 : 1)} MB`;
        return `${mb(this.uploadBytesSent)} / ${mb(this.uploadBytesTotal)}`;
    }

    public uploadSpeedLabel(): string {
        return this.uploadSpeedMbps > 0 ? `${this.uploadSpeedMbps.toFixed(1)} MB/s` : '속도 계산 중';
    }

    private updateUploadProgress(sent: number, total: number, forceRender: boolean = false) {
        this.uploadBytesSent = Math.max(0, Math.min(total, sent));
        this.uploadBytesTotal = Math.max(0, total);
        this.uploadProgressPercent = total > 0 ? Math.min(100, Math.round(this.uploadBytesSent / total * 100)) : 0;
        const elapsedSeconds = Math.max(0.001, (Date.now() - this.uploadStartedAt) / 1000);
        this.uploadSpeedMbps = this.uploadBytesSent > 0 ? this.uploadBytesSent / (1024 * 1024) / elapsedSeconds : 0;
        const now = Date.now();
        if (forceRender || now - this.uploadLastRenderAt >= 120) {
            this.uploadLastRenderAt = now;
            void this.service.render();
        }
    }

    private uploadModelForm(form: FormData, completedBytes: number, fileSize: number, totalBytes: number): Promise<any> {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open('POST', '/wiz/api/page.models/upload_model_asset');
            xhr.responseType = 'text';
            xhr.upload.onprogress = (event: ProgressEvent) => {
                if (!event.lengthComputable) return;
                this.uploadPhase = 'uploading';
                const fileProgress = event.total > 0 ? Math.min(1, event.loaded / event.total) : 0;
                this.updateUploadProgress(completedBytes + fileSize * fileProgress, totalBytes);
            };
            xhr.upload.onload = () => {
                this.uploadPhase = 'checking';
                this.updateUploadProgress(completedBytes + fileSize, totalBytes, true);
            };
            xhr.onerror = () => reject(new Error('네트워크 오류로 파일 전송에 실패했습니다.'));
            xhr.onabort = () => reject(new Error('파일 전송이 취소되었습니다.'));
            xhr.onload = () => {
                let json: any = {};
                try {
                    json = JSON.parse(String(xhr.responseText || '{}'));
                } catch (_) {
                    return reject(new Error(`서버 응답을 확인할 수 없습니다. (HTTP ${xhr.status})`));
                }
                if (xhr.status < 200 || xhr.status >= 300) {
                    return reject(new Error(json?.data?.message || json?.message || `등록 실패 (HTTP ${xhr.status})`));
                }
                resolve(json);
            };
            xhr.send(form);
        });
    }

    public async uploadSelectedModels() {
        if (!this.canRegisterSelectedModels() || this.uploading) return;
        this.uploading = true;
        this.uploadDone = 0;
        this.resetUploadProgress();
        this.uploadMessage = '모델 파일을 등록하는 중입니다.';
        this.uploadMessageType = 'info';
        await this.service.render();
        const importId = `manual-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        const errors: string[] = [];
        const files = [...this.uploadFiles].sort((left: File, right: File) => {
            const primary = (file: File) => /\.(pkl|joblib|pt|pth|onnx|bin)$/i.test(this.displayName(file)) ? 0 : 1;
            return primary(left) - primary(right);
        });
        const totalBytes = files.reduce((sum: number, file: File) => sum + Number(file.size || 0), 0);
        let completedBytes = 0;
        this.uploadBytesTotal = totalBytes;
        this.uploadStartedAt = Date.now();
        this.uploadPhase = 'uploading';
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            try {
                const fd = new FormData();
                fd.append('model', file);
                fd.append('family', this.uploadFamily || 'rf-fall-v2');
                fd.append('label', this.registrationModelName || importId);
                fd.append('note', this.uploadCombinedNote());
                fd.append('metadata', JSON.stringify({
                    model_id: importId,
                    relative_path: this.displayName(file),
                    bulk_index: i + 1,
                    bulk_total: files.length,
                    pose_variant_id: this.uploadFamily === 'pose-backbone' ? this.poseVariantId : undefined,
                    keypoint_schema: this.uploadFamily === 'pose-backbone' ? 'coco17' : undefined,
                    pipeline_contract_version: this.uploadFamily === 'pose-backbone' ? 'fallai-pose-v1' : undefined,
                    model_type: this.selectedAiKind,
                    model_name: this.registrationModelName,
                    model_version: this.registrationVersion,
                    framework: this.registrationFramework,
                    backbone: this.registrationBackbone,
                    developer: this.registrationDeveloper,
                    description: this.registrationDescription,
                    registration_source: this.registrationSource,
                    pose_family: this.selectedAiKind === 'pose' ? this.poseRegistrationFamily : undefined,
                    model_variant: this.selectedAiKind === 'pose' ? this.poseVariantId : this.registrationVariantId,
                    defer_registry_refresh: true,
                }));
                const json = await this.uploadModelForm(fd, completedBytes, Number(file.size || 0), totalBytes);
                if (json.code !== 200) errors.push(`${file.name}: ${json.data?.message || json.message || '등록 실패'}`);
            } catch (e: any) {
                errors.push(`${file.name}: ${e?.message || e}`);
            }
            completedBytes += Number(file.size || 0);
            this.updateUploadProgress(completedBytes, totalBytes, true);
            this.uploadDone = i + 1;
            this.uploadMessage = this.uploadDone < files.length ? `다음 파일 준비 중 ${this.uploadDone}/${files.length}` : '등록 결과를 확인하는 중입니다.';
            await this.service.render();
        }
        this.uploading = false;
        this.uploadPhase = 'idle';
        if (errors.length === 0) {
            this.lastRegisteredLabel = this.registrationModelName || importId;
            this.lastRegisteredModelId = importId;
            this.compatibilityModelId = importId;
            this.registrationStep = 4;
            this.uploadMessage = `새 모델 등록 완료: ${this.lastRegisteredLabel}`;
            this.uploadMessageType = 'success';
            this.uploadFiles = [];
            this.uploadNote = '';
        } else {
            this.uploadMessage = `일부 등록 실패: ${errors.slice(0, 2).join(' / ')}`;
            this.uploadMessageType = 'error';
        }
        await this.loadRegistry();
    }

    public async deleteModel(item: any) {
        const modelId = String(item?.model_id || '');
        if (!modelId || item?.deletable === false || this.deletingId) return;
        this.deletingId = modelId;
        this.uploadMessage = `${item?.label || modelId} 삭제 예약 중`;
        this.uploadMessageType = 'info';
        await this.service.render();
        try {
            const params = new URLSearchParams();
            params.set('model_id', modelId);
            const res = await fetch(`/wiz/api/page.models/delete_model_asset?${params.toString()}`, { method: 'POST' });
            const json = await this.readJsonResponse(res);
            const payload = this.responsePayload(json);
            if (json.code === 200) {
                this.uploadMessage = payload.delete_after ? `모델 삭제를 예약했습니다. 실제 삭제 예정: ${payload.delete_after}` : '모델 삭제를 예약했습니다.';
                this.uploadMessageType = 'success';
                await this.loadRegistry();
            } else {
                this.uploadMessage = json.data?.message || json.message || '모델 삭제 실패';
                this.uploadMessageType = 'error';
            }
        } catch (e: any) {
            this.uploadMessage = e?.message || '모델 삭제 실패';
            this.uploadMessageType = 'error';
        }
        this.deletingId = '';
        await this.service.render();
    }

    public async cancelDelete(item: any) {
        const modelId = String(item?.model_id || '');
        if (!modelId || this.cancelingDeleteId) return;
        this.cancelingDeleteId = modelId;
        this.uploadMessage = `${item?.display_name || item?.label || modelId} 삭제 예약 취소 중`;
        this.uploadMessageType = 'info';
        await this.service.render();
        try {
            const params = new URLSearchParams();
            params.set('model_id', modelId);
            const res = await fetch(`/wiz/api/page.models/cancel_model_delete?${params.toString()}`, { method: 'POST' });
            const json = await this.readJsonResponse(res);
            if (json.code === 200) {
                this.uploadMessage = '삭제 예약을 취소했습니다.';
                this.uploadMessageType = 'success';
                await this.loadRegistry();
            } else {
                this.uploadMessage = json.data?.message || json.message || '삭제 예약 취소 실패';
                this.uploadMessageType = 'error';
            }
        } catch (e: any) {
            this.uploadMessage = e?.message || '삭제 예약 취소 실패';
            this.uploadMessageType = 'error';
        }
        this.cancelingDeleteId = '';
        await this.service.render();
    }

    public trashRows(): any[] {
        return Array.isArray(this.registry?.trash) ? this.registry.trash : [];
    }

    public compositionRows(): any[] {
        return Array.isArray(this.registry?.runtime_composition?.families) ? this.registry.runtime_composition.families : [];
    }

    public runtimeBundles(): any[] {
        return Array.isArray(this.registry?.runtime_bundles) ? this.registry.runtime_bundles : [];
    }

    public compositionOptions(row: any): any[] {
        return Array.isArray(row?.options) ? row.options : [];
    }

    public runtimeOptionText(option: any): string {
        const source = option?.source ? ` · ${option.source}` : '';
        const version = option?.display_version && option.display_version !== '-' ? ` · ${option.display_version}` : '';
        const f1 = Number(option?.metric_f1 || 0) > 0 ? ` · F1 ${(Number(option.metric_f1) * 100).toFixed(1)}%` : '';
        return `${option?.display_name || option?.label || '운영 기본값'}${version}${source}${f1}`;
    }

    public async setRuntimeSelection(row: any, event: any) {
        const family = String(row?.family || '');
        if (!family || this.savingFamily) return;
        const modelId = String(event?.target?.value || '');
        this.savingFamily = family;
        this.uploadMessage = `${row?.family_label || family} 통합 조합을 저장하는 중입니다.`;
        this.uploadMessageType = 'info';
        await this.service.render();
        try {
            const params = new URLSearchParams();
            params.set('family', family);
            params.set('model_id', modelId);
            const res = await fetch(`/wiz/api/page.models/set_runtime_model_selection?${params.toString()}`, { method: 'POST' });
            const json = await this.readJsonResponse(res);
            if (json.code === 200) {
                this.uploadMessage = 'RF-Dual 통합 조합에 반영했습니다.';
                this.uploadMessageType = 'success';
                await this.loadRegistry();
            } else {
                this.uploadMessage = json.data?.message || json.message || '통합 조합 저장 실패';
                this.uploadMessageType = 'error';
            }
        } catch (e: any) {
            this.uploadMessage = e?.message || '통합 조합 저장 실패';
            this.uploadMessageType = 'error';
        }
        this.savingFamily = '';
        await this.service.render();
    }

    private currentRuntimeSelections(): any {
        const selections: any = {};
        for (const row of this.compositionRows()) {
            const family = String(row?.family || '');
            const modelId = String(row?.selected_model_id || '');
            if (family && modelId) selections[family] = modelId;
        }
        return selections;
    }

    public async saveRuntimeBundle() {
        if (this.bundleSaving) return;
        this.bundleSaving = true;
        this.uploadMessage = '현재 선택한 세부 모델 조합을 저장하는 중입니다.';
        this.uploadMessageType = 'info';
        await this.service.render();
        try {
            const params = new URLSearchParams();
            params.set('label', this.bundleLabel || '');
            params.set('selections', JSON.stringify(this.currentRuntimeSelections()));
            const res = await fetch(`/wiz/api/page.models/save_runtime_model_bundle?${params.toString()}`, { method: 'POST' });
            const json = await this.readJsonResponse(res);
            if (json.code === 200) {
                this.bundleLabel = '';
                this.uploadMessage = '선택한 모델 조합을 저장하고 적용했습니다.';
                this.uploadMessageType = 'success';
                await this.loadRegistry();
            } else {
                this.uploadMessage = json.data?.message || json.message || '모델 조합 저장 실패';
                this.uploadMessageType = 'error';
            }
        } catch (e: any) {
            this.uploadMessage = e?.message || '모델 조합 저장 실패';
            this.uploadMessageType = 'error';
        }
        this.bundleSaving = false;
        await this.service.render();
    }

    public async applyRuntimeBundle(bundle: any) {
        const bundleId = String(bundle?.bundle_id || '');
        if (!bundleId || this.applyingBundleId) return;
        this.applyingBundleId = bundleId;
        this.uploadMessage = `${bundle?.label || '모델 조합'} 적용 중입니다.`;
        this.uploadMessageType = 'info';
        await this.service.render();
        try {
            const params = new URLSearchParams();
            params.set('bundle_id', bundleId);
            const res = await fetch(`/wiz/api/page.models/apply_runtime_model_bundle?${params.toString()}`, { method: 'POST' });
            const json = await this.readJsonResponse(res);
            if (json.code === 200) {
                this.uploadMessage = '모델 조합을 적용했습니다.';
                this.uploadMessageType = 'success';
                await this.loadRegistry();
            } else {
                this.uploadMessage = json.data?.message || json.message || '모델 조합 적용 실패';
                this.uploadMessageType = 'error';
            }
        } catch (e: any) {
            this.uploadMessage = e?.message || '모델 조합 적용 실패';
            this.uploadMessageType = 'error';
        }
        this.applyingBundleId = '';
        await this.service.render();
    }

    public async deleteRuntimeBundle(bundle: any) {
        const bundleId = String(bundle?.bundle_id || '');
        if (!bundleId || this.deletingBundleId) return;
        this.deletingBundleId = bundleId;
        this.uploadMessage = `${bundle?.label || '모델 조합'} 삭제 중입니다.`;
        this.uploadMessageType = 'info';
        await this.service.render();
        try {
            const params = new URLSearchParams();
            params.set('bundle_id', bundleId);
            const res = await fetch(`/wiz/api/page.models/delete_runtime_model_bundle?${params.toString()}`, { method: 'POST' });
            const json = await this.readJsonResponse(res);
            const payload = this.responsePayload(json);
            if (json.code === 200) {
                this.uploadMessage = payload.delete_after ? `커스텀 최종 모델 삭제를 예약했습니다. 실제 삭제 예정: ${payload.delete_after}` : '커스텀 최종 모델 삭제를 예약했습니다.';
                this.uploadMessageType = 'success';
                await this.loadRegistry();
            } else {
                this.uploadMessage = json.data?.message || json.message || '모델 조합 삭제 실패';
                this.uploadMessageType = 'error';
            }
        } catch (e: any) {
            this.uploadMessage = e?.message || '모델 조합 삭제 실패';
            this.uploadMessageType = 'error';
        }
        this.deletingBundleId = '';
        await this.service.render();
    }

    public bundleSelectionText(bundle: any): string {
        const rows = Array.isArray(bundle?.selection_rows) ? bundle.selection_rows : [];
        if (rows.length === 0) return '운영 기본값 조합';
        return rows.map((row: any) => `${row.family_label}: ${row.display_version || '-'} ${row.label || ''}`.trim()).join(' / ');
    }

    public async cleanupCandidates() {
        if (this.cleanupBusy) return;
        this.cleanupBusy = true;
        this.uploadMessage = '낮은 우선순위 후보 모델 삭제 예약을 계산하는 중입니다.';
        this.uploadMessageType = 'info';
        await this.service.render();
        try {
            const params = new URLSearchParams();
            params.set('keep_per_family', '1');
            params.set('min_f1', '0.90');
            const res = await fetch(`/wiz/api/page.models/cleanup_model_candidates?${params.toString()}`, { method: 'POST' });
            const json = await this.readJsonResponse(res);
            const payload = this.responsePayload(json);
            if (json.code === 200) {
                const bad = Number(payload.low_score_count || 0);
                const extra = Number(payload.extra_count || 0);
                this.uploadMessage = `후보 정리 예약 완료: ${payload.scheduled_count || 0}개 · 저성능 ${bad}개 · 하위 후보 ${extra}개`;
                this.uploadMessageType = 'success';
                await this.loadRegistry();
            } else {
                this.uploadMessage = json.data?.message || json.message || '후보 정리 실패';
                this.uploadMessageType = 'error';
            }
        } catch (e: any) {
            this.uploadMessage = e?.message || '후보 정리 실패';
            this.uploadMessageType = 'error';
        }
        this.cleanupBusy = false;
        await this.service.render();
    }

    public sourceText(item: any): string {
        return this.statusBadgeText(item);
    }

    public badgeClass(item: any): string {
        return this.statusBadgeClass(item);
    }

    private statusBadgeTone(item: any): string {
        const status = this.trainingStatus(item);
        if (status === 'failed') return 'problem';
        if (item?.missing || ['blocked', 'stale', 'stopping', 'deferred', 'preparing'].includes(status)) return 'review';
        if (item?.active === true || item?.source === 'active') return 'active';
        return 'waiting';
    }

    public statusBadgeText(item: any): string {
        const tone = this.statusBadgeTone(item);
        if (tone === 'active') return '운영중';
        if (tone === 'review') return '재확인 필요';
        if (tone === 'problem') return '문제';
        return '대기';
    }

    public statusBadgeClass(item: any): string {
        const tone = this.statusBadgeTone(item);
        if (tone === 'active') return 'bg-emerald-50 text-emerald-700 border-emerald-200';
        if (tone === 'review') return 'bg-amber-50 text-amber-700 border-amber-200';
        if (tone === 'problem') return 'bg-rose-50 text-rose-700 border-rose-200';
        return 'bg-zinc-50 text-zinc-600 border-zinc-200';
    }

    public manageBadgeClass(item: any): string {
        if (item?.deletable !== false) return 'bg-rose-50 text-rose-700 border-rose-200';
        return 'bg-zinc-50 text-zinc-500 border-zinc-200';
    }

    public occlusionLines(): string[] {
        return Array.isArray(this.registry?.occlusion_policy?.explanation) ? this.registry.occlusion_policy.explanation : [];
    }

    public occlusionTuningPlan(): string[] {
        return Array.isArray(this.registry?.occlusion_policy?.tuning_plan) ? this.registry.occlusion_policy.tuning_plan : [];
    }

    public occlusionStatusText(): string {
        return String(this.registry?.occlusion_policy?.training_status?.message || this.registry?.occlusion_policy?.training_status?.latest_log || '상태 확인 중');
    }

    public occlusionVersionText(): string {
        const status = this.registry?.occlusion_policy?.training_status || {};
        return String(status.active_version_text || status.training_version_text || '-');
    }

    public occlusionSequenceText(): string {
        const status = this.registry?.occlusion_policy?.training_status || {};
        const sequence = Number(status.best_sequence_macro_f1 || status.sequence_macro_f1 || 0);
        const window = Number(status.best_macro_f1 || status.active_macro_f1 || 0);
        const bits = [];
        if (sequence > 0) bits.push(`Sequence F1 ${(sequence * 100).toFixed(1)}%`);
        if (window > 0) bits.push(`Window F1 ${(window * 100).toFixed(1)}%`);
        return bits.join(' · ') || '-';
    }
}

export default PageModelsComponent;